import { a as Rr, s as _r, c as Wn, b as zn, d as Lr, e as $r, f as qr, g as Hr, S as Ur, h as Wr } from "./index-B5b1KQB-.js";
import { i as Rs } from "./index-B5b1KQB-.js";
import { s as zr, u as Vr, j as p, B as W, P as i, T as ie, q as se, a as Vn, $ as Kr, I as Kn, c as ce, b as fe, W as Yn, d as Yr, S as Ot, e as gn, f as Gr } from "./index-DquFzzqx.js";
import { D as Ls, F as $s, i as qs, h as Hs, k as Us, l as Ws, g as zs } from "./index-DquFzzqx.js";
import { g as Gn, a as Qe } from "./24-C6BtDHWk.js";
import G, { forwardRef as Ee, useRef as Ce, useState as Y, useEffect as Z, cloneElement as Nt, Children as xe, isValidElement as Jn, memo as De, useLayoutEffect as Jr, useMemo as Ft, Fragment as Xr, createRef as Qr, createContext as Zr, useContext as Ze } from "react";
import Xn, { createPortal as eo, findDOMNode as to } from "react-dom";
import { c as Qn, a as Zn, b as er } from "./checklist-Cb4-KBhq.js";
import { T as tr, C as no, r as ro, d as oo, e as io, S as Pt } from "./index-CO7Yr6AY.js";
import { i as Ks, a as Ys, M as Gs, c as Js, b as Xs } from "./index-CO7Yr6AY.js";
const so = /* @__PURE__ */ Gn(zr);
var ft, mn;
function ao() {
  return mn || (mn = 1, ft = function(e) {
    var n = {};
    function r(o) {
      if (n[o]) return n[o].exports;
      var t = n[o] = { i: o, l: !1, exports: {} };
      return e[o].call(t.exports, t, t.exports, r), t.l = !0, t.exports;
    }
    return r.m = e, r.c = n, r.d = function(o, t, s) {
      r.o(o, t) || Object.defineProperty(o, t, { enumerable: !0, get: s });
    }, r.r = function(o) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
    }, r.t = function(o, t) {
      if (1 & t && (o = r(o)), 8 & t || 4 & t && typeof o == "object" && o && o.__esModule) return o;
      var s = /* @__PURE__ */ Object.create(null);
      if (r.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: o }), 2 & t && typeof o != "string") for (var a in o) r.d(s, a, (function(l) {
        return o[l];
      }).bind(null, a));
      return s;
    }, r.n = function(o) {
      var t = o && o.__esModule ? function() {
        return o.default;
      } : function() {
        return o;
      };
      return r.d(t, "a", t), t;
    }, r.o = function(o, t) {
      return Object.prototype.hasOwnProperty.call(o, t);
    }, r.p = "", r(r.s = 3);
  }([function(e, n) {
    e.exports = G;
  }, function(e, n) {
    e.exports = so;
  }, function(e, n) {
    e.exports = Xn;
  }, function(e, n, r) {
    r.r(n), r.d(n, "ModalProvider", function() {
      return y;
    }), r.d(n, "BaseModalBackground", function() {
      return s;
    });
    var o = r(1), t = r.n(o), s = t.a.div.withConfig({ displayName: "baseStyles__BaseModalBackground" })(["display:flex;position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:30;background-color:rgba(0,0,0,0.5);align-items:center;justify-content:center;"]), a = r(0), l = r.n(a), u = l.a.createContext({}), m = u.Provider, f = u.Consumer;
    function E(h, S) {
      return function(g) {
        if (Array.isArray(g)) return g;
      }(h) || function(g, O) {
        if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(g)))) {
          var v = [], A = !0, d = !1, c = void 0;
          try {
            for (var k, R = g[Symbol.iterator](); !(A = (k = R.next()).done) && (v.push(k.value), !O || v.length !== O); A = !0) ;
          } catch (_) {
            d = !0, c = _;
          } finally {
            try {
              A || R.return == null || R.return();
            } finally {
              if (d) throw c;
            }
          }
          return v;
        }
      }(h, S) || function(g, O) {
        if (g) {
          if (typeof g == "string") return w(g, O);
          var v = Object.prototype.toString.call(g).slice(8, -1);
          if (v === "Object" && g.constructor && (v = g.constructor.name), v === "Map" || v === "Set") return Array.from(v);
          if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return w(g, O);
        }
      }(h, S) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function w(h, S) {
      (S == null || S > h.length) && (S = h.length);
      for (var g = 0, O = new Array(S); g < S; g++) O[g] = h[g];
      return O;
    }
    function y(h) {
      var S = h.backgroundComponent, g = h.children, O = Object(a.useRef)(null), v = E(Object(a.useState)(null), 2), A = v[0], d = v[1], c = E(Object(a.useState)(s), 2), k = c[0], R = c[1];
      return Object(a.useEffect)(function() {
        S && R(S);
      }, [R, S]), Object(a.useEffect)(function() {
        d(O.current);
      }, [d, O]), l.a.createElement(m, { value: { modalNode: A, BackgroundComponent: k } }, g, l.a.createElement("div", { ref: O }));
    }
    var D = r(2), j = r.n(D);
    function P() {
      return (P = Object.assign || function(h) {
        for (var S = 1; S < arguments.length; S++) {
          var g = arguments[S];
          for (var O in g) Object.prototype.hasOwnProperty.call(g, O) && (h[O] = g[O]);
        }
        return h;
      }).apply(this, arguments);
    }
    function N(h, S) {
      return function(g) {
        if (Array.isArray(g)) return g;
      }(h) || function(g, O) {
        if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(g)))) {
          var v = [], A = !0, d = !1, c = void 0;
          try {
            for (var k, R = g[Symbol.iterator](); !(A = (k = R.next()).done) && (v.push(k.value), !O || v.length !== O); A = !0) ;
          } catch (_) {
            d = !0, c = _;
          } finally {
            try {
              A || R.return == null || R.return();
            } finally {
              if (d) throw c;
            }
          }
          return v;
        }
      }(h, S) || function(g, O) {
        if (g) {
          if (typeof g == "string") return M(g, O);
          var v = Object.prototype.toString.call(g).slice(8, -1);
          if (v === "Object" && g.constructor && (v = g.constructor.name), v === "Map" || v === "Set") return Array.from(v);
          if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return M(g, O);
        }
      }(h, S) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function M(h, S) {
      (S == null || S > h.length) && (S = h.length);
      for (var g = 0, O = new Array(S); g < S; g++) O[g] = h[g];
      return O;
    }
    function b(h, S) {
      if (h == null) return {};
      var g, O, v = function(d, c) {
        if (d == null) return {};
        var k, R, _ = {}, B = Object.keys(d);
        for (R = 0; R < B.length; R++) k = B[R], c.indexOf(k) >= 0 || (_[k] = d[k]);
        return _;
      }(h, S);
      if (Object.getOwnPropertySymbols) {
        var A = Object.getOwnPropertySymbols(h);
        for (O = 0; O < A.length; O++) g = A[O], S.indexOf(g) >= 0 || Object.prototype.propertyIsEnumerable.call(h, g) && (v[g] = h[g]);
      }
      return v;
    }
    function x(h) {
      var S, g = h.WrapperComponent, O = h.children, v = h.onBackgroundClick, A = h.onEscapeKeydown, d = h.allowScroll, c = h.beforeOpen, k = h.afterOpen, R = h.beforeClose, _ = h.afterClose, B = h.backgroundProps, I = h.isOpen, L = b(h, ["WrapperComponent", "children", "onBackgroundClick", "onEscapeKeydown", "allowScroll", "beforeOpen", "afterOpen", "beforeClose", "afterClose", "backgroundProps", "isOpen"]), $ = Object(a.useRef)(null), U = Object(a.useRef)(null), F = Object(a.useRef)(!1), T = N(Object(a.useState)(!1), 2), q = T[0], H = T[1], V = Object(a.useCallback)(A), K = Object(a.useCallback)(v), ne = Object(a.useCallback)(c), ae = Object(a.useCallback)(k), ge = Object(a.useCallback)(R), de = Object(a.useCallback)(_);
      function ee(te) {
        $.current === te.target && K && K(te);
      }
      return Object(a.useEffect)(function() {
        function te(le) {
          if (le) try {
            le().then(function() {
              return H(I);
            });
          } catch {
            H(I);
          }
          else H(I);
        }
        q !== I && te(I ? ne : ge);
      }, [F, q, H, I, ne, ge]), Object(a.useEffect)(function() {
        q ? ae && ae() : F.current && de && de();
      }, [F, q, ae, de]), Object(a.useEffect)(function() {
        function te(le) {
          le.key === "Escape" && V && V(le);
        }
        return q && document.addEventListener("keydown", te), function() {
          document.removeEventListener("keydown", te);
        };
      }, [q, V]), Object(a.useEffect)(function() {
        return q && !d && (U.current = document.body.style.overflow, document.body.style.overflow = "hidden"), function() {
          d || (document.body.style.overflow = U.current || "");
        };
      }, [q, d]), Object(a.useEffect)(function() {
        F.current = !0;
      }, [F]), S = g ? l.a.createElement(g, L, O) : O, l.a.createElement(f, null, function(te) {
        var le = te.modalNode, Ae = te.BackgroundComponent;
        return le && Ae && q ? j.a.createPortal(l.a.createElement(Ae, P({}, B, { onClick: ee, ref: $ }), S), le) : null;
      });
    }
    x.styled = function() {
      for (var h = arguments.length, S = new Array(h), g = 0; g < h; g++) S[g] = arguments[g];
      var O = S ? t.a.div.withConfig({ displayName: "Modal__wrap" }).apply(void 0, S) : t.a.div.withConfig({ displayName: "Modal__wrap" })();
      return function(v) {
        return l.a.createElement(x, P({ WrapperComponent: O }, v));
      };
    }, x.defaultProps = { backgroundProps: {} };
    var C = x;
    n.default = C;
  }])), ft;
}
var nr = ao();
const As = /* @__PURE__ */ Qe(nr);
function lo(e) {
  let n = 0;
  if (e.length === 0) return n;
  for (let o = 0; o < e.length; o++)
    n = e.charCodeAt(o) + ((n << 5) - n), n &= n;
  let r = "#";
  for (let o = 0; o < 3; o++) {
    const t = n >> o * 8 & 255;
    r += `00${t.toString(16)}`.substr(-2);
  }
  return r;
}
const uo = ({ size: e, name: n }) => {
  const r = n ? lo(n) : "white", o = "basic.100", { sizes: t } = Vr();
  return {
    size: t.avatars[e?.toLowerCase()],
    bg: r,
    color: o
  };
}, co = (e) => {
  const [n, r] = e.split(" ");
  return n && r ? `${n.charAt(0)}${r.charAt(0)}` : n.charAt(0);
}, rr = ({ src: e, onLoad: n, onError: r }) => {
  const o = Ce(!0), [t, s] = Y(!1);
  return Z(() => {
    const a = new window.Image();
    a.src = e, a.onload = (l) => {
      o.current && (s(!0), n && n(l));
    }, a.onError = (l) => {
      o.current && (s(!1), r && r(l));
    };
  }, [e, n, r]), Z(() => () => {
    o.current = !1;
  }, []), t;
}, po = Ee(
  ({ htmlWidth: e, htmlHeight: n, alt: r, ...o }, t) => /* @__PURE__ */ p.jsx("img", { alt: r, height: n, ref: t, width: e, ...o })
), Re = Ee(
  ({ src: e, fallbackSrc: n, onError: r, onLoad: o, loading: t, ...s }, a) => {
    const l = rr({ src: e, onLoad: o, onError: r }), u = { src: l ? e : n };
    return l ? /* @__PURE__ */ p.jsx(
      W,
      {
        as: po,
        ref: a,
        ...u,
        ...s,
        loading: t
      }
    ) : null;
  }
);
Re.propTypes = {
  /**
   * If `src` is invalid or absent, `fallbackSrc` is rendered.
   */
  fallbackSrc: i.string,
  /**
   * Loading type
   */
  loading: i.string,
  /**
   * Callback for when `src` is invalid
   */
  onError: i.func,
  /**
   * Callback for when the Image src has loaded successfully
   */
  onLoad: i.func,
  /**
   * Image source url
   */
  src: i.string.isRequired
};
Re.defaultProps = {
  fallbackSrc: "",
  loading: "lazy",
  onError: null,
  onLoad: null
};
Re.displayName = "Image";
const It = ["xl", "x", "l", "m", "s", "XL", "X", "L", "M", "S"], fo = ["square", "circle"], or = ({ children: e, ...n }) => /* @__PURE__ */ p.jsx(
  W,
  {
    bg: "accent.50",
    bottom: "-10px",
    position: "absolute",
    px: "size6",
    py: "size2",
    ...n,
    children: /* @__PURE__ */ p.jsx(ie, { type: "label", children: e })
  }
);
or.propTypes = {
  /**
   * Text to be displayed on the badge
   */
  children: i.string.isRequired
};
const Ke = ({ name: e, size: n, ...r }) => {
  const o = {
    xl: "title1",
    l: "button",
    m: "button",
    s: "label"
  };
  return /* @__PURE__ */ p.jsx(
    W,
    {
      alignItems: "center",
      "aria-label": e,
      fontWeight: "medium",
      justifyContent: "center",
      textAlign: "center",
      textTransform: "uppercase",
      ...r,
      children: /* @__PURE__ */ p.jsx(ie, { type: o[n], children: e ? co(e) : null })
    }
  );
};
Ke.propTypes = {
  /**
   * Name of the user to derive initials from
   */
  name: i.string,
  /**
   * Avatar size; This is a derived prop
   */
  size: i.oneOf(It)
};
Ke.defaultProps = {
  name: null,
  size: "m"
};
const yn = (e) => /* @__PURE__ */ p.jsx(W, { size: "100%", ...e, children: /* @__PURE__ */ p.jsx("svg", { fill: "#fff", role: "img", viewBox: "0 0 128 128", children: /* @__PURE__ */ p.jsxs("g", { children: [
  /* @__PURE__ */ p.jsx("path", { d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z" }),
  /* @__PURE__ */ p.jsx("path", { d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24" })
] }) }) }), ho = ({ src: e, name: n, objectFit: r, shape: o, size: t }) => {
  const s = rr({ src: e });
  return e && s ? /* @__PURE__ */ p.jsx(
    W,
    {
      alt: n,
      as: "img",
      borderRadius: o === "square" ? "0%" : "full",
      objectFit: r,
      size: "100%",
      src: e
    }
  ) : e && !s ? n ? /* @__PURE__ */ p.jsx(Ke, { name: n, size: t }) : /* @__PURE__ */ p.jsx(yn, {}) : !e && n ? /* @__PURE__ */ p.jsx(Ke, { name: n, size: t }) : /* @__PURE__ */ p.jsx(yn, {});
}, ke = ({ shape: e, size: n, name: r, src: o, badgeText: t, objectFit: s, ...a }) => {
  const l = n?.toLowerCase(), u = uo({
    name: r,
    size: n
  });
  return /* @__PURE__ */ p.jsxs(
    W,
    {
      alignItems: "center",
      borderRadius: e === "square" ? "0%" : "full",
      display: "flex",
      justifyContent: "center",
      position: "relative",
      verticalAlign: "top",
      ...u,
      ...a,
      children: [
        /* @__PURE__ */ p.jsx(
          ho,
          {
            name: r,
            objectFit: s,
            shape: e,
            size: l,
            src: o
          }
        ),
        t && t.length && ["xl", "l"].indexOf(l) > -1 && /* @__PURE__ */ p.jsx(or, { children: t })
      ]
    }
  );
}, ir = {
  /**
   * The text that the badge will contain. Will only show up if Avatar is xl or l.
   */
  badgeText: i.string,
  /**
   * The name associated with the Avatar, useful for when the user hasn't uploaded their image yet.
   */
  name: i.string,
  /**
   * Objectfit property for image
   */
  objectFit: i.string,
  /**
   * The Shape of the avatar icon
   */
  shape: i.oneOf(fo),
  /**
   * The size of the avatar icon
   */
  size: i.oneOf(It),
  /**
   * The image that the Avatar will contain
   */
  src: i.string
};
ke.propTypes = ir;
ke.defaultProps = {
  badgeText: null,
  name: null,
  objectFit: "cover",
  shape: "circle",
  size: It[2],
  src: null
};
ke.displayName = "Avatar";
const go = se(W)`
  display: flex;

  .avatarContainer:not(:first-of-type) {
    border: 1px solid #ffffff;
    margin-left: -8px;
  }
  .groupedAvatar {
    border-radius: 50%;
    background: #2f53d7;
    justify-content: center;
    align-items: center;
    color: white;
    display: flex;
    position: relative;
  }
  .moreContainer {
    margin-left: 8px;
    color: #72737d;
    align-self: center;
  }
`, Bt = G.memo(function({
  usersList: n,
  showMax: r = n.length,
  showGroupedAvatarsCount: o,
  avatarSize: t,
  avatarShape: s,
  ...a
}) {
  const l = n.length - r, u = {
    xl: "title1",
    l: "button",
    m: "button",
    s: "label"
  };
  return /* @__PURE__ */ p.jsxs(go, { ...a, children: [
    n.slice(0, r).map((m) => /* @__PURE__ */ p.jsx(
      ke,
      {
        className: "note14 avatarContainer",
        ...m,
        shape: m.shape || s,
        size: m.size || t
      }
    )),
    o && l > 0 ? /* @__PURE__ */ p.jsxs(
      ie,
      {
        className: "moreContainer",
        type: u[t.toLowerCase()],
        children: [
          "+ ",
          l,
          " more"
        ]
      }
    ) : null
  ] });
});
Bt.propTypes = {
  /**
   * Shape of all avatars, default to 'circle'
   */
  avatarShape: i.string,
  /**
   * Size of all avatars, default to 's'
   */
  avatarSize: i.string,
  /**
   * Show count of grouped avatars what are not shown, default to false
   */
  showGroupedAvatarsCount: i.bool,
  /**
   * How many avatars to be shown, default to length of array
   */
  showMax: i.number,
  /**
   * From where to start showing avatars from list, default to index 0
   */
  usersList: i.arrayOf(
    i.shape({
      id: i.number.isRequired,
      ...ir
    })
  )
};
Bt.displayName = "AvatarGroup";
Bt.defaultProps = {
  avatarShape: "circle",
  avatarSize: "s",
  showGroupedAvatarsCount: !1,
  showMax: void 0,
  usersList: []
};
const mo = {
  transition: "all 0.15s ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  _focus: {
    boxShadow: "outline"
  },
  _disabled: {
    cursor: "not-allowed",
    textDecoration: "none"
  }
}, et = Ee(({ isDisabled: e, isExternal: n, onClick: r, ...o }, t) => {
  const s = n ? { target: "_blank", rel: "noopener noreferrer" } : null;
  return /* @__PURE__ */ p.jsx(
    Vn,
    {
      _hover: { textDecoration: "underline" },
      "aria-disabled": e,
      as: "a",
      onClick: e ? (a) => a.preventDefault() : r,
      ref: t,
      tabIndex: e ? -1 : void 0,
      ...s,
      ...mo,
      ...o
    }
  );
});
et.displayName = "Link";
et.propTypes = {
  /**
   * If `true`, the link will be disabled and not clickable
   */
  isDisabled: i.bool,
  /**
   *  If `true`, the link will open in new tab
   */
  isExternal: i.bool,
  /**
   * Action to perform when clicked
   */
  onClick: i.function
};
et.defaultProps = {
  isDisabled: !1,
  isExternal: !1,
  onClick: () => {
  }
};
const Rt = ({
  index: e,
  isCurrentPage: n,
  separator: r,
  children: o,
  ...t
}) => /* @__PURE__ */ p.jsxs(W, { alignItems: "center", as: "li", display: "inline-flex", ...t, children: [
  e > 0 && /* @__PURE__ */ p.jsx(W, { as: "span", mx: 2, role: "presentation", children: r }),
  /* @__PURE__ */ p.jsx(
    et,
    {
      "aria-current": n ? "page" : null,
      color: n ? "basic.10" : "link",
      fontSize: "14px",
      isDisabled: n,
      ...t,
      children: o
    }
  )
] });
Rt.displayName = "BreadcrumbItem";
Rt.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: i.node,
  /**
   * index of the breadcrumb item
   */
  index: i.number,
  /**
   * If `true`, indicates that the breadcrumb item is active and will not be clickable
   */
  isCurrentPage: i.bool,
  /**
   * The visual separator between each breadcrumb item
   */
  separator: i.string
};
Rt.defaultProps = {
  separator: "/",
  index: 0,
  isCurrentPage: !1
};
const yo = (e) => xe.toArray(e).filter((n) => Jn(n)), _t = ({
  children: e,
  numberOfVisibleBreadcrumbs: n,
  separator: r,
  ...o
}) => {
  const t = yo(e), s = " ...";
  n > 0 && n < t.length && t.splice(
    1,
    t.length - n - 1,
    s
  );
  const a = t.map((l, u) => l === s ? (
    // eslint-disable-next-line react/jsx-fragments
    /* @__PURE__ */ p.jsx(G.Fragment, { children: /* @__PURE__ */ p.jsxs(W, { as: "span", mx: 2, role: "presentation", children: [
      r,
      " ",
      s
    ] }) }, `bc_${l.key}`)
  ) : Nt(l, {
    separator: r,
    numberOfVisibleBreadcrumbs: n,
    index: u,
    isCurrentPage: t.length > 1 && t.length === u + 1
  }));
  return /* @__PURE__ */ p.jsx(W, { "aria-label": "breadcrumb", as: "nav", ...o, children: /* @__PURE__ */ p.jsx(W, { as: "ol", pl: "0", children: a }) });
};
_t.displayName = "Breadcrumb";
_t.propTypes = {
  children: i.node.isRequired,
  /**
   * Number of visible breadcrumbs
   */
  numberOfVisibleBreadcrumbs: i.number,
  /**
   * The visual separator between each breadcrumb item
   */
  separator: i.string
};
_t.defaultProps = {
  numberOfVisibleBreadcrumbs: 0,
  separator: "/"
};
const bo = Kr`
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
margin: 0;
padding: 0;
border: 0;
font-size: 100%;
vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
display: block;
}
body, body * {
line-height: 1;
}
ol, ul {
list-style: none;
}
blockquote, q {
quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
content: '';
content: none;
}
table {
border-collapse: collapse;
border-spacing: 0;
}
a {
  text-decoration: none;
  color: inherit;
}

body, body * {
  font-family: 'IBM Plex Sans', sans-serif;
}

[role="tooltip"] {
  display: none;
}

button:hover + [role="tooltip"],
button:focus + [role="tooltip"] {
  display: block;
}

.ReactModal__Overlay {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}




`, Ts = () => /* @__PURE__ */ p.jsx(bo, {}), sr = ({ badgeCount: e }) => !e || e < 0 ? null : /* @__PURE__ */ p.jsxs(
  W,
  {
    alignItems: "center",
    as: ie,
    bg: "negative.50",
    borderRadius: "xlarge",
    color: "basic.100",
    display: "flex",
    height: 3,
    justifyContent: "center",
    ml: 2,
    px: 2,
    type: "inputFieldLabel",
    children: [
      e > 99 ? 99 : e,
      e > 99 && /* @__PURE__ */ p.jsx("span", { children: "+" })
    ]
  }
);
sr.propTypes = {
  badgeCount: i.number.isRequired
};
const tt = Ee(
  ({
    isDisabled: e,
    isActive: n,
    as: r,
    children: o,
    variant: t,
    isOpen: s,
    size: a,
    leftIcon: l,
    ariaDescribedby: u,
    badgeCount: m,
    ...f
  }, E) => {
    const w = {
      isDisabled: e,
      isActive: n,
      as: r,
      children: o,
      isOpen: s,
      size: a,
      leftIcon: l,
      ariaDescribedby: u,
      badgeCount: m,
      ...f
    };
    return /* @__PURE__ */ p.jsxs(
      Kn,
      {
        as: W,
        color: "basic",
        display: "inline-flex",
        ref: E,
        rightIcon: s ? Qn : Zn,
        variant: t === "standard" ? "solid" : "secondary",
        ...w,
        children: [
          o,
          /* @__PURE__ */ p.jsx(sr, { badgeCount: m })
        ]
      }
    );
  }
), ar = ["standard", "subtle"], lr = ["large", "medium", "small"];
tt.propTypes = {
  /**
   *  The label that the button is given, accessible to screen-readers.
   */
  ariaDescribedby: i.string,
  /**
   *  `as` prop from styled-components
   */
  as: i.oneOfType([i.object, i.string]),
  /**
   *  Badge count (integer) to enable showing of the badge
   */
  badgeCount: i.number,
  /**
   *  The text the button displays
   */
  children: i.oneOfType([i.object, i.string]),
  /**
   *  If true, the button is active. An active button is one that is currently clicked (pressed down)
   */
  isActive: i.bool,
  /**
   *  If true, the button is disabled
   */
  isDisabled: i.bool,
  /**
   *  The chevron icon on the right is pointed upwards - indicating the dropdown to be open
   */
  isOpen: i.bool,
  /**
   *  An icon is added to the left of the text, inside the button
   */
  leftIcon: i.oneOf([i.object, i.string]),
  /**
   *  The size of the button
   */
  size: i.oneOf(lr),
  /**
   *  The type of button
   */
  variant: i.oneOf(ar)
};
tt.defaultProps = {
  ariaDescribedby: null,
  as: "button",
  badgeCount: null,
  children: null,
  isActive: !1,
  isDisabled: !1,
  isOpen: !1,
  leftIcon: null,
  size: lr[0],
  variant: ar[0]
};
tt.displayName = "DropdownButton";
const nt = Ee(
  ({
    isDisabled: e,
    isLoading: n,
    isActive: r,
    children: o,
    as: t,
    color: s,
    leftIcon: a,
    rightIcon: l,
    loadingText: u,
    size: m,
    ariaDescribedby: f,
    ...E
  }, w) => {
    const y = {
      isDisabled: e,
      isLoading: n,
      isActive: r,
      children: o,
      Component: t,
      color: s,
      leftIcon: a,
      rightIcon: l,
      loadingText: u,
      size: m,
      ariaDescribedby: f,
      ...E
    };
    return /* @__PURE__ */ p.jsx(Kn, { variant: "text", ...y, ref: w });
  }
), ur = ["primary", "basic", "positive", "negative"], cr = ["large", "medium", "small"];
nt.propTypes = {
  /**
   * aria-described-by html attribute
   */
  ariaDescribedby: i.string,
  /**
   * `html tag` or `React Component` that renders button styles instead of the default `button` tag
   */
  as: i.oneOf([i.object, i.string]),
  /**
   * The text inside the button. Can also be used to render custom components inside the button.
   */
  children: i.string.isRequired,
  /**
   * The color type of button
   */
  color: i.oneOf(ur),
  /**
   * If true, the button is active. An active button is one that is currently clicked (pressed down)
   */
  isActive: i.bool,
  /**
   * If true, the button is disabled
   */
  isDisabled: i.bool,
  /**
   * If true, the button enters loading state and is disabled
   */
  isLoading: i.bool,
  /**
   * Icon to be rendered on the left of `children` - can only be one of the icons from the list exported from `IconLib`
   */
  leftIcon: i.oneOf([i.object, i.string]),
  /**
   * Custom text to be rendered in place of `children` when button is in loading state
   */
  loadingText: i.string,
  /**
   * Icon to be rendered on the right of `children` - can only be one of the icons from the list exported from `IconLib`
   */
  rightIcon: i.oneOf([i.object, i.string]),
  /**
   * The size of button
   */
  size: i.oneOf(cr)
};
nt.defaultProps = {
  ariaDescribedby: null,
  as: "button",
  color: ur[0],
  isActive: !1,
  isDisabled: !1,
  isLoading: !1,
  leftIcon: void 0,
  rightIcon: null,
  loadingText: null,
  size: cr[0]
};
nt.displayName = "TextButton";
const vo = se(W)`
  display: flex;
  align-items: center;
  background-color: ${(e) => e.bgColor ? e.bgColor : "#E8EDFF"};
  border-radius: 4px;
  padding: 0px 10px 0px 8px;
  margin: 2px 4px 2px 0px;
  max-width: calc(100% -16px);
  height: 26px;

  .chipAvatar {
    margin-right: 4px;
    height: 18px;
    width: 18px;
    border: 1px solid #fff;
 
    > div > div {
      font-size: 10px;
      text-align: center;
    }
  }

  .chipLabel {
    flex: 1;
    color: ${(e) => e.color ? e.color : ce.black};
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    white-space: nowrap;
    text-transform: capitalize;
  }

  .chipDelete {
    width: 16px;
    height: 16px;
    cursor: pointer;
    margin-left: 4px;
  }
`, rt = (e) => {
  const {
    showAvatar: n,
    data: r,
    _handleChipViewDelete: o,
    showClear: t,
    bgColor: s,
    className: a,
    border: l,
    color: u
  } = e;
  return /* @__PURE__ */ p.jsxs(
    vo,
    {
      bgColor: s,
      border: l,
      className: a,
      color: u,
      children: [
        n && /* @__PURE__ */ p.jsx(
          ke,
          {
            className: "chipAvatar",
            name: r.name,
            size: "S",
            src: r.image
          }
        ),
        /* @__PURE__ */ p.jsx(W, { className: "chipLabel label14", children: r.name }),
        t && /* @__PURE__ */ p.jsx(
          fe,
          {
            className: "chipDelete",
            icon: er,
            onClick: () => o(r.id)
          }
        )
      ]
    }
  );
};
rt.propTypes = {
  _handleChipViewDelete: () => {
  },
  bgColor: i.string,
  border: i.string,
  className: i.string,
  color: i.string,
  data: {},
  showAvatar: i.bool,
  showClear: i.bool
};
rt.defaultProps = {
  _handleChipViewDelete: () => {
  },
  bgColor: "#E1E1E8",
  border: "",
  className: "",
  color: "",
  data: {},
  showAvatar: !1,
  showClear: !0
};
rt.displayName = "Chip";
const xo = se(W)`
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;
    border-radius: 4px;

    .inputIcon {
        position: absolute;
        right: 20px;
    }

    .chipView {
        position: relative;
        display: flex;
        align-items: center;
        flex-flow: wrap;
        width: 100%;
        min-height: 44px;
        -webkit-transition: all 0.2s;
        transition: all 0.2s;
        padding-top: 6px;
        outline: none;
        background: none;
        box-sizing: border-box;
        border: ${(e) => e.noBorder ? 0 : "1px solid"};
        border-color: #C8C9D1;
        background-color: ${(e) => e.backgroundColor || "#ffffff"};
        color: #202124;
        padding-left: 16px;
        padding-right: 12px;
        padding-bottom: 6px;
        border-radius:4px;
        transition: 0.2s border;

        &.active {
            border: ${(e) => e.noBorder ? 0 : `1px solid ${ce.blue[50]}`};
        }
    }

    .searchInput {
        border: 0 !important;
        outline: none !important;
        flex: 1;
        background-color: ${(e) => e.backgroundColor || "#ffffff"};
    }

    .searchInput::placeholder {
      color: #adadae;
    }

    .renderListContainer {
        border: 1px solid #E1E1E8;
        border-radius: 4px;
        position: absolute;
        min-width: 400px;
        z-index: ${(e) => e.zIndex || 9};
        top: ${(e) => `${e.containerHeight}px`};
        max-height: 300px;
        overflow-y: auto;
    }

    .renderListItem {
        &:hover {
            background: #eaf3fd
        }
    }
`, Eo = {
  delete: 8
}, wo = (e) => e == null || e.toString().trim().length === 0, Co = (e, n) => e.filter((r) => r.name.toLowerCase().includes(n.toLowerCase()) || r.email.toLowerCase().includes(n.toLowerCase())), Lt = G.memo(function(n) {
  const {
    userListMap: r,
    placeholder: o,
    icon: t,
    backgroundColor: s,
    noBorder: a,
    inputFieldId: l,
    chipViewId: u,
    iconClicked: m,
    itemKey: f,
    defaultValue: E,
    selectedList: w,
    onListUpdate: y,
    disabledUsersMap: D,
    list: j
  } = n, [P, N] = Y(!1), [M, b] = Y(E || ""), [x, C] = Y([]), [h, S] = Y(
    w && w.length ? w : []
  ), [g, O] = Y(null), v = () => {
    setTimeout(() => {
      C([]);
    }, 200);
  }, A = () => {
    N(!1), v();
  };
  Z(() => {
    const _ = setTimeout(() => {
      const B = document.getElementById(u);
      O(B && B.offsetHeight || 20);
    }, 200);
    return () => {
      clearTimeout(_);
    };
  }, []), Z(() => {
    S(w);
  }, [w]);
  const d = (_) => {
    if (b(_.target.value), _.target.value.trim() === "") {
      C([]);
      return;
    }
    let B = Co(j, _.target.value);
    B.length && (B = B.filter(
      (I) => !h.includes(I[f])
    )), C(B);
  }, c = (_, B) => {
    B || (S([...h, _[f]]), b(""), document.getElementById(l) && document.getElementById(l).focus(), y && y([...h, _[f]]), setTimeout(() => {
      C([]);
      const I = document.getElementById(u);
      O(I && I.offsetHeight || 20);
    }, 200));
  }, k = (_) => {
    const B = h.filter((I) => I !== _);
    S(B), y && y(B), document.getElementById(l) && document.getElementById(l).focus(), setTimeout(() => {
      const I = document.getElementById(u);
      O(I && I.offsetHeight || 20);
    }, 200);
  }, R = (_) => {
    _.which === Eo.delete && h.length > 0 && wo(M) && k(h[h.length - 1]);
  };
  return /* @__PURE__ */ p.jsxs(
    xo,
    {
      backgroundColor: s,
      containerHeight: g,
      noBorder: a,
      children: [
        /* @__PURE__ */ p.jsxs(
          W,
          {
            className: `chipView text14weight400 ${P ? "active" : ""}`,
            id: u,
            children: [
              h.length ? h.map((_) => {
                if (!_) return null;
                const B = r[_];
                return /* @__PURE__ */ p.jsx(
                  rt,
                  {
                    _handleChipViewDelete: k,
                    data: {
                      image: B.profile_image_url && B.profile_image_url.thumbnail ? B.profile_image_url.thumbnail : null,
                      name: B.name,
                      id: B[f]
                    },
                    showAvatar: !0,
                    showClear: !0
                  },
                  B[f]
                );
              }) : "",
              /* @__PURE__ */ p.jsx(
                "input",
                {
                  className: "searchInput",
                  height: "40px",
                  id: l,
                  onBlur: A,
                  onChange: d,
                  onFocus: () => N(!0),
                  onKeyDown: R,
                  placeholder: h.length ? "" : o || "Your input here",
                  value: M
                }
              ),
              /* @__PURE__ */ p.jsx(
                Re,
                {
                  className: "inputIcon",
                  cursor: m ? "pointer" : "default",
                  onClick: () => m ? m() : {},
                  src: t
                }
              )
            ]
          }
        ),
        x.length ? /* @__PURE__ */ p.jsx(
          W,
          {
            bg: "basic.100",
            className: "renderListContainer",
            color: "base.10",
            w: "100%",
            children: x.map((_) => {
              let B = !1, I = "";
              return D && D[_[f]] && (B = !0, I = D[_[f]].reason), /* @__PURE__ */ p.jsx(
                tr,
                {
                  arrowSize: 5,
                  background: "#000",
                  color: "#FFF",
                  content: I,
                  direction: "down",
                  useHover: B,
                  children: /* @__PURE__ */ p.jsxs(
                    W,
                    {
                      alignItems: "center",
                      bg: "basic.100",
                      className: "renderListItem",
                      color: "base.10",
                      cursor: B ? "not-allowed" : "pointer",
                      d: "flex",
                      onClick: () => c(_, B),
                      pb: 5,
                      pl: 6,
                      pr: 6,
                      pt: 5,
                      children: [
                        /* @__PURE__ */ p.jsx(
                          ke,
                          {
                            name: _.name,
                            shape: "circle",
                            size: "M",
                            src: _.profile_image_url && _.profile_image_url.thumbnail ? _.profile_image_url.thumbnail : ""
                          }
                        ),
                        /* @__PURE__ */ p.jsxs(W, { className: "", color: "base.10", ml: 6, children: [
                          /* @__PURE__ */ p.jsx(ie, { type: "tag", children: _.name }),
                          /* @__PURE__ */ p.jsx(ie, { type: "timestamp", children: _.email })
                        ] })
                      ]
                    },
                    _[f]
                  )
                }
              );
            })
          }
        ) : ""
      ]
    }
  );
});
Lt.propTypes = {
  backgroundColor: "",
  chipViewId: "id",
  defaultValue: "",
  disabledUsersMap: {},
  icon: "",
  iconClicked: () => {
  },
  inputFieldId: "id",
  itemKey: "id",
  list: [],
  noBorder: !1,
  onListUpdate: () => {
  },
  placeholder: "placeholder",
  selectedList: [],
  userListMap: {}
};
Lt.defaultProps = {
  backgroundColor: "",
  chipViewId: "id",
  defaultValue: "",
  icon: "",
  iconClicked: () => {
  },
  inputFieldId: "id",
  itemKey: "id",
  list: [],
  noBorder: !1,
  onListUpdate: () => {
  },
  placeholder: "placeholder",
  selectedList: [],
  userListMap: {},
  disabledUsersMap: {}
};
Lt.displayName = "UserChipInput";
const $t = ({
  ctaLabel: e,
  id: n,
  index: r,
  isChecked: o,
  isDisabled: t,
  label: s,
  onCheckboxClick: a,
  onCtaClick: l,
  showCheckbox: u,
  tag: m,
  ...f
}) => {
  const E = () => {
    a(n);
  }, w = () => {
    e && l(n);
  }, y = /* @__PURE__ */ p.jsxs(ie, { color: "grey.10", type: "timestamp", children: [
    r > -1 && `${r + 1}. `,
    s
  ] });
  return /* @__PURE__ */ p.jsxs(
    W,
    {
      border: "1px solid",
      borderColor: "grey.80",
      borderRadius: "3px",
      boxSizing: "border-box",
      d: "flex",
      flex: "1",
      justifyContent: "space-between",
      m: "4px 0",
      p: "9px 12px",
      w: "100%",
      ...f,
      children: [
        /* @__PURE__ */ p.jsxs(W, { alignItems: "center", d: "inline-flex", justifyContent: "flex-start", children: [
          u && /* @__PURE__ */ p.jsx(
            no,
            {
              checked: o,
              disabled: t,
              id: `checkbox_${n}`,
              onChange: E,
              children: y
            }
          ),
          !u && y
        ] }),
        /* @__PURE__ */ p.jsxs(W, { d: "flex", children: [
          e && /* @__PURE__ */ p.jsx(
            ie,
            {
              alignItems: "center",
              color: "blue.50",
              cursor: "pointer",
              d: "flex",
              justifyContent: "flex-end",
              minWidth: "100px",
              onClick: w,
              pl: "10px",
              tag: "div",
              type: "tag",
              children: e
            }
          ),
          m && /* @__PURE__ */ p.jsx(
            ie,
            {
              alignItems: "center",
              color: "grey.20",
              d: "flex",
              justifyContent: "flex-end",
              minWidth: e ? "auto" : "100px",
              pl: "10px",
              tag: "div",
              type: "inputFieldLabel",
              userSelect: "none",
              children: m
            }
          )
        ] })
      ]
    }
  );
};
$t.displayName = "ContentSelectionItem";
$t.propTypes = {
  /** CTA Label */
  ctaLabel: i.string,
  /** Unique ID if checkbox is enabled */
  id: i.oneOfType([i.string, i.number]),
  /** Index to show numbers in front of labels */
  index: i.number,
  /** Checkbox checked state */
  isChecked: i.bool,
  /** Checkbox disabled state */
  isDisabled: i.bool,
  /** Short label for item */
  label: i.string.isRequired,
  /** Click handler for checkbox */
  onCheckboxClick: i.func,
  /** Click handler for CTA */
  onCtaClick: i.func,
  /** Show and hide checkbox */
  showCheckbox: i.bool,
  /** Label for tag */
  tag: i.string
};
$t.defaultProps = {
  ctaLabel: "",
  id: "",
  index: -1,
  isChecked: !1,
  isDisabled: !1,
  onCheckboxClick: null,
  onCtaClick: null,
  showCheckbox: !1,
  tag: ""
};
const Do = "0 1px 3px 0 rgba(0, 0, 0, 0.2), 1px 3px 4px 0 rgba(241, 241, 241, 0.15), 0 4px 8px 0 rgba(0, 0, 0, 0.05)", qt = ({ title: e, description: n, help: r, children: o }) => /* @__PURE__ */ p.jsxs(W, { bg: "white", borderRadius: "4px", boxShadow: Do, p: "24px 16px 12px", children: [
  /* @__PURE__ */ p.jsxs(
    W,
    {
      alignItems: "flex-end",
      d: "flex",
      justifyContent: "space-between",
      mb: "6px",
      children: [
        /* @__PURE__ */ p.jsx(W, { children: /* @__PURE__ */ p.jsx(ie, { color: "black", type: "button", children: e }) }),
        r && /* @__PURE__ */ p.jsx(W, { alignItems: "flex-end", d: "flex", h: "16px", children: r })
      ]
    }
  ),
  n && /* @__PURE__ */ p.jsx(ie, { color: "grey.30", mb: "22px", type: "note", children: n }),
  /* @__PURE__ */ p.jsx(W, { d: "flex", flexDir: "column", my: "10px", children: o })
] });
qt.propTypes = {
  /**
   * List of content selection items
   */
  children: i.node.isRequired,
  /**
   * Short description of the block
   */
  description: i.string,
  /**
   * Helper element. It can be a tag, tooltip, badge, etc.
   */
  help: i.node,
  /**
   * Title
   */
  title: i.string.isRequired
};
qt.defaultProps = {
  description: "",
  help: null
};
qt.displayName = "ContentSelection";
const ko = (e, n, r) => (e - n) * 100 / (r - n), Ht = ({ min: e, max: n, value: r, ...o }) => {
  const t = ko(r, e, n), s = Yn`
  0% {
    width:0
  }
  100% {
   width:${t}%
  }
`, a = se.div`
    animation: ${s} 1s ease-in-out;
  `;
  return /* @__PURE__ */ p.jsx(
    W,
    {
      "aria-valuemax": n,
      "aria-valuemin": e,
      "aria-valuenow": r,
      as: a,
      height: "100%",
      role: "progressbar",
      width: `${t}%`,
      ...o,
      transition: "all 3s"
    }
  );
};
Ht.propTypes = {
  max: i.number,
  min: i.number,
  value: i.number
};
Ht.defaultProps = {
  max: 100,
  min: 0,
  value: 20
};
const dr = {
  large: "8px",
  medium: "4px",
  small: "2px"
}, pr = {
  positive: ["#59ff4a", ce.positive[50]],
  negative: ["#fb9566", ce.negative[40]],
  neutral: ["#fdef54", "#fdda01"]
}, Ut = Object.keys(dr), So = Object.keys(pr), Wt = ({ size: e, ...n }) => /* @__PURE__ */ p.jsx(
  W,
  {
    height: dr[e],
    overflow: "hidden",
    pos: "relative",
    transition: "all 0.3s",
    ...n
  }
);
Wt.propTypes = {
  size: i.oneOf(Ut)
};
Wt.defaultProps = {
  size: "medium"
};
const zt = De(
  ({
    color: e,
    gradientColorsType: n,
    gradientColors: r,
    gradientDirection: o,
    value: t,
    min: s,
    max: a,
    size: l,
    ...u
  }) => {
    const m = "basic.80", f = n ? pr[n]?.join(",") : r?.join(",");
    return /* @__PURE__ */ p.jsx(
      Wt,
      {
        bg: m,
        borderRadius: l === "small" ? "small" : "medium",
        size: l,
        ...u,
        children: /* @__PURE__ */ p.jsx(
          Ht,
          {
            background: f ? `linear-gradient(${o},${f})` : "",
            bg: f ? "" : e,
            borderRadius: l === "small" ? "small" : "medium",
            max: a,
            min: s,
            value: t
          }
        )
      }
    );
  }
);
zt.propTypes = {
  /**
   * Color of the progress track
   */
  color: i.string,
  /**
   * Custom gradient colors if override needed for gradientType
   */
  gradientColors: i.arrayOf(i.string),
  /**
   * Available gradients, either positive, negative or neutral
   */
  gradientColorsType: i.oneOf(So),
  /**
   * Custom gradient colors if override needed for gradientType
   */
  gradientDirection: i.string,
  /**
   * Max value acceptable by progress
   */
  max: i.number,
  /**
   * Min value acceptable by progress
   */
  min: i.number,
  /**
   * Available sizes (or heights)
   */
  size: i.oneOf(Ut),
  /**
   * The current value of the progressbar. Should be between `min` and `max`
   */
  value: i.number
};
zt.defaultProps = {
  color: "primary.50",
  gradientColors: [],
  gradientColorsType: "",
  gradientDirection: "to right",
  max: 100,
  min: 0,
  size: "medium",
  value: 20
};
const Oo = Ut, fr = ({
  color: e,
  value: n,
  steps: r,
  size: o,
  ...t
}) => /* @__PURE__ */ p.jsx(W, { display: "grid", gridAutoFlow: "column", gridGap: 2, children: [...Array(r).keys()].map(
  (s) => /* @__PURE__ */ p.jsx(zt, { color: e, size: o, ...t, max: 1, min: 0, value: s < n ? 1 : 0 })
) });
fr.propTypes = {
  /**
   * Color of the progress track
   */
  color: i.string,
  /**
   * Available sizes (or heights)
   */
  size: i.oneOf(Oo),
  /**
   * No of steps in the discrete progressbar - should be an integer
   */
  steps: i.number,
  /**
   * The current value of the progressbar. Should be an integer between `0` and `steps`
   */
  value: i.number
};
fr.defaultProps = {
  color: "primary.50",
  steps: 10,
  size: "medium",
  value: 2
};
const Vt = Ee(({ children: e, ...n }, r) => {
  const o = Yr();
  return o.isInvalid ? /* @__PURE__ */ p.jsx(
    W,
    {
      ...n,
      align: "center",
      as: ie,
      color: "negative.50",
      id: o.id ? `${o.id}-error-message` : null,
      mt: 4,
      ref: r,
      type: "note",
      children: e
    }
  ) : null;
});
Vt.defaultProps = {
  children: null
};
Vt.propTypes = {
  children: i.node
};
Vt.displayName = "FormErrorMessage";
const ot = ({
  item: { refId: e, parent: n, isEndNode: r, isLoading: o, isExpanded: t },
  children: s,
  depth: a,
  depthLimit: l,
  index: u,
  siblingsCount: m,
  smallDash: f,
  toggleExpand: E,
  variant: w,
  ...y
}) => {
  const D = ["accordion", "customAccordion"], j = D.includes(w) ? l === a && !r : r && n === "_root", P = () => {
    j || E({ refId: e, parent: n, isEndNode: r });
  }, N = f ? "14px" : "40px";
  return /* @__PURE__ */ p.jsx(W, { as: "li", d: "block", listStyle: "none", position: "relative", ...y, children: /* @__PURE__ */ p.jsxs(
    W,
    {
      cursor: "pointer",
      d: "flex",
      m: D.includes(w) ? "0" : "10px 0 5px",
      position: D.includes(w) ? "relative" : "",
      children: [
        w === "default" && a > 0 && (u === 0 || u < m - 1) && /* @__PURE__ */ p.jsx(
          W,
          {
            as: "span",
            bg: "grey.70",
            h: u === 0 ? `calc(100% + ${m > 1 ? 35 : 5}px)` : "calc(100% + 10px)",
            left: "0",
            position: "absolute",
            top: u === 0 ? "-16px" : "10px",
            w: "1px",
            zIndex: "3"
          }
        ),
        w === "default" && /* @__PURE__ */ p.jsx(
          W,
          {
            as: "span",
            bg: n === "_root" ? "transparent" : "grey.70",
            h: "1px",
            position: "relative",
            top: "9px",
            w: j ? "20px" : r ? N : "20px"
          }
        ),
        w === "default" && /* @__PURE__ */ p.jsxs(
          W,
          {
            alignItems: "center",
            bg: j ? "grey.80" : r ? "transparent" : "blue.90",
            d: "flex",
            h: "20px",
            justifyContent: "center",
            onClick: P,
            position: "relative",
            w: j ? "20px" : r ? "0px" : "20px",
            children: [
              !r && o && /* @__PURE__ */ p.jsx(Ot, { color: "grey.20", size: "12px", thickness: "1px" }),
              (j || !r && !o) && /* @__PURE__ */ p.jsx(
                fe,
                {
                  color: "grey.20",
                  icon: t ? _r : Rr,
                  size: "20px"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ p.jsx(
          W,
          {
            flex: "1",
            onClick: (M) => {
              D.includes(w) && (P(), M.stopPropagation());
            },
            ...y,
            children: s
          }
        ),
        w === "accordion" && /* @__PURE__ */ p.jsxs(
          W,
          {
            alignItems: "center",
            bg: j ? "grey.90" : "transparent",
            d: "flex",
            h: "20px",
            justifyContent: "center",
            mt: 1,
            pointerEvents: "none",
            position: "absolute",
            right: "6px",
            top: "10px",
            w: "20px",
            children: [
              !r && o && /* @__PURE__ */ p.jsx(Ot, { color: "grey.20", size: "12px", thickness: "1px" }),
              (j || !r && !o) && /* @__PURE__ */ p.jsx(
                fe,
                {
                  color: j ? "grey.20" : "blue.50",
                  icon: t ? zn : Wn,
                  size: "20px"
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};
ot.propTypes = {
  children: i.node.isRequired,
  depth: i.number.isRequired,
  depthLimit: i.number,
  index: i.number.isRequired,
  item: i.shape({
    isEndNode: i.bool.isRequired,
    isExpanded: i.bool.isRequired,
    isLoading: i.bool.isRequired,
    parent: i.oneOfType([i.string, i.number]).isRequired,
    refId: i.oneOfType([i.string, i.number]).isRequired
  }).isRequired,
  siblingsCount: i.number.isRequired,
  smallDash: i.bool,
  toggleExpand: i.func.isRequired,
  variant: i.string
};
ot.defaultProps = {
  depthLimit: -1,
  smallDash: !1,
  variant: "default"
};
ot.displayName = "HierarchyItem";
const it = ({
  allNodes: e,
  children: n,
  depth: r,
  depthLimit: o,
  loadChildrenWithDelay: t,
  nodeRefId: s,
  smallDash: a,
  toggleNodeExpand: l,
  variant: u,
  ...m
}) => {
  const [f, E] = Y(e), w = (P) => {
    const N = P.parent, M = [...e[N]], b = M.findIndex((C) => C.refId === P.refId), x = M[b];
    t ? x.isExpanded ? (x.isExpanded = !1, x.isLoading = !1) : (x.isLoading = !0, l(P, b)) : x.isExpanded = !x.isExpanded, E((C) => ({
      ...C,
      [N]: M
    }));
  }, y = (P) => !P.isEndNode && e && e[P.refId] && e[P.refId].length > 0 && P.isExpanded, D = f[s] ? f[s].length : 0, j = (P) => xe.map(n, (N) => {
    const M = { depth: r, ...P };
    return Jn(N) ? Nt(N, M) : N;
  });
  return Z(() => {
    E(e);
  }, [e]), /* @__PURE__ */ p.jsx(W, { ...m, children: /* @__PURE__ */ p.jsx(
    W,
    {
      as: "ul",
      left: u === "default" ? "-9px" : 0,
      listStyle: "none",
      m: r > 0 && u === "default" ? "16px 0 0" : "0",
      pl: 0,
      position: "relative",
      children: f[s] && f[s].map((P, N) => /* @__PURE__ */ p.jsxs(
        ot,
        {
          depth: r,
          depthLimit: o,
          index: N,
          item: P,
          siblingsCount: D,
          smallDash: a,
          toggleExpand: w,
          variant: u,
          ...m,
          children: [
            j(P),
            y(P) && /* @__PURE__ */ p.jsx(
              it,
              {
                allNodes: f,
                depth: r + 1,
                depthLimit: o,
                loadChildrenWithDelay: t,
                nodeRefId: P.refId,
                smallDash: a,
                toggleNodeExpand: w,
                variant: u,
                ...m,
                children: j(P)
              }
            )
          ]
        },
        P.refId
      ))
    }
  ) });
};
it.propTypes = {
  /**
   * Entire hierarchy object
   */
  allNodes: i.objectOf(i.array).isRequired,
  /**
   * UI element used for each element in the hierarchy
   */
  children: i.node.isRequired,
  /**
   * Depth of the hierarchy tree at a particular level
   */
  depth: i.number.isRequired,
  /**
   * Depth limit for opening the hierarchy tree
   */
  depthLimit: i.number,
  /**
   * Are children loaded with some delay?
   */
  loadChildrenWithDelay: i.bool,
  /**
   * Node ref id in the hierarchy object
   */
  nodeRefId: i.oneOfType([i.string, i.number]).isRequired,
  /**
   * Small dash in front of users
   */
  smallDash: i.bool,
  /**
   * Handler to toggle expansion of node
   */
  toggleNodeExpand: i.func,
  /**
   * Style for the hierarchy tree expansion
   */
  variant: i.string
};
it.defaultProps = {
  depthLimit: -1,
  loadChildrenWithDelay: !1,
  smallDash: !1,
  toggleNodeExpand: null,
  variant: "default"
};
it.displayName = "Hierarchy";
const Kt = ({
  data: e,
  height: n,
  width: r,
  visibleDataLimit: o,
  hideFirstScoreText: t,
  hideLastScoreText: s
}) => {
  const [a, l] = Y(0), [u, m] = Y(0), [f, E] = Y(0), [w, y] = Y(0), [D, j] = Y(0), [P, N] = Y([]), [M, b] = Y(-1), x = n / 4, C = () => {
    let d = Number.MAX_SAFE_INTEGER, c = Number.MIN_SAFE_INTEGER, k = 0, R = [];
    o && o < e.length ? (k = e.length - o, j(k), R = e.filter((B, I) => !(I !== 0 && I < k + 1)), N(R)) : (R = e, N(e));
    const _ = R.length;
    for (let B = 0; B < e.length; B += 1)
      e[B].score < d && (d = e[B].score), e[B].score > c && (c = e[B].score);
    return {
      minScore: d,
      maxScore: c,
      numberOfScores: _
    };
  }, h = (d, c) => {
    const k = Math.abs(d - c);
    return k > Math.max(Math.abs(d), Math.abs(d)) ? (n - 2 * x) / k : (n - 2 * x) / (Math.max(Math.abs(d), Math.abs(d)) || 1);
  }, S = (d) => w === f ? n / 2 : w < 0 || f < 0 ? -(d * u + x) + (n - Math.abs(u * f)) : -(d * u + x) + n;
  Z(() => {
    const {
      maxScore: d,
      minScore: c,
      numberOfScores: k
    } = C();
    l((r - x) / (k - 1)), m(h(d, c)), E(c), y(d);
  }, [n, r, e]);
  const g = () => {
    const d = [];
    for (let c = 0; c < P.length; c += 1) {
      const k = S(
        P[c].score
      );
      d.push({
        x: a * c + x / 2,
        y: k
      });
    }
    return d;
  }, O = (d) => {
    b(d);
  }, v = () => {
    b(-1);
  }, A = () => /* @__PURE__ */ p.jsx(G.Fragment, { children: g().map(
    (d, c, k) => /* @__PURE__ */ p.jsxs(G.Fragment, { children: [
      c < k.length - 1 ? /* @__PURE__ */ p.jsx(
        "line",
        {
          stroke: "#c8c9d1",
          strokeDasharray: `2,${c === 0 && D > 0 ? "2" : 0}`,
          strokeWidth: 2,
          x1: d.x,
          x2: k[c + 1].x,
          y1: d.y,
          y2: k[c + 1].y
        }
      ) : null,
      c === 0 && !t || c === k.length - 1 && !s || c === M ? /* @__PURE__ */ p.jsx(
        "text",
        {
          dominantBaseline: "middle",
          fill: P[c].color,
          style: { font: "bold 10px sans-serif" },
          textAnchor: "middle",
          x: d.x,
          y: d.y - 15,
          children: P[c].score
        }
      ) : null,
      /* @__PURE__ */ p.jsxs(
        "g",
        {
          filter: "url(#shadow)",
          onFocus: () => null,
          onMouseLeave: () => v(),
          onMouseOver: () => O(c),
          children: [
            /* @__PURE__ */ p.jsx(
              "circle",
              {
                cx: d.x,
                cy: d.y,
                fill: "#ffffff",
                r: c === 0 || c === k.length - 1 || c === M ? "6" : "4"
              }
            ),
            /* @__PURE__ */ p.jsx(
              "circle",
              {
                cx: d.x,
                cy: d.y,
                fill: P[c].color,
                r: c === 0 || c === k.length - 1 || c === M ? "5" : "3"
              }
            )
          ]
        }
      )
    ] })
  ) });
  return /* @__PURE__ */ p.jsxs("svg", { height: n, width: r, children: [
    /* @__PURE__ */ p.jsx("defs", { children: /* @__PURE__ */ p.jsx("filter", { id: "shadow", children: /* @__PURE__ */ p.jsx(
      "feDropShadow",
      {
        dx: "0.5",
        dy: "0.4",
        floodColor: "#444444",
        floodOpacity: "0.5",
        stdDeviation: "1"
      }
    ) }) }),
    A()
  ] });
};
Kt.propTypes = {
  /**
   * Data object for each point
   */
  data: i.arrayOf(
    i.shape({
      color: i.string,
      hoverText: i.string,
      score: i.number.isRequired
    })
  ).isRequired,
  /**
   * height of the svg
   */
  height: i.number.isRequired,
  /**
   * hide the first score text from trendLine
   */
  hideFirstScoreText: i.bool,
  /**
   * hide the first score text from trendLine
   */
  hideLastScoreText: i.bool,
  /**
   * Number of points to show at max
   */
  visibleDataLimit: i.number.isRequired,
  /**
   * width of the svg
   */
  width: i.number.isRequired
};
Kt.defaultProps = {
  hideFirstScoreText: !1,
  hideLastScoreText: !1
};
Kt.displayName = "TrendLine";
const Yt = ({ isFullWidth: e, width: n, children: r, ...o }) => /* @__PURE__ */ p.jsx(
  W,
  {
    alignItems: "flex-start",
    boxShadow: gn.shadows.base,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    overflow: "hidden",
    width: e ? "100%" : n,
    zIndex: gn.zIndices[4],
    ...o,
    children: r
  }
);
Yt.propTypes = {
  /**
   *You can pass the children as node or any other components.
   */
  children: i.node.isRequired,
  /**
   *This className for Menu view row.
   */
  className: i.string,
  /**
   *If row will take full width or not
   */
  isFullWidth: i.bool,
  /**
   *Width of row/custom components.
   */
  width: i.string
};
Yt.defaultProps = {
  className: null,
  isFullWidth: !1,
  width: "300px"
};
Yt.displayName = "SimpleMenuView";
const Gt = ({
  children: e,
  isDisabled: n,
  item: r,
  isFullWidth: o,
  onSelection: t,
  optionLabel: s,
  selectedItem: a,
  className: l,
  defaultBg: u,
  defaultTextColor: m,
  disableBg: f,
  disableTextColor: E,
  selectionBg: w,
  selectionTextColor: y,
  type: D,
  width: j,
  ...P
}) => /* @__PURE__ */ p.jsx(
  Vn,
  {
    _hover: {
      bg: n ? "" : "#ebf6ff"
    },
    backgroundColor: n ? f : a && a.id === r.id ? w : u,
    borderBottomWidth: "1px",
    borderColor: "#e2e2ea",
    borderStyle: "solid",
    className: l,
    cursor: n ? "not-allowed" : "pointer",
    display: "flex",
    flexDirection: "row",
    onClick: () => t(r),
    pl: "16px",
    py: "8px",
    textOverflow: "ellipsis",
    transition: "all 0.2s",
    width: o ? "100%" : j,
    ...P,
    children: e || /* @__PURE__ */ p.jsx(
      ie,
      {
        className: "dropdownrow",
        color: n ? E : a && a.id === r.id ? y : m,
        fontWeight: "bold",
        type: D,
        children: r && r[s]
      }
    )
  }
), Po = () => {
};
Gt.propTypes = {
  /**
   *This child for Menu view row where one can pass any node or any other components.
   */
  children: i.node,
  /**
   *Default background color value.
   */
  defaultBg: i.string,
  /**
   *Default background text color value.
   */
  defaultTextColor: i.string,
  /**
   *Disable background color value.
   */
  disableBg: i.string,
  /**
   *Disable text color value.
   */
  disableTextColor: i.string,
  /**
   *Selection background color value.
   */
  selectionBg: i.string,
  /**
   *Selection Text color value.
   */
  selectionTextColor: i.string,
  /**
   *This className for Menu view row.
   */
  className: i.string,
  /**
   *Boolean which check if this row is disable.
   */
  isDisabled: i.bool,
  /**
   *If row will take full width or not
   */
  isFullWidth: i.bool,
  /**
   *Current item.
   */
  item: i.oneOfType([i.object]).isRequired,
  /**
   *A callback which update the selected item .
   */
  onSelection: i.func,
  /**
   *Property from the object to display the text
   */
  optionLabel: i.string,
  /**
   *Object of selected item.
   */
  selectedItem: i.oneOfType([i.object]),
  /**
   *Type for text i.e. 'title1' | 'header1' | 'header2' | 'header3' | 'header4' |
   'header5' | 'header6' | 'subheader' | 'body' | 'note' | 'button' | 'tag' |
   'label' | 'inputFieldLabel' | 'timestamp'.
   */
  type: i.string,
  /**
   *Width of row/custom components.
   */
  width: i.string
};
Gt.defaultProps = {
  children: null,
  defaultBg: "#ffffff",
  defaultTextColor: "#6c6d6f",
  disableBg: "#ffffff",
  disableTextColor: "#adadae",
  isDisabled: !1,
  selectionBg: "#ebf6ff",
  selectionTextColor: "#2f53d7",
  className: null,
  isFullWidth: !1,
  onSelection: Po(),
  optionLabel: "label",
  selectedItem: null,
  type: "body",
  width: "300px"
};
Gt.displayName = "SimpleMenuViewRow";
var jo = ro();
function Ye(e, n) {
  typeof e == "function" ? e(n) : e && (e.current = n);
}
function Mo(e, n) {
  return Ft(() => e == null && n == null ? null : (r) => {
    Ye(e, r), Ye(n, r);
  }, [e, n]);
}
const ht = typeof window < "u" ? Jr : Z;
function Ao(e) {
  const n = typeof e == "function" ? e() : e;
  return to(n);
}
const _e = Ee(
  ({ children: e, container: n, isDisabled: r = !1, onRendered: o }, t) => {
    const [s, a] = Y(null), l = Mo(e.ref, t);
    return ht(() => {
      r || a(Ao(n) || document.body);
    }, [n, r]), ht(() => {
      if (s && !r)
        return Ye(t, s), () => {
          Ye(t, null);
        };
    }, [t, s, r]), ht(() => {
      o && (s || r) && o();
    }, [o, s, r]), r ? (xe.only(e), Nt(e, {
      ref: l
    })) : s && eo(e, s);
  }
);
_e.propTypes = {
  children: i.node,
  container: i.oneOfType([
    i.func,
    i.instanceOf(typeof Element > "u" ? Object : Element)
  ]),
  isDisabled: i.bool,
  onRendered: i.func
};
_e.defaultProps = {
  children: null,
  container: null,
  isDisabled: !1,
  onRendered: null
};
_e.displayName = "Portal";
_e.displayName = "Portal";
const hr = ({ customText: e, customSVG: n, size: r, color: o, thickness: t, isOpen: s, ...a }) => (Z(() => {
  const l = document.querySelector("body");
  s ? oo(l) : io(l);
}, [s]), s ? /* @__PURE__ */ p.jsx(_e, { container: jo.canUseDOM ? document.body : "null", children: /* @__PURE__ */ p.jsxs(
  W,
  {
    alignItems: "center",
    bg: "pageOverlay",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
    transition: "all 0.3s",
    zIndex: 5,
    ...a,
    children: [
      /* @__PURE__ */ p.jsx(Ot, { color: o, customSVG: n, size: r, thickness: t }),
      e && /* @__PURE__ */ p.jsx(ie, { color: o, maxWidth: "100px", textAlign: "center", mt: 4, type: "button", children: e })
    ]
  }
) }) : null);
hr.propTypes = {
  /**
   * Same as `Spinner`
   */
  color: i.string,
  /**
   * Same as `Spinner`
   */
  customSVG: i.string,
  /**
   * If provided, this will be shown below the spinner
   */
  customText: i.string,
  /**
   * If set to true, PageSpinner DOM element will be added to the Portal container (body). When unset, the element will be unmounted
   */
  isOpen: i.bool,
  /**
   * Same as `Spinner`
   */
  size: i.oneOf([Gr, i.string]),
  /**
   * Same as `Spinner`
   */
  thickness: i.string
};
hr.defaultProps = {
  color: "basic.100",
  customSVG: void 0,
  customText: null,
  isOpen: !1,
  size: "medium",
  thickness: "4px"
};
const To = (e, n) => e < n ? "grey.20" : e > n ? "grey.50" : "blue.50", Jt = ({ index: e, label: n, activeStep: r }) => /* @__PURE__ */ p.jsxs(W, { flex: "1", p: "0", position: "relative", userSelect: "none", children: [
  e > 0 && /* @__PURE__ */ p.jsx(
    W,
    {
      left: "calc(-50% + 12px)",
      position: "absolute",
      right: "calc(50% + 12px)",
      top: "12px",
      children: /* @__PURE__ */ p.jsx(W, { borderTop: "1px solid", borderTopColor: "grey.70" })
    }
  ),
  /* @__PURE__ */ p.jsxs(W, { "align-items": "center", d: "flex", flexDirection: "column", children: [
    /* @__PURE__ */ p.jsx(W, { d: "flex", children: /* @__PURE__ */ p.jsxs(W, { d: "inline-block", h: "4", m: "0 auto", w: "4", children: [
      e < r && /* @__PURE__ */ p.jsx(
        fe,
        {
          color: "green.50",
          icon: Lr,
          left: "-1px",
          position: "relative",
          size: "26px",
          top: "-1px"
        }
      ),
      e >= r && /* @__PURE__ */ p.jsx(
        W,
        {
          backgroundColor: `${e > r ? "grey.80" : "blue.50"}`,
          borderRadius: "50%",
          color: `${e > r ? "black" : "white"}`,
          d: "inline-block",
          fontSize: "size12",
          fontWeight: "medium",
          h: "4",
          lineHeight: "size24",
          textAlign: "center",
          w: "4",
          children: e + 1
        }
      )
    ] }) }),
    n && /* @__PURE__ */ p.jsx(W, { d: "flex", justifyContent: "center", w: "100%", children: /* @__PURE__ */ p.jsx(
      W,
      {
        borderBottom: "2px solid",
        borderBottomColor: `${r === e ? "blue.50" : "transparent"}`,
        color: To(e, r),
        fontSize: "size16",
        fontWeight: `${e > r ? "normal" : "bold"}`,
        lineHeight: "1.4",
        mt: "4",
        pb: "8",
        textAlign: "center",
        width: "min(200px, 100%)",
        children: n
      }
    ) })
  ] })
] });
Jt.propTypes = {
  /**
   * Index of active step
   */
  activeStep: i.number.isRequired,
  /**
   * Index of label
   */
  index: i.number.isRequired,
  /**
   * Step label
   */
  label: i.string.isRequired
};
Jt.defaultProps = {};
const Xt = ({ labels: e, activeIndex: n }) => /* @__PURE__ */ p.jsx(W, { alignItems: "flex-start", d: "flex", flexDirection: "row", children: e.map((r, o) => /* @__PURE__ */ p.jsx(
  Jt,
  {
    activeStep: n,
    index: o,
    label: r.label
  },
  r.id
)) });
Xt.propTypes = {
  /**
   * Index of the active label
   */
  activeIndex: i.number.isRequired,
  /**
   * Labels for all the steps
   */
  labels: i.arrayOf(
    i.shape({
      id: i.string.isRequired,
      label: i.string.isRequired
    })
  ).isRequired
};
Xt.defaultProps = {};
Xt.displayName = "Stepper";
const Qt = ({
  children: e,
  backgroundColor: n,
  foregroundColor: r,
  leftIcon: o,
  leftIconColor: t,
  rightIcon: s,
  rightIconColor: a,
  onRightIconClick: l
}) => /* @__PURE__ */ p.jsxs(
  W,
  {
    alignItems: "center",
    bg: n,
    borderRadius: "small",
    color: r,
    display: "inline-grid",
    gridAutoFlow: "column",
    gridGap: 3,
    px: 4,
    py: 2,
    children: [
      o && /* @__PURE__ */ p.jsx(fe, { color: t || r, icon: o }),
      /* @__PURE__ */ p.jsx(ie, { type: "tag", children: e }),
      s && /* @__PURE__ */ p.jsx(
        fe,
        {
          color: a || r,
          cursor: l ? "pointer" : "normal",
          icon: s,
          onClick: () => l && l()
        }
      )
    ]
  }
);
Qt.propTypes = {
  /**
   * Foreground color of the text
   */
  backgroundColor: i.string,
  /**
   * Accepts Text that the tag will display
   */
  children: i.string.isRequired,
  /**
   * Foreground color of the text
   */
  foregroundColor: i.string,
  /**
   * Icon to be rendered on the left of `children` - can only be one of the icons from the list exported from `IconLib`
   */
  leftIcon: i.shape({ render: i.func }),
  /**
   * If left icon is provided, this will set its color.
   */
  leftIconColor: i.string,
  /**
   * Click handler for right icon. Left icon however is only for presentational purposes
   */
  onRightIconClick: i.func,
  /**
   * Icon to be rendered on the right of `children` - can only be one of the icons from the list exported from `IconLib`
   */
  rightIcon: i.shape({ render: i.func }),
  /**
   * If right icon is provided, this will set its color.
   */
  rightIconColor: i.string
};
Qt.defaultProps = {
  backgroundColor: "basic.80",
  foregroundColor: "text.default",
  leftIcon: void 0,
  leftIconColor: void 0,
  onRightIconClick: null,
  rightIcon: void 0,
  rightIconColor: void 0
};
Qt.displayName = "Tag";
var Ue = { exports: {} }, No = Ue.exports, bn;
function Fo() {
  return bn || (bn = 1, function(e, n) {
    (function(r, o) {
      e.exports = o(G);
    })(typeof self < "u" ? self : No, function(r) {
      return function(o) {
        function t(a) {
          if (s[a]) return s[a].exports;
          var l = s[a] = { i: a, l: !1, exports: {} };
          return o[a].call(l.exports, l, l.exports, t), l.l = !0, l.exports;
        }
        var s = {};
        return t.m = o, t.c = s, t.d = function(a, l, u) {
          t.o(a, l) || Object.defineProperty(a, l, { configurable: !1, enumerable: !0, get: u });
        }, t.n = function(a) {
          var l = a && a.__esModule ? function() {
            return a.default;
          } : function() {
            return a;
          };
          return t.d(l, "a", l), l;
        }, t.o = function(a, l) {
          return Object.prototype.hasOwnProperty.call(a, l);
        }, t.p = "", t(t.s = 8);
      }([function(o, t) {
        o.exports = r;
      }, function(o, t, s) {
        function a(b) {
          return new Date(b.getTime());
        }
        function l(b) {
          return b instanceof Date && !isNaN(b.valueOf());
        }
        function u(b, x) {
          var C = a(b);
          return C.setMonth(b.getMonth() + x), C;
        }
        function m(b, x) {
          return !(!b || !x) && b.getDate() === x.getDate() && b.getMonth() === x.getMonth() && b.getFullYear() === x.getFullYear();
        }
        function f(b, x) {
          return !(!b || !x) && b.getMonth() === x.getMonth() && b.getFullYear() === x.getFullYear();
        }
        function E(b, x) {
          return a(b).setHours(0, 0, 0, 0) < a(x).setHours(0, 0, 0, 0);
        }
        function w(b, x) {
          return a(b).setHours(0, 0, 0, 0) > a(x).setHours(0, 0, 0, 0);
        }
        function y(b) {
          var x = /* @__PURE__ */ new Date();
          return x.setHours(0, 0, 0, 0), E(b, x);
        }
        function D(b) {
          var x = new Date((/* @__PURE__ */ new Date()).getTime() + 864e5);
          return x.setHours(0, 0, 0, 0), b >= x;
        }
        function j(b, x, C) {
          var h = a(b);
          return h.setHours(0, 0, 0, 0), w(h, x) && E(h, C) || w(h, C) && E(h, x);
        }
        function P(b) {
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { from: null, to: null }, C = x.from, h = x.to;
          return C ? C && h && m(C, h) && m(b, C) ? (C = null, h = null) : h && E(b, C) ? C = b : h && m(b, h) ? (C = b, h = b) : (h = b, E(h, C) && (h = C, C = b)) : C = b, { from: C, to: h };
        }
        function N(b, x) {
          var C = x.from, h = x.to;
          return C && m(b, C) || h && m(b, h) || C && h && j(b, C, h);
        }
        function M(b) {
          var x = a(b);
          return x.setHours(0, 0, 0), x.setDate(x.getDate() + 4 - (x.getDay() || 7)), Math.ceil(((x - new Date(x.getFullYear(), 0, 1)) / 864e5 + 1) / 7);
        }
        Object.defineProperty(t, "__esModule", { value: !0 }), t.clone = a, t.isDate = l, t.addMonths = u, t.isSameDay = m, t.isSameMonth = f, t.isDayBefore = E, t.isDayAfter = w, t.isPastDay = y, t.isFutureDay = D, t.isDayBetween = j, t.addDayToRange = P, t.isDayInRange = N, t.getWeekNumber = M, t.default = { addDayToRange: P, addMonths: u, clone: a, getWeekNumber: M, isDate: l, isDayAfter: w, isDayBefore: E, isDayBetween: j, isDayInRange: N, isFutureDay: D, isPastDay: y, isSameDay: m, isSameMonth: f };
      }, function(o, t, s) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.LEFT = 37, t.UP = 38, t.RIGHT = 39, t.DOWN = 40, t.ENTER = 13, t.SPACE = 32, t.ESC = 27, t.TAB = 9;
      }, function(o, t, s) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { container: "DayPicker", wrapper: "DayPicker-wrapper", interactionDisabled: "DayPicker--interactionDisabled", months: "DayPicker-Months", month: "DayPicker-Month", navBar: "DayPicker-NavBar", navButtonPrev: "DayPicker-NavButton DayPicker-NavButton--prev", navButtonNext: "DayPicker-NavButton DayPicker-NavButton--next", navButtonInteractionDisabled: "DayPicker-NavButton--interactionDisabled", caption: "DayPicker-Caption", weekdays: "DayPicker-Weekdays", weekdaysRow: "DayPicker-WeekdaysRow", weekday: "DayPicker-Weekday", body: "DayPicker-Body", week: "DayPicker-Week", weekNumber: "DayPicker-WeekNumber", day: "DayPicker-Day", footer: "DayPicker-Footer", todayButton: "DayPicker-TodayButton", today: "today", selected: "selected", disabled: "disabled", outside: "outside" };
      }, function(o, t, s) {
        function a(S) {
          S.preventDefault(), S.stopPropagation();
        }
        function l(S) {
          return new Date(S.getFullYear(), S.getMonth(), 1, 12);
        }
        function u(S) {
          var g = l(S);
          return g.setMonth(g.getMonth() + 1), g.setDate(g.getDate() - 1), g.getDate();
        }
        function m(S) {
          var g = M({}, S.modifiers);
          return S.selectedDays && (g[S.classNames.selected] = S.selectedDays), S.disabledDays && (g[S.classNames.disabled] = S.disabledDays), g;
        }
        function f(S) {
          var g = S.firstDayOfWeek, O = S.locale, v = O === void 0 ? "en" : O, A = S.localeUtils, d = A === void 0 ? {} : A;
          return isNaN(g) ? d.getFirstDayOfWeek ? d.getFirstDayOfWeek(v) : 0 : g;
        }
        function E(S) {
          return !!(S && S.from && S.to);
        }
        function w(S, g) {
          return g.getMonth() - S.getMonth() + 12 * (g.getFullYear() - S.getFullYear());
        }
        function y(S) {
          for (var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, x.getFirstDayOfWeek)(), O = arguments[2], v = u(S), A = [], d = [], c = [], k = 1; k <= v; k += 1) A.push(new Date(S.getFullYear(), S.getMonth(), k, 12));
          A.forEach(function(K) {
            d.length > 0 && K.getDay() === g && (c.push(d), d = []), d.push(K), A.indexOf(K) === A.length - 1 && c.push(d);
          });
          for (var R = c[0], _ = 7 - R.length; _ > 0; _ -= 1) {
            var B = (0, b.clone)(R[0]);
            B.setDate(R[0].getDate() - 1), R.unshift(B);
          }
          for (var I = c[c.length - 1], L = I.length; L < 7; L += 1) {
            var $ = (0, b.clone)(I[I.length - 1]);
            $.setDate(I[I.length - 1].getDate() + 1), I.push($);
          }
          if (O && c.length < 6) for (var U = void 0, F = c.length; F < 6; F += 1) {
            U = c[c.length - 1];
            for (var T = U[U.length - 1], q = [], H = 0; H < 7; H += 1) {
              var V = (0, b.clone)(T);
              V.setDate(T.getDate() + H + 1), q.push(V);
            }
            c.push(q);
          }
          return c;
        }
        function D(S) {
          var g = (0, b.clone)(S);
          return g.setDate(1), g.setHours(12, 0, 0, 0), g;
        }
        function j(S, g) {
          var O = void 0;
          O = g === h.default ? g.day + "--" + g.outside : "" + g.outside;
          var v = g.day.replace(/ /g, "."), A = O.replace(/ /g, "."), d = "." + v + ":not(." + A + ")";
          return S.querySelectorAll(d);
        }
        function P(S) {
          return Array.prototype.slice.call(S, 0);
        }
        function N(S, g) {
          return Object.prototype.hasOwnProperty.call(S, g);
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var M = Object.assign || function(S) {
          for (var g = 1; g < arguments.length; g++) {
            var O = arguments[g];
            for (var v in O) Object.prototype.hasOwnProperty.call(O, v) && (S[v] = O[v]);
          }
          return S;
        };
        t.cancelEvent = a, t.getFirstDayOfMonth = l, t.getDaysInMonth = u, t.getModifiersFromProps = m, t.getFirstDayOfWeekFromProps = f, t.isRangeOfDates = E, t.getMonthsDiff = w, t.getWeekArray = y, t.startOfMonth = D, t.getDayNodes = j, t.nodeListToArray = P, t.hasOwnProp = N;
        var b = s(1), x = s(5), C = s(3), h = function(S) {
          return S && S.__esModule ? S : { default: S };
        }(C);
      }, function(o, t, s) {
        function a(j) {
          return j.toDateString();
        }
        function l(j) {
          return D[j.getMonth()] + " " + j.getFullYear();
        }
        function u(j) {
          return y[j];
        }
        function m(j) {
          return w[j];
        }
        function f() {
          return 0;
        }
        function E() {
          return D;
        }
        Object.defineProperty(t, "__esModule", { value: !0 }), t.formatDay = a, t.formatMonthTitle = l, t.formatWeekdayShort = u, t.formatWeekdayLong = m, t.getFirstDayOfWeek = f, t.getMonths = E;
        var w = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], y = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], D = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        t.default = { formatDay: a, formatMonthTitle: l, formatWeekdayShort: u, formatWeekdayLong: m, getFirstDayOfWeek: f, getMonths: E };
      }, function(o, t, s) {
        function a(f, E) {
          return !!E && (Array.isArray(E) ? E : [E]).some(function(w) {
            return !!w && (w instanceof Date ? (0, u.isSameDay)(f, w) : (0, m.isRangeOfDates)(w) ? (0, u.isDayInRange)(f, w) : w.after && w.before && (0, u.isDayAfter)(w.before, w.after) ? (0, u.isDayAfter)(f, w.after) && (0, u.isDayBefore)(f, w.before) : w.after && w.before && ((0, u.isDayAfter)(w.after, w.before) || (0, u.isSameDay)(w.after, w.before)) ? (0, u.isDayAfter)(f, w.after) || (0, u.isDayBefore)(f, w.before) : w.after ? (0, u.isDayAfter)(f, w.after) : w.before ? (0, u.isDayBefore)(f, w.before) : w.daysOfWeek ? w.daysOfWeek.some(function(y) {
              return f.getDay() === y;
            }) : typeof w == "function" && w(f));
          });
        }
        function l(f) {
          var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return Object.keys(E).reduce(function(w, y) {
            var D = E[y];
            return a(f, D) && w.push(y), w;
          }, []);
        }
        Object.defineProperty(t, "__esModule", { value: !0 }), t.dayMatchesModifier = a, t.getModifiersForDay = l;
        var u = s(1), m = s(4);
        t.default = { dayMatchesModifier: a, getModifiersForDay: l };
      }, function(o, t, s) {
        function a($) {
          if ($ && $.__esModule) return $;
          var U = {};
          if ($ != null) for (var F in $) Object.prototype.hasOwnProperty.call($, F) && (U[F] = $[F]);
          return U.default = $, U;
        }
        function l($) {
          return $ && $.__esModule ? $ : { default: $ };
        }
        function u($, U) {
          var F = {};
          for (var T in $) U.indexOf(T) >= 0 || Object.prototype.hasOwnProperty.call($, T) && (F[T] = $[T]);
          return F;
        }
        function m($, U) {
          if (!($ instanceof U)) throw new TypeError("Cannot call a class as a function");
        }
        function f($, U) {
          if (!$) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !U || typeof U != "object" && typeof U != "function" ? $ : U;
        }
        function E($, U) {
          if (typeof U != "function" && U !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof U);
          $.prototype = Object.create(U && U.prototype, { constructor: { value: $, enumerable: !1, writable: !0, configurable: !0 } }), U && (Object.setPrototypeOf ? Object.setPrototypeOf($, U) : $.__proto__ = U);
        }
        Object.defineProperty(t, "__esModule", { value: !0 }), t.ModifiersUtils = t.LocaleUtils = t.DateUtils = t.DayPicker = void 0;
        var w = Object.assign || function($) {
          for (var U = 1; U < arguments.length; U++) {
            var F = arguments[U];
            for (var T in F) Object.prototype.hasOwnProperty.call(F, T) && ($[T] = F[T]);
          }
          return $;
        }, y = /* @__PURE__ */ function() {
          function $(U, F) {
            for (var T = 0; T < F.length; T++) {
              var q = F[T];
              q.enumerable = q.enumerable || !1, q.configurable = !0, "value" in q && (q.writable = !0), Object.defineProperty(U, q.key, q);
            }
          }
          return function(U, F, T) {
            return F && $(U.prototype, F), T && $(U, T), U;
          };
        }(), D = s(0), j = l(D), P = s(9), N = l(P), M = s(10), b = l(M), x = s(11), C = l(x), h = s(14), S = l(h), g = s(4), O = a(g), v = s(1), A = a(v), d = s(5), c = a(d), k = s(6), R = a(k), _ = s(3), B = l(_), I = s(2), L = t.DayPicker = function($) {
          function U(F) {
            m(this, U);
            var T = f(this, (U.__proto__ || Object.getPrototypeOf(U)).call(this, F));
            T.dayPicker = null, T.showNextMonth = function(H) {
              if (T.allowNextMonth()) {
                var V = T.props.pagedNavigation ? T.props.numberOfMonths : 1, K = A.addMonths(T.state.currentMonth, V);
                T.showMonth(K, H);
              }
            }, T.showPreviousMonth = function(H) {
              if (T.allowPreviousMonth()) {
                var V = T.props.pagedNavigation ? T.props.numberOfMonths : 1, K = A.addMonths(T.state.currentMonth, -V);
                T.showMonth(K, H);
              }
            }, T.handleKeyDown = function(H) {
              switch (H.persist(), H.keyCode) {
                case I.LEFT:
                  T.props.dir === "rtl" ? T.showNextMonth() : T.showPreviousMonth(), O.cancelEvent(H);
                  break;
                case I.RIGHT:
                  T.props.dir === "rtl" ? T.showPreviousMonth() : T.showNextMonth(), O.cancelEvent(H);
                  break;
                case I.UP:
                  T.showPreviousYear(), O.cancelEvent(H);
                  break;
                case I.DOWN:
                  T.showNextYear(), O.cancelEvent(H);
              }
              T.props.onKeyDown && T.props.onKeyDown(H);
            }, T.handleDayKeyDown = function(H, V, K) {
              switch (K.persist(), K.keyCode) {
                case I.LEFT:
                  O.cancelEvent(K), T.props.dir === "rtl" ? T.focusNextDay(K.target) : T.focusPreviousDay(K.target);
                  break;
                case I.RIGHT:
                  O.cancelEvent(K), T.props.dir === "rtl" ? T.focusPreviousDay(K.target) : T.focusNextDay(K.target);
                  break;
                case I.UP:
                  O.cancelEvent(K), T.focusPreviousWeek(K.target);
                  break;
                case I.DOWN:
                  O.cancelEvent(K), T.focusNextWeek(K.target);
                  break;
                case I.ENTER:
                case I.SPACE:
                  O.cancelEvent(K), T.props.onDayClick && T.handleDayClick(H, V, K);
              }
              T.props.onDayKeyDown && T.props.onDayKeyDown(H, V, K);
            }, T.handleDayClick = function(H, V, K) {
              K.persist(), V[T.props.classNames.outside] && T.props.enableOutsideDaysClick && T.handleOutsideDayClick(H), T.props.onDayClick && T.props.onDayClick(H, V, K);
            }, T.handleTodayButtonClick = function(H) {
              var V = /* @__PURE__ */ new Date(), K = new Date(V.getFullYear(), V.getMonth());
              T.showMonth(K), H.target.blur(), T.props.onTodayButtonClick && (H.persist(), T.props.onTodayButtonClick(new Date(V.getFullYear(), V.getMonth(), V.getDate()), R.getModifiersForDay(V, T.props.modifiers), H));
            };
            var q = T.getCurrentMonthFromProps(F);
            return T.state = { currentMonth: q }, T;
          }
          return E(U, $), y(U, [{ key: "componentDidUpdate", value: function(F) {
            if (F.month !== this.props.month && !A.isSameMonth(F.month, this.props.month)) {
              var T = this.getCurrentMonthFromProps(this.props);
              this.setState({ currentMonth: T });
            }
          } }, { key: "getCurrentMonthFromProps", value: function(F) {
            var T = O.startOfMonth(F.month || F.initialMonth || /* @__PURE__ */ new Date()), q = T;
            if (F.pagedNavigation && F.numberOfMonths > 1 && F.fromMonth) {
              var H = O.startOfMonth(F.fromMonth), V = O.getMonthsDiff(H, q);
              q = A.addMonths(H, Math.floor(V / F.numberOfMonths) * F.numberOfMonths);
            } else F.toMonth && F.numberOfMonths > 1 && O.getMonthsDiff(q, F.toMonth) <= 0 && (q = A.addMonths(O.startOfMonth(F.toMonth), 1 - this.props.numberOfMonths));
            return q;
          } }, { key: "getNextNavigableMonth", value: function() {
            return A.addMonths(this.state.currentMonth, this.props.numberOfMonths);
          } }, { key: "getPreviousNavigableMonth", value: function() {
            return A.addMonths(this.state.currentMonth, -1);
          } }, { key: "allowPreviousMonth", value: function() {
            var F = A.addMonths(this.state.currentMonth, -1);
            return this.allowMonth(F);
          } }, { key: "allowNextMonth", value: function() {
            var F = A.addMonths(this.state.currentMonth, this.props.numberOfMonths);
            return this.allowMonth(F);
          } }, { key: "allowMonth", value: function(F) {
            var T = this.props, q = T.fromMonth, H = T.toMonth;
            return !(!T.canChangeMonth || q && O.getMonthsDiff(q, F) < 0 || H && O.getMonthsDiff(H, F) > 0);
          } }, { key: "allowYearChange", value: function() {
            return this.props.canChangeMonth;
          } }, { key: "showMonth", value: function(F, T) {
            var q = this;
            this.allowMonth(F) && this.setState({ currentMonth: O.startOfMonth(F) }, function() {
              T && T(), q.props.onMonthChange && q.props.onMonthChange(q.state.currentMonth);
            });
          } }, { key: "showNextYear", value: function() {
            if (this.allowYearChange()) {
              var F = A.addMonths(this.state.currentMonth, 12);
              this.showMonth(F);
            }
          } }, { key: "showPreviousYear", value: function() {
            if (this.allowYearChange()) {
              var F = A.addMonths(this.state.currentMonth, -12);
              this.showMonth(F);
            }
          } }, { key: "focus", value: function() {
            this.wrapper.focus();
          } }, { key: "focusFirstDayOfMonth", value: function() {
            O.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
          } }, { key: "focusLastDayOfMonth", value: function() {
            var F = O.getDayNodes(this.dayPicker, this.props.classNames);
            F[F.length - 1].focus();
          } }, { key: "focusPreviousDay", value: function(F) {
            var T = this, q = O.getDayNodes(this.dayPicker, this.props.classNames), H = O.nodeListToArray(q).indexOf(F);
            H !== -1 && (H === 0 ? this.showPreviousMonth(function() {
              return T.focusLastDayOfMonth();
            }) : q[H - 1].focus());
          } }, { key: "focusNextDay", value: function(F) {
            var T = this, q = O.getDayNodes(this.dayPicker, this.props.classNames), H = O.nodeListToArray(q).indexOf(F);
            H !== -1 && (H === q.length - 1 ? this.showNextMonth(function() {
              return T.focusFirstDayOfMonth();
            }) : q[H + 1].focus());
          } }, { key: "focusNextWeek", value: function(F) {
            var T = this, q = O.getDayNodes(this.dayPicker, this.props.classNames), H = O.nodeListToArray(q).indexOf(F);
            H > q.length - 8 ? this.showNextMonth(function() {
              var V = q.length - H, K = 7 - V;
              O.getDayNodes(T.dayPicker, T.props.classNames)[K].focus();
            }) : q[H + 7].focus();
          } }, { key: "focusPreviousWeek", value: function(F) {
            var T = this, q = O.getDayNodes(this.dayPicker, this.props.classNames), H = O.nodeListToArray(q).indexOf(F);
            H <= 6 ? this.showPreviousMonth(function() {
              var V = O.getDayNodes(T.dayPicker, T.props.classNames);
              V[V.length - 7 + H].focus();
            }) : q[H - 7].focus();
          } }, { key: "handleOutsideDayClick", value: function(F) {
            var T = this.state.currentMonth, q = this.props.numberOfMonths, H = O.getMonthsDiff(T, F);
            H > 0 && H >= q ? this.showNextMonth() : H < 0 && this.showPreviousMonth();
          } }, { key: "renderNavbar", value: function() {
            var F = this.props, T = F.labels, q = F.locale, H = F.localeUtils, V = F.canChangeMonth, K = F.navbarElement, ne = u(F, ["labels", "locale", "localeUtils", "canChangeMonth", "navbarElement"]);
            if (!V) return null;
            var ae = { month: this.state.currentMonth, classNames: this.props.classNames, className: this.props.classNames.navBar, nextMonth: this.getNextNavigableMonth(), previousMonth: this.getPreviousNavigableMonth(), showPreviousButton: this.allowPreviousMonth(), showNextButton: this.allowNextMonth(), onNextClick: this.showNextMonth, onPreviousClick: this.showPreviousMonth, dir: ne.dir, labels: T, locale: q, localeUtils: H };
            return j.default.isValidElement(K) ? j.default.cloneElement(K, ae) : j.default.createElement(K, ae);
          } }, { key: "renderMonths", value: function() {
            for (var F = [], T = O.getFirstDayOfWeekFromProps(this.props), q = 0; q < this.props.numberOfMonths; q += 1) {
              var H = A.addMonths(this.state.currentMonth, q);
              F.push(j.default.createElement(C.default, w({ key: q }, this.props, { month: H, firstDayOfWeek: T, onDayKeyDown: this.handleDayKeyDown, onDayClick: this.handleDayClick })));
            }
            return this.props.reverseMonths && F.reverse(), F;
          } }, { key: "renderFooter", value: function() {
            return this.props.todayButton ? j.default.createElement("div", { className: this.props.classNames.footer }, this.renderTodayButton()) : null;
          } }, { key: "renderTodayButton", value: function() {
            return j.default.createElement("button", { type: "button", tabIndex: 0, className: this.props.classNames.todayButton, "aria-label": this.props.todayButton, onClick: this.handleTodayButtonClick }, this.props.todayButton);
          } }, { key: "render", value: function() {
            var F = this, T = this.props.classNames.container;
            return this.props.onDayClick || (T = T + " " + this.props.classNames.interactionDisabled), this.props.className && (T = T + " " + this.props.className), j.default.createElement("div", w({}, this.props.containerProps, { className: T, ref: function(q) {
              return F.dayPicker = q;
            }, lang: this.props.locale }), j.default.createElement("div", { className: this.props.classNames.wrapper, ref: function(q) {
              return F.wrapper = q;
            }, tabIndex: this.props.canChangeMonth && this.props.tabIndex !== void 0 ? this.props.tabIndex : -1, onKeyDown: this.handleKeyDown, onFocus: this.props.onFocus, onBlur: this.props.onBlur }, this.renderNavbar(), j.default.createElement("div", { className: this.props.classNames.months }, this.renderMonths()), this.renderFooter()));
          } }]), U;
        }(D.Component);
        L.defaultProps = { classNames: B.default, tabIndex: 0, numberOfMonths: 1, labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, locale: "en", localeUtils: c, showOutsideDays: !1, enableOutsideDaysClick: !0, fixedWeeks: !1, canChangeMonth: !0, reverseMonths: !1, pagedNavigation: !1, showWeekNumbers: !1, showWeekDays: !0, renderDay: function($) {
          return $.getDate();
        }, renderWeek: function($) {
          return $;
        }, weekdayElement: j.default.createElement(S.default, null), navbarElement: j.default.createElement(b.default, { classNames: B.default }), captionElement: j.default.createElement(N.default, { classNames: B.default }) }, L.VERSION = "7.4.10", L.DateUtils = A, L.LocaleUtils = c, L.ModifiersUtils = R, t.DateUtils = A, t.LocaleUtils = c, t.ModifiersUtils = R, t.default = L;
      }, function(o, t, s) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = s(7).default;
        a.Input = s(15).default, t.default = a;
      }, function(o, t, s) {
        function a(N) {
          return N && N.__esModule ? N : { default: N };
        }
        function l(N, M) {
          if (!(N instanceof M)) throw new TypeError("Cannot call a class as a function");
        }
        function u(N, M) {
          if (!N) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !M || typeof M != "object" && typeof M != "function" ? N : M;
        }
        function m(N, M) {
          if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof M);
          N.prototype = Object.create(M && M.prototype, { constructor: { value: N, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(N, M) : N.__proto__ = M);
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var f = /* @__PURE__ */ function() {
          function N(M, b) {
            for (var x = 0; x < b.length; x++) {
              var C = b[x];
              C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(M, C.key, C);
            }
          }
          return function(M, b, x) {
            return b && N(M.prototype, b), x && N(M, x), M;
          };
        }(), E = s(0), w = a(E), y = s(5), D = a(y), j = s(2), P = function(N) {
          function M(b) {
            l(this, M);
            var x = u(this, (M.__proto__ || Object.getPrototypeOf(M)).call(this, b));
            return x.handleKeyUp = x.handleKeyUp.bind(x), x;
          }
          return m(M, N), f(M, [{ key: "shouldComponentUpdate", value: function(b) {
            return b.locale !== this.props.locale || b.classNames !== this.props.classNames || b.date.getMonth() !== this.props.date.getMonth() || b.date.getFullYear() !== this.props.date.getFullYear();
          } }, { key: "handleKeyUp", value: function(b) {
            b.keyCode === j.ENTER && this.props.onClick(b);
          } }, { key: "render", value: function() {
            var b = this.props, x = b.classNames, C = b.date, h = b.months, S = b.locale, g = b.localeUtils, O = b.onClick;
            return w.default.createElement("div", { className: x.caption, role: "heading", "aria-live": "polite" }, w.default.createElement("div", { onClick: O, onKeyUp: this.handleKeyUp }, h ? h[C.getMonth()] + " " + C.getFullYear() : g.formatMonthTitle(C, S)));
          } }]), M;
        }(E.Component);
        P.defaultProps = { localeUtils: D.default }, t.default = P;
      }, function(o, t, s) {
        function a(N) {
          return N && N.__esModule ? N : { default: N };
        }
        function l(N, M) {
          if (!(N instanceof M)) throw new TypeError("Cannot call a class as a function");
        }
        function u(N, M) {
          if (!N) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !M || typeof M != "object" && typeof M != "function" ? N : M;
        }
        function m(N, M) {
          if (typeof M != "function" && M !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof M);
          N.prototype = Object.create(M && M.prototype, { constructor: { value: N, enumerable: !1, writable: !0, configurable: !0 } }), M && (Object.setPrototypeOf ? Object.setPrototypeOf(N, M) : N.__proto__ = M);
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var f = /* @__PURE__ */ function() {
          function N(M, b) {
            for (var x = 0; x < b.length; x++) {
              var C = b[x];
              C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(M, C.key, C);
            }
          }
          return function(M, b, x) {
            return b && N(M.prototype, b), x && N(M, x), M;
          };
        }(), E = s(0), w = a(E), y = s(3), D = a(y), j = s(2), P = function(N) {
          function M() {
            var b, x, C, h;
            l(this, M);
            for (var S = arguments.length, g = Array(S), O = 0; O < S; O++) g[O] = arguments[O];
            return x = C = u(this, (b = M.__proto__ || Object.getPrototypeOf(M)).call.apply(b, [this].concat(g))), C.handleNextClick = function() {
              C.props.onNextClick && C.props.onNextClick();
            }, C.handlePreviousClick = function() {
              C.props.onPreviousClick && C.props.onPreviousClick();
            }, C.handleNextKeyDown = function(v) {
              v.keyCode !== j.ENTER && v.keyCode !== j.SPACE || (v.preventDefault(), C.handleNextClick());
            }, C.handlePreviousKeyDown = function(v) {
              v.keyCode !== j.ENTER && v.keyCode !== j.SPACE || (v.preventDefault(), C.handlePreviousClick());
            }, h = x, u(C, h);
          }
          return m(M, N), f(M, [{ key: "shouldComponentUpdate", value: function(b) {
            return b.labels !== this.props.labels || b.dir !== this.props.dir || this.props.showPreviousButton !== b.showPreviousButton || this.props.showNextButton !== b.showNextButton;
          } }, { key: "render", value: function() {
            var b = this.props, x = b.classNames, C = b.className, h = b.showPreviousButton, S = b.showNextButton, g = b.labels, O = b.dir, v = void 0, A = void 0, d = void 0, c = void 0, k = void 0, R = void 0;
            O === "rtl" ? (v = this.handleNextClick, A = this.handlePreviousClick, d = this.handleNextKeyDown, c = this.handlePreviousKeyDown, R = h, k = S) : (v = this.handlePreviousClick, A = this.handleNextClick, d = this.handlePreviousKeyDown, c = this.handleNextKeyDown, R = S, k = h);
            var _ = k ? x.navButtonPrev : x.navButtonPrev + " " + x.navButtonInteractionDisabled, B = R ? x.navButtonNext : x.navButtonNext + " " + x.navButtonInteractionDisabled, I = w.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": g.previousMonth, key: "previous", className: _, onKeyDown: k ? d : void 0, onClick: k ? v : void 0 }), L = w.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": g.nextMonth, key: "right", className: B, onKeyDown: R ? c : void 0, onClick: R ? A : void 0 });
            return w.default.createElement("div", { className: C || x.navBar }, O === "rtl" ? [L, I] : [I, L]);
          } }]), M;
        }(E.Component);
        P.defaultProps = { classNames: D.default, dir: "ltr", labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, showPreviousButton: !0, showNextButton: !0 }, t.default = P;
      }, function(o, t, s) {
        function a(v) {
          if (v && v.__esModule) return v;
          var A = {};
          if (v != null) for (var d in v) Object.prototype.hasOwnProperty.call(v, d) && (A[d] = v[d]);
          return A.default = v, A;
        }
        function l(v) {
          return v && v.__esModule ? v : { default: v };
        }
        function u(v, A) {
          if (!(v instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function m(v, A) {
          if (!v) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !A || typeof A != "object" && typeof A != "function" ? v : A;
        }
        function f(v, A) {
          if (typeof A != "function" && A !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof A);
          v.prototype = Object.create(A && A.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), A && (Object.setPrototypeOf ? Object.setPrototypeOf(v, A) : v.__proto__ = A);
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var E = /* @__PURE__ */ function() {
          function v(A, d) {
            for (var c = 0; c < d.length; c++) {
              var k = d[c];
              k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(A, k.key, k);
            }
          }
          return function(A, d, c) {
            return d && v(A.prototype, d), c && v(A, c), A;
          };
        }(), w = s(0), y = l(w), D = s(12), j = l(D), P = s(13), N = l(P), M = s(2), b = s(6), x = a(b), C = s(4), h = a(C), S = s(1), g = a(S), O = function(v) {
          function A() {
            var d, c, k, R;
            u(this, A);
            for (var _ = arguments.length, B = Array(_), I = 0; I < _; I++) B[I] = arguments[I];
            return c = k = m(this, (d = A.__proto__ || Object.getPrototypeOf(A)).call.apply(d, [this].concat(B))), k.renderDay = function(L) {
              var $ = k.props.month.getMonth(), U = h.getModifiersFromProps(k.props), F = x.getModifiersForDay(L, U);
              g.isSameDay(L, /* @__PURE__ */ new Date()) && !Object.prototype.hasOwnProperty.call(U, k.props.classNames.today) && F.push(k.props.classNames.today), L.getMonth() !== $ && F.push(k.props.classNames.outside);
              var T = L.getMonth() !== $, q = -1;
              k.props.onDayClick && !T && L.getDate() === 1 && (q = k.props.tabIndex);
              var H = "" + L.getFullYear() + L.getMonth() + L.getDate(), V = {};
              return F.forEach(function(K) {
                V[K] = !0;
              }), y.default.createElement(N.default, { key: (T ? "outside-" : "") + H, classNames: k.props.classNames, day: L, modifiers: V, modifiersStyles: k.props.modifiersStyles, empty: T && !k.props.showOutsideDays && !k.props.fixedWeeks, tabIndex: q, ariaLabel: k.props.localeUtils.formatDay(L, k.props.locale), ariaDisabled: T || F.indexOf(k.props.classNames.disabled) > -1, ariaSelected: F.indexOf(k.props.classNames.selected) > -1, onClick: k.props.onDayClick, onFocus: k.props.onDayFocus, onKeyDown: k.props.onDayKeyDown, onMouseEnter: k.props.onDayMouseEnter, onMouseLeave: k.props.onDayMouseLeave, onMouseDown: k.props.onDayMouseDown, onMouseUp: k.props.onDayMouseUp, onTouchEnd: k.props.onDayTouchEnd, onTouchStart: k.props.onDayTouchStart }, k.props.renderDay(L, V));
            }, R = c, m(k, R);
          }
          return f(A, v), E(A, [{ key: "render", value: function() {
            var d = this, c = this.props, k = c.classNames, R = c.month, _ = c.months, B = c.fixedWeeks, I = c.captionElement, L = c.weekdayElement, $ = c.locale, U = c.localeUtils, F = c.weekdaysLong, T = c.weekdaysShort, q = c.firstDayOfWeek, H = c.onCaptionClick, V = c.showWeekNumbers, K = c.showWeekDays, ne = c.onWeekClick, ae = { date: R, classNames: k, months: _, localeUtils: U, locale: $, onClick: H ? function(ee) {
              return H(R, ee);
            } : void 0 }, ge = y.default.isValidElement(I) ? y.default.cloneElement(I, ae) : y.default.createElement(I, ae), de = h.getWeekArray(R, q, B);
            return y.default.createElement("div", { className: k.month, role: "grid" }, ge, K && y.default.createElement(j.default, { classNames: k, weekdaysShort: T, weekdaysLong: F, firstDayOfWeek: q, showWeekNumbers: V, locale: $, localeUtils: U, weekdayElement: L }), y.default.createElement("div", { className: k.body, role: "rowgroup" }, de.map(function(ee) {
              var te = void 0;
              return V && (te = g.getWeekNumber(ee[6])), y.default.createElement("div", { key: ee[0].getTime(), className: k.week, role: "row" }, V && y.default.createElement("div", { className: k.weekNumber, tabIndex: ne ? 0 : -1, role: "gridcell", onClick: ne ? function(le) {
                return ne(te, ee, le);
              } : void 0, onKeyUp: ne ? function(le) {
                return le.keyCode === M.ENTER && ne(te, ee, le);
              } : void 0 }, d.props.renderWeek(te, ee, R)), ee.map(d.renderDay));
            })));
          } }]), A;
        }(w.Component);
        t.default = O;
      }, function(o, t, s) {
        function a(y, D) {
          if (!(y instanceof D)) throw new TypeError("Cannot call a class as a function");
        }
        function l(y, D) {
          if (!y) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !D || typeof D != "object" && typeof D != "function" ? y : D;
        }
        function u(y, D) {
          if (typeof D != "function" && D !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof D);
          y.prototype = Object.create(D && D.prototype, { constructor: { value: y, enumerable: !1, writable: !0, configurable: !0 } }), D && (Object.setPrototypeOf ? Object.setPrototypeOf(y, D) : y.__proto__ = D);
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var m = /* @__PURE__ */ function() {
          function y(D, j) {
            for (var P = 0; P < j.length; P++) {
              var N = j[P];
              N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(D, N.key, N);
            }
          }
          return function(D, j, P) {
            return j && y(D.prototype, j), P && y(D, P), D;
          };
        }(), f = s(0), E = function(y) {
          return y && y.__esModule ? y : { default: y };
        }(f), w = function(y) {
          function D() {
            return a(this, D), l(this, (D.__proto__ || Object.getPrototypeOf(D)).apply(this, arguments));
          }
          return u(D, y), m(D, [{ key: "shouldComponentUpdate", value: function(j) {
            return this.props !== j;
          } }, { key: "render", value: function() {
            for (var j = this.props, P = j.classNames, N = j.firstDayOfWeek, M = j.showWeekNumbers, b = j.weekdaysLong, x = j.weekdaysShort, C = j.locale, h = j.localeUtils, S = j.weekdayElement, g = [], O = 0; O < 7; O += 1) {
              var v = (O + N) % 7, A = { key: O, className: P.weekday, weekday: v, weekdaysLong: b, weekdaysShort: x, localeUtils: h, locale: C }, d = E.default.isValidElement(S) ? E.default.cloneElement(S, A) : E.default.createElement(S, A);
              g.push(d);
            }
            return E.default.createElement("div", { className: P.weekdays, role: "rowgroup" }, E.default.createElement("div", { className: P.weekdaysRow, role: "row" }, M && E.default.createElement("div", { className: P.weekday }), g));
          } }]), D;
        }(f.Component);
        t.default = w;
      }, function(o, t, s) {
        function a(x) {
          return x && x.__esModule ? x : { default: x };
        }
        function l(x, C) {
          if (!(x instanceof C)) throw new TypeError("Cannot call a class as a function");
        }
        function u(x, C) {
          if (!x) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !C || typeof C != "object" && typeof C != "function" ? x : C;
        }
        function m(x, C) {
          if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof C);
          x.prototype = Object.create(C && C.prototype, { constructor: { value: x, enumerable: !1, writable: !0, configurable: !0 } }), C && (Object.setPrototypeOf ? Object.setPrototypeOf(x, C) : x.__proto__ = C);
        }
        function f(x, C, h) {
          if (x) return function(S) {
            S.persist(), x(C, h, S);
          };
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var E = Object.assign || function(x) {
          for (var C = 1; C < arguments.length; C++) {
            var h = arguments[C];
            for (var S in h) Object.prototype.hasOwnProperty.call(h, S) && (x[S] = h[S]);
          }
          return x;
        }, w = /* @__PURE__ */ function() {
          function x(C, h) {
            for (var S = 0; S < h.length; S++) {
              var g = h[S];
              g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(C, g.key, g);
            }
          }
          return function(C, h, S) {
            return h && x(C.prototype, h), S && x(C, S), C;
          };
        }(), y = s(0), D = a(y), j = s(1), P = s(4), N = s(3), M = a(N), b = function(x) {
          function C() {
            return l(this, C), u(this, (C.__proto__ || Object.getPrototypeOf(C)).apply(this, arguments));
          }
          return m(C, x), w(C, [{ key: "shouldComponentUpdate", value: function(h) {
            var S = this, g = Object.keys(this.props), O = Object.keys(h);
            return g.length !== O.length || g.some(function(v) {
              if (v === "modifiers" || v === "modifiersStyles" || v === "classNames") {
                var A = S.props[v], d = h[v], c = Object.keys(A), k = Object.keys(d);
                return c.length !== k.length || c.some(function(R) {
                  return !(0, P.hasOwnProp)(d, R) || A[R] !== d[R];
                });
              }
              return v === "day" ? !(0, j.isSameDay)(S.props[v], h[v]) : !(0, P.hasOwnProp)(h, v) || S.props[v] !== h[v];
            });
          } }, { key: "render", value: function() {
            var h = this.props, S = h.classNames, g = h.modifiersStyles, O = h.day, v = h.tabIndex, A = h.empty, d = h.modifiers, c = h.onMouseEnter, k = h.onMouseLeave, R = h.onMouseUp, _ = h.onMouseDown, B = h.onClick, I = h.onKeyDown, L = h.onTouchStart, $ = h.onTouchEnd, U = h.onFocus, F = h.ariaLabel, T = h.ariaDisabled, q = h.ariaSelected, H = h.children, V = S.day;
            S !== M.default ? V += " " + Object.keys(d).join(" ") : V += Object.keys(d).map(function(ne) {
              return " " + V + "--" + ne;
            }).join("");
            var K = void 0;
            return g && Object.keys(d).filter(function(ne) {
              return !!g[ne];
            }).forEach(function(ne) {
              K = E({}, K, g[ne]);
            }), A ? D.default.createElement("div", { "aria-disabled": !0, className: V, style: K }) : D.default.createElement("div", { className: V, tabIndex: v, style: K, role: "gridcell", "aria-label": F, "aria-disabled": T, "aria-selected": q, onClick: f(B, O, d), onKeyDown: f(I, O, d), onMouseEnter: f(c, O, d), onMouseLeave: f(k, O, d), onMouseUp: f(R, O, d), onMouseDown: f(_, O, d), onTouchEnd: f($, O, d), onTouchStart: f(L, O, d), onFocus: f(U, O, d) }, H);
          } }]), C;
        }(y.Component);
        b.defaultProps = { tabIndex: -1 }, b.defaultProps = { modifiers: {}, modifiersStyles: {}, empty: !1 }, t.default = b;
      }, function(o, t, s) {
        function a(y, D) {
          if (!(y instanceof D)) throw new TypeError("Cannot call a class as a function");
        }
        function l(y, D) {
          if (!y) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !D || typeof D != "object" && typeof D != "function" ? y : D;
        }
        function u(y, D) {
          if (typeof D != "function" && D !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof D);
          y.prototype = Object.create(D && D.prototype, { constructor: { value: y, enumerable: !1, writable: !0, configurable: !0 } }), D && (Object.setPrototypeOf ? Object.setPrototypeOf(y, D) : y.__proto__ = D);
        }
        Object.defineProperty(t, "__esModule", { value: !0 });
        var m = /* @__PURE__ */ function() {
          function y(D, j) {
            for (var P = 0; P < j.length; P++) {
              var N = j[P];
              N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(D, N.key, N);
            }
          }
          return function(D, j, P) {
            return j && y(D.prototype, j), P && y(D, P), D;
          };
        }(), f = s(0), E = function(y) {
          return y && y.__esModule ? y : { default: y };
        }(f), w = function(y) {
          function D() {
            return a(this, D), l(this, (D.__proto__ || Object.getPrototypeOf(D)).apply(this, arguments));
          }
          return u(D, y), m(D, [{ key: "shouldComponentUpdate", value: function(j) {
            return this.props !== j;
          } }, { key: "render", value: function() {
            var j = this.props, P = j.weekday, N = j.className, M = j.weekdaysLong, b = j.weekdaysShort, x = j.localeUtils, C = j.locale, h = void 0;
            h = M ? M[P] : x.formatWeekdayLong(P, C);
            var S = void 0;
            return S = b ? b[P] : x.formatWeekdayShort(P, C), E.default.createElement("div", { className: N, role: "columnheader" }, E.default.createElement("abbr", { title: h }, S));
          } }]), D;
        }(f.Component);
        t.default = w;
      }, function(o, t, s) {
        function a(v) {
          return v && v.__esModule ? v : { default: v };
        }
        function l(v, A, d) {
          return A in v ? Object.defineProperty(v, A, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : v[A] = d, v;
        }
        function u(v, A) {
          if (!(v instanceof A)) throw new TypeError("Cannot call a class as a function");
        }
        function m(v, A) {
          if (!v) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !A || typeof A != "object" && typeof A != "function" ? v : A;
        }
        function f(v, A) {
          if (typeof A != "function" && A !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof A);
          v.prototype = Object.create(A && A.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), A && (Object.setPrototypeOf ? Object.setPrototypeOf(v, A) : v.__proto__ = A);
        }
        function E(v, A) {
          var d = {};
          for (var c in v) A.indexOf(c) >= 0 || Object.prototype.hasOwnProperty.call(v, c) && (d[c] = v[c]);
          return d;
        }
        function w(v) {
          var A = (v.input, v.selectedDay, v.month, v.children), d = v.classNames, c = E(v, ["input", "selectedDay", "month", "children", "classNames"]);
          return M.default.createElement("div", P({ className: d.overlayWrapper }, c), M.default.createElement("div", { className: d.overlay }, A));
        }
        function y(v) {
          return (0, C.isDate)(v) ? v.getFullYear() + "-" + ("" + (v.getMonth() + 1)) + "-" + ("" + v.getDate()) : "";
        }
        function D(v) {
          if (typeof v == "string") {
            var A = v.split("-");
            if (A.length === 3) {
              var d = parseInt(A[0], 10), c = parseInt(A[1], 10) - 1, k = parseInt(A[2], 10);
              if (!(isNaN(d) || String(d).length > 4 || isNaN(c) || isNaN(k) || k <= 0 || k > 31 || c < 0 || c >= 12)) return new Date(d, c, k, 12, 0, 0, 0);
            }
          }
        }
        Object.defineProperty(t, "__esModule", { value: !0 }), t.HIDE_TIMEOUT = void 0;
        var j = /* @__PURE__ */ function() {
          function v(A, d) {
            for (var c = 0; c < d.length; c++) {
              var k = d[c];
              k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(A, k.key, k);
            }
          }
          return function(A, d, c) {
            return d && v(A.prototype, d), c && v(A, c), A;
          };
        }(), P = Object.assign || function(v) {
          for (var A = 1; A < arguments.length; A++) {
            var d = arguments[A];
            for (var c in d) Object.prototype.hasOwnProperty.call(d, c) && (v[c] = d[c]);
          }
          return v;
        };
        t.OverlayComponent = w, t.defaultFormat = y, t.defaultParse = D;
        var N = s(0), M = a(N), b = s(7), x = a(b), C = s(1), h = s(6), S = s(2), g = t.HIDE_TIMEOUT = 100, O = function(v) {
          function A(d) {
            u(this, A);
            var c = m(this, (A.__proto__ || Object.getPrototypeOf(A)).call(this, d));
            return c.input = null, c.daypicker = null, c.clickTimeout = null, c.hideTimeout = null, c.inputBlurTimeout = null, c.inputFocusTimeout = null, c.state = c.getInitialStateFromProps(d), c.state.showOverlay = d.showOverlay, c.hideAfterDayClick = c.hideAfterDayClick.bind(c), c.handleInputClick = c.handleInputClick.bind(c), c.handleInputFocus = c.handleInputFocus.bind(c), c.handleInputBlur = c.handleInputBlur.bind(c), c.handleInputChange = c.handleInputChange.bind(c), c.handleInputKeyDown = c.handleInputKeyDown.bind(c), c.handleInputKeyUp = c.handleInputKeyUp.bind(c), c.handleDayClick = c.handleDayClick.bind(c), c.handleMonthChange = c.handleMonthChange.bind(c), c.handleOverlayFocus = c.handleOverlayFocus.bind(c), c.handleOverlayBlur = c.handleOverlayBlur.bind(c), c;
          }
          return f(A, v), j(A, [{ key: "componentDidUpdate", value: function(d) {
            var c = {}, k = this.props, R = k.value, _ = k.formatDate, B = k.format, I = k.dayPickerProps;
            R === d.value && I.locale === d.dayPickerProps.locale && B === d.format || ((0, C.isDate)(R) ? c.value = _(R, B, I.locale) : c.value = R);
            var L = d.dayPickerProps.month;
            I.month && I.month !== L && !(0, C.isSameMonth)(I.month, L) && (c.month = I.month), d.dayPickerProps.selectedDays !== I.selectedDays && (c.selectedDays = I.selectedDays), Object.keys(c).length > 0 && this.setState(c);
          } }, { key: "componentWillUnmount", value: function() {
            clearTimeout(this.clickTimeout), clearTimeout(this.hideTimeout), clearTimeout(this.inputFocusTimeout), clearTimeout(this.inputBlurTimeout), clearTimeout(this.overlayBlurTimeout);
          } }, { key: "getInitialMonthFromProps", value: function(d) {
            var c = d.dayPickerProps, k = d.format, R = void 0;
            return d.value && (R = (0, C.isDate)(d.value) ? d.value : d.parseDate(d.value, k, c.locale)), c.initialMonth || c.month || R || /* @__PURE__ */ new Date();
          } }, { key: "getInitialStateFromProps", value: function(d) {
            var c = d.dayPickerProps, k = d.formatDate, R = d.format, _ = d.typedValue, B = d.value;
            return d.value && (0, C.isDate)(d.value) && (B = k(d.value, R, c.locale)), { value: B, typedValue: _, month: this.getInitialMonthFromProps(d), selectedDays: c.selectedDays };
          } }, { key: "getInput", value: function() {
            return this.input;
          } }, { key: "getDayPicker", value: function() {
            return this.daypicker;
          } }, { key: "updateState", value: function(d, c, k) {
            var R = this, _ = this.props, B = _.dayPickerProps, I = _.onDayChange;
            this.setState({ month: d, value: c, typedValue: "" }, function() {
              if (k && k(), I) {
                var L = P({ disabled: B.disabledDays, selected: B.selectedDays }, B.modifiers), $ = (0, h.getModifiersForDay)(d, L).reduce(function(U, F) {
                  return P({}, U, l({}, F, !0));
                }, {});
                I(d, $, R);
              }
            });
          } }, { key: "showDayPicker", value: function() {
            var d = this, c = this.props, k = c.parseDate, R = c.format, _ = c.dayPickerProps, B = this.state, I = B.value;
            if (!B.showOverlay) {
              var L = I ? k(I, R, _.locale) : this.getInitialMonthFromProps(this.props);
              this.setState(function($) {
                return { showOverlay: !0, month: L || $.month };
              }, function() {
                d.props.onDayPickerShow && d.props.onDayPickerShow();
              });
            }
          } }, { key: "hideDayPicker", value: function() {
            var d = this;
            this.state.showOverlay !== !1 && this.setState({ showOverlay: !1 }, function() {
              d.props.onDayPickerHide && d.props.onDayPickerHide();
            });
          } }, { key: "hideAfterDayClick", value: function() {
            var d = this;
            this.props.hideOnDayClick && (this.hideTimeout = setTimeout(function() {
              d.overlayHasFocus = !1, d.hideDayPicker();
            }, g));
          } }, { key: "handleInputClick", value: function(d) {
            this.showDayPicker(), this.props.inputProps.onClick && (d.persist(), this.props.inputProps.onClick(d));
          } }, { key: "handleInputFocus", value: function(d) {
            var c = this;
            this.showDayPicker(), this.inputFocusTimeout = setTimeout(function() {
              c.overlayHasFocus = !1;
            }, 2), this.props.inputProps.onFocus && (d.persist(), this.props.inputProps.onFocus(d));
          } }, { key: "handleInputBlur", value: function(d) {
            var c = this;
            this.inputBlurTimeout = setTimeout(function() {
              c.overlayHasFocus || c.hideDayPicker();
            }, 1), this.props.inputProps.onBlur && (d.persist(), this.props.inputProps.onBlur(d));
          } }, { key: "handleOverlayFocus", value: function(d) {
            d.preventDefault(), this.overlayHasFocus = !0, this.props.keepFocus && this.input && typeof this.input.focus == "function" && this.input.focus();
          } }, { key: "handleOverlayBlur", value: function() {
            var d = this;
            this.overlayBlurTimeout = setTimeout(function() {
              d.overlayHasFocus = !1;
            }, 3);
          } }, { key: "handleInputChange", value: function(d) {
            var c = this.props, k = c.dayPickerProps, R = c.format, _ = c.inputProps, B = c.onDayChange, I = c.parseDate;
            _.onChange && (d.persist(), _.onChange(d));
            var L = d.target.value;
            if (L.trim() === "") return this.setState({ value: L, typedValue: "" }), void (B && B(void 0, {}, this));
            var $ = I(L, R, k.locale);
            if (!$) return this.setState({ value: L, typedValue: L }), void (B && B(void 0, {}, this));
            this.updateState($, L);
          } }, { key: "handleInputKeyDown", value: function(d) {
            d.keyCode === S.TAB ? this.hideDayPicker() : this.showDayPicker(), this.props.inputProps.onKeyDown && (d.persist(), this.props.inputProps.onKeyDown(d));
          } }, { key: "handleInputKeyUp", value: function(d) {
            d.keyCode === S.ESC ? this.hideDayPicker() : this.showDayPicker(), this.props.inputProps.onKeyUp && (d.persist(), this.props.inputProps.onKeyUp(d));
          } }, { key: "handleMonthChange", value: function(d) {
            var c = this;
            this.setState({ month: d }, function() {
              c.props.dayPickerProps && c.props.dayPickerProps.onMonthChange && c.props.dayPickerProps.onMonthChange(d);
            });
          } }, { key: "handleDayClick", value: function(d, c, k) {
            var R = this, _ = this.props, B = _.clickUnselectsDay, I = _.dayPickerProps, L = _.onDayChange, $ = _.formatDate, U = _.format;
            if (I.onDayClick && I.onDayClick(d, c, k), !(c.disabled || I && I.classNames && c[I.classNames.disabled])) {
              if (c.selected && B) {
                var F = this.state.selectedDays;
                if (Array.isArray(F)) {
                  F = F.slice(0);
                  var T = F.indexOf(d);
                  F.splice(T, 1);
                } else F && (F = null);
                return this.setState({ value: "", typedValue: "", selectedDays: F }, this.hideAfterDayClick), void (L && L(void 0, c, this));
              }
              var q = $(d, U, I.locale);
              this.setState({ value: q, typedValue: "", month: d }, function() {
                L && L(d, c, R), R.hideAfterDayClick();
              });
            }
          } }, { key: "renderOverlay", value: function() {
            var d = this, c = this.props, k = c.classNames, R = c.dayPickerProps, _ = c.parseDate, B = c.formatDate, I = c.format, L = this.state, $ = L.selectedDays, U = L.value, F = void 0;
            if (!$ && U) {
              var T = _(U, I, R.locale);
              T && (F = T);
            } else $ && (F = $);
            var q = void 0;
            R.todayButton && (q = function() {
              return d.updateState(/* @__PURE__ */ new Date(), B(/* @__PURE__ */ new Date(), I, R.locale), d.hideAfterDayClick);
            });
            var H = this.props.overlayComponent;
            return M.default.createElement(H, { classNames: k, month: this.state.month, selectedDay: F, input: this.input, tabIndex: 0, onFocus: this.handleOverlayFocus, onBlur: this.handleOverlayBlur }, M.default.createElement(x.default, P({ ref: function(V) {
              return d.daypicker = V;
            }, onTodayButtonClick: q }, R, { month: this.state.month, selectedDays: F, onDayClick: this.handleDayClick, onMonthChange: this.handleMonthChange })));
          } }, { key: "render", value: function() {
            var d = this, c = this.props.component, k = this.props.inputProps;
            return M.default.createElement("div", { className: this.props.classNames.container, style: this.props.style }, M.default.createElement(c, P({ ref: function(R) {
              return d.input = R;
            }, placeholder: this.props.placeholder }, k, { value: this.state.value || this.state.typedValue, onChange: this.handleInputChange, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onKeyDown: this.handleInputKeyDown, onKeyUp: this.handleInputKeyUp, onClick: k.disabled ? void 0 : this.handleInputClick })), this.state.showOverlay && this.renderOverlay());
          } }]), A;
        }(M.default.Component);
        O.defaultProps = { dayPickerProps: {}, value: "", typedValue: "", placeholder: "YYYY-M-D", format: "L", formatDate: y, parseDate: D, showOverlay: !1, hideOnDayClick: !0, clickUnselectsDay: !1, keepFocus: !0, component: "input", inputProps: {}, overlayComponent: w, classNames: { container: "DayPickerInput", overlayWrapper: "DayPickerInput-OverlayWrapper", overlay: "DayPickerInput-Overlay" } }, t.default = O;
      }]).default;
    });
  }(Ue)), Ue.exports;
}
var gr = Fo();
const Io = /* @__PURE__ */ Qe(gr), Bo = se.div`
  .dropDownBody {
    border-radius: 4px;
  }
  .DayPicker-Caption {
    display: none;
  }
  .Range {
    border: 1px solid #fff;
    border-radius: 4px;
    background-color: #ffffff;
    .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
      background-color: #e8edff !important;
      color: #202124;
      font-weight: 400;
    }
    .DayPicker-Day {
      border-radius: 0 !important;
      min-width: 14px;
      min-height: 14px;
      padding: 8.5px 9.5px;
      color: #202124;
      font-size: 14px;
    }
    .DayPicker-wrapper {
      padding-bottom: 0;
    }
    .DayPicker-Month {
      display: block;
      padding-bottom: 1em;
      &:first-child {
        border-right: 0.5px solid #ccc;
        padding: 0 1em;
        padding-top: 1em;
        margin: 0;
        margin-top: 0;
      }
    }
    .DayPicker-Months {
      flex-wrap: nowrap;
    }
    .DayPicker-Day--today:not(.DayPicker-Day--outside) {
      color: initial;
      font-weight: 400;
      color: #202124;
    }
    .DayPicker-Day--disabled {
      background-color: #eeeeee !important;
      color: #fff !important;
      cursor: not-allowed;
    }
    .DayPicker-Day--start:not(.DayPicker-Day--outside),
    .DayPicker-Day--end:not(.DayPicker-Day--outside),
    &:not(.DayPicker--interactionDisabled)
      .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
      background-color: #2f53d7 !important;
      color: #fff !important;
      border-radius: 50% !important;
    }
  }
  .dropDownWrapper {
    width: 266px;
  }
  .datesInputWrapper {
    display: flex;
    padding: 0 8px;
    width: 240px;
    color: rgb(109, 108, 111);
    border-radius: 4px;
    background-color: #f8f8fa;
    flex: 1 1 0%;
    justify-content: space-between;
    align-items: center;
    border: ${(e) => e.showDropDown ? "1px solid #2F53D7" : "1px solid #ffffff"};
    .closeIcon {
      border: 1px solid rgb(200, 201, 209);
      border-radius: 50%;
      background-color: rgb(200, 201, 209);
      color: #f8f8fa;
      width: 14px;
      height: 14px;
      cursor: pointer;
      &:hover {
        background-color: rgb(111, 111, 111);
        border: 1px solid rgb(111, 111, 111);
      }
    }
  }
  .errorDateInput {
    border: 1px solid #df2e2e;
    background-color: #ffeeeb;
    .inputStart {
      background: #ffeeeb;
    }
    .inputDue {
      background: #ffeeeb;
    }
  }
  .focusedDateInput {
    border-color: #2f53d7;
  }
  .datesTo {
    padding: 0 12px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #808080;
  }
  .datesInput {
    margin: 10px 0;
    font-weight: 400;
    font-size: 14px;
    width: 82px;
    border: none;
    background-color: #f8f8fa;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
  .inputStart {
    background: ${(e) => e.showDropDown && e.dateActive === "start" ? "#e8edff" : "#F8F8FA"};
  }
  .inputDue {
    background: ${(e) => e.showDropDown && e.dateActive === "due" ? "#e8edff" : "#F8F8FA"};
  }
  .dateRecentSelections {
    display: flex;
    align-items: center;
    margin-left: 24px;
    margin-bottom: 5px;
    margin-top: 8px;
    .recentSelectionImage {
      margin-right: 6px;
      width: 14px;
      height: 12px;
    }
    .selectionTitle {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-right: 8px;
      font-weight: 600;
      color: ${ce.grey[50]};
    }
    .selectionsContainer {
      display: flex;
      align-items: center;
      .singleSelection {
        font-weight: 500;
        cursor: pointer;
        padding: 6px 12px;
        border: 1px solid ${ce.grey[70]};
        border-radius: 23px;
        color: ${ce.grey[20]};
        font-size: 10px;
        margin-left: 8px;
        &:hover {
          background: ${ce.blue[90]};
          border: 1px solid ${ce.blue[90]};
        }
      }
      &::before {
        content: '';
        width: 1px;
        height: 16px;
        background-color: #e7e8ed;
      }
    }
  }

  .dateRangePickerFooterContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 0.5px solid #ccc;
    padding: 12px 24px;
  }

  .dateRangePickerSecondaryCta {
    color: #010101;
    margin-right: 20px;
    cursor: pointer;
  }

  .dateRangePickerPrimaryCta {
    padding: 8px 60px;
  }
`, Ro = se.div`
  display: flex;
  align-items: center;
  .rangeIcon {
    padding: 0 5px;
  }
  .selectedStartRange {
    padding-top: 10px;
    display: flex;
    flex: 0 1 50%;
    align-items: center;
    border-right: 0.5px solid #ccc;
    font-size: 15px;
  }
  .selectedEndRange {
    padding-top: 10px;
    display: flex;
    flex: 0 1 50%;
    align-items: center;
    font-size: 15px;
  }
  .selectedRange {
    display: flex;
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5;
    color: #70707e;
  }
  .previousButton,
  .nextButton {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    &.disabled {
      background-color: #f0f0f0;
      pointer-events: none;
    }
  }
  .previousButton {
    justify-content: flex-start;
    flex: 0 1 30%;
    padding-left: 18px;
  }
  .nextButton {
    justify-content: flex-end;
    flex: 0 1 35%;
    padding-right: 18px;
  }
  .selectedEndMonth {
    flex: 0 1 65%;
    text-align: end;
  }
`;
function Zt(e) {
  const {
    showPreviousButton: n,
    showNextButton: r,
    month: o,
    nextMonth: t,
    onPreviousClick: s,
    onNextClick: a,
    className: l,
    localeUtils: u
  } = e, m = u.getMonths(), f = m[o.getMonth()], E = m[t.getMonth() - 1 >= 0 ? t.getMonth() - 1 : 11], y = (t ? t.getFullYear() : 0) - (t.getMonth() - 1 >= 0 ? 0 : 1);
  return /* @__PURE__ */ p.jsx(Ro, { className: l, children: /* @__PURE__ */ p.jsxs("div", { className: "selectedRange", children: [
    /* @__PURE__ */ p.jsxs("div", { className: "selectedStartRange", children: [
      /* @__PURE__ */ p.jsx(
        "div",
        {
          className: `previousButton${n ? "" : " disabled"}`,
          onClick: () => {
            n && s();
          },
          children: /* @__PURE__ */ p.jsx(fe, { color: ce.grey[10], icon: $r, size: "m" })
        }
      ),
      /* @__PURE__ */ p.jsxs("span", { children: [
        f && f.slice(0, 3),
        " ",
        o && o.getFullYear()
      ] })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: "selectedEndRange", children: [
      /* @__PURE__ */ p.jsxs("span", { className: "selectedEndMonth", children: [
        E && E.slice(0, 3),
        " ",
        y
      ] }),
      /* @__PURE__ */ p.jsx(
        "div",
        {
          className: `nextButton${r ? "" : " disabled"}`,
          onClick: () => {
            r && a();
          },
          children: /* @__PURE__ */ p.jsx(fe, { color: ce.grey[10], icon: qr, size: "m" })
        }
      )
    ] })
  ] }) });
}
const _o = De(Zt);
Zt.propTypes = {
  className: i.string,
  localeUtils: i.object,
  month: i.object,
  nextMonth: i.object,
  onNextClick: i.func,
  onPreviousClick: i.func,
  showNextButton: i.func,
  showPreviousButton: i.func
};
Zt.defaultProps = {
  className: null,
  localeUtils: null,
  month: null,
  nextMonth: null,
  onNextClick: null,
  onPreviousClick: null,
  showNextButton: null,
  showPreviousButton: null
};
const Lo = Yn`
   from {
     opacity: 0;
   }
   to {
     opacity: 1;
   }
 `, $o = se.div.attrs({ className: "dropDownBody" })`
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1),
    0 32px 32px 0 rgba(134, 139, 143, 0.2);
  background-color: #fff;
  display: ${(e) => e.open ? "block" : "none"};
  min-width: ${(e) => `${e.minDropDownWidth}px`};
  max-height: ${(e) => `${e.maxDropDownHeight}px`};
  ${(e) => e.textAlign ? `text-align: ${e.textAlign}` : ""};
  white-space: nowrap;
  z-index: 10;
  position: fixed;
  top: ${(e) => `${e.dropDownTop}px`};
  ${(e) => e.dropDownLeft ? `left: ${e.dropDownLeft}px` : ""};
  ${(e) => e.dropDownRight ? `right: ${e.dropDownRight}px` : ""};
  animation: ${Lo} 0.25s linear;
`, en = De((e) => {
  const {
    id: n,
    className: r,
    enableScrollBlock: o,
    scrollAncestorIdentifier: t,
    disabled: s,
    width: a,
    open: l,
    onToggle: u,
    dynamicProps: m,
    preferTop: f,
    preferLeft: E,
    distanceFromSelector: w,
    parentContainerId: y,
    showDarkBg: D
  } = e, [j, P] = Y(0), [N, M] = Y(0), [b, x] = Y(0), [C, h] = Y(0), [S, g] = Y(0), [O, v] = Y(
    l !== null ? l : !1
  ), [A, d] = Y(0), c = (L, $, U) => {
    if (!U) return { x1: L, y1: $ };
    const F = U.getBoundingClientRect();
    return { x1: L - F.left, y1: $ - F.top };
  }, k = (L, $, U, F, T, q) => {
    const H = y ? document.getElementById(y) : null, { x1: V, y1: K } = c(L, $, H), ne = H ? H.clientHeight : window.innerHeight, ae = H ? H.clientWidth : window.innerWidth;
    let ge = E ? "left" : "right", de = f ? "top" : "bottom", ee = e.maxDropDownHeight && e.maxDropDownHeight <= F ? e.maxDropDownHeight : F;
    if (U - (ae - V) > 0 && (ge = "left"), ee + q > ne - K && K > ne - K && (de = "top"), de === "top") {
      const te = K - 40;
      ee = ee < te ? ee : te;
    }
    if (de === "bottom") {
      const te = ne - K - 40;
      ee = ee < te ? ee : te;
    }
    return {
      left: ge === "right" ? V : void 0,
      right: ge === "left" ? ae - (V + T) : void 0,
      top: de === "top" ? K - ee : K + q + w,
      maxDropDownHeight: ee
    };
  }, R = () => o && t && document.querySelector(t) ? document.querySelector(t) : null, _ = () => {
    R() && (R().style.overflow = "auto");
  }, B = () => {
    R() && (R().style.overflow = "hidden");
  }, I = () => {
    _(), v(!1), u && u(!1);
  };
  return Z(() => {
    const L = () => {
      d(!A), _();
    };
    return window.addEventListener("resize", L), () => window.removeEventListener("resize", L);
  }, [A]), Z(() => {
    const L = document.getElementById(n) ? document.getElementById(n).getBoundingClientRect() : null, $ = document.querySelector(`#${n} .dropDownBody`);
    if (document.getElementById(n) && $ && L) {
      const U = $.clientWidth, F = $.scrollHeight, T = L.width, q = L.height;
      h(L.width);
      const H = k(
        L.left,
        L.top,
        U,
        F,
        T,
        q
      );
      P(H.top), M(H.left), x(H.right), g(H.maxDropDownHeight);
    }
  }, [
    n,
    O,
    A,
    e.maxDropDownHeight,
    m,
    f,
    E
  ]), Z(() => {
    const L = document.querySelector(`#${n} .dropDownSelector`), $ = document.querySelector(`#${n} .dropDownBody`);
    if (!s && L) {
      const U = (T) => {
        (L === T.target || L.contains(T.target)) && (O ? _() : B(), e.isCloseOnClickSelector && (v(!O), u && u(!O)));
      }, F = (T) => {
        O && T.target !== L && !L.contains(T.target) && !($ && $.contains(T.target)) && I();
      };
      return L.addEventListener("click", U), document.addEventListener("click", F, !0), () => {
        L.removeEventListener("click", U), document.removeEventListener("click", F, !0);
      };
    }
  }, [n, O, s, u]), Z(() => {
    if (l !== void 0) {
      if (l) {
        v(l);
        return;
      }
      v(!1);
    }
  }, [l]), /* @__PURE__ */ p.jsxs(Xr, { children: [
    O && D && /* @__PURE__ */ p.jsx(
      "div",
      {
        className: "showDarkBg",
        onClick: I,
        style: {
          cursor: "default",
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 8,
          backgroundColor: "rgba(0,0,0,0)",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    ),
    /* @__PURE__ */ p.jsxs(
      "div",
      {
        className: `dropDownWrapper${r ? ` ${r}` : ""}`,
        id: n,
        width: a,
        children: [
          /* @__PURE__ */ p.jsx("div", { className: `dropDownSelector${O ? " active" : ""}`, children: e.selector }),
          /* @__PURE__ */ p.jsx(
            $o,
            {
              dropDownLeft: N,
              dropDownRight: b,
              dropDownTop: j,
              maxDropDownHeight: S,
              minDropDownWidth: C,
              open: O,
              children: e.children
            }
          )
        ]
      }
    )
  ] });
});
en.defaultProps = {
  children: null,
  className: null,
  disabled: !1,
  distanceFromSelector: 0,
  dynamicProps: null,
  enableScrollBlock: !1,
  id: null,
  isCloseOnClickSelector: !0,
  maxDropDownHeight: null,
  onToggle: () => null,
  open: !1,
  preferLeft: !1,
  preferTop: !1,
  scrollAncestorIdentifier: null,
  selector: null,
  width: null,
  parentContainerId: null,
  showDarkBg: !1
};
en.propTypes = {
  children: i.node,
  className: i.string,
  disabled: i.bool,
  distanceFromSelector: i.number,
  dynamicProps: i.shape(Object),
  enableScrollBlock: i.bool,
  id: i.string,
  isCloseOnClickSelector: i.bool,
  maxDropDownHeight: i.number,
  onToggle: i.func,
  open: i.bool,
  parentContainerId: i.string,
  preferLeft: i.bool,
  preferTop: i.bool,
  scrollAncestorIdentifier: i.string,
  selector: i.node,
  showDarkBg: i.bool,
  width: i.string
};
const gt = (e) => e instanceof Date && !Number.isNaN(e.getTime()), qo = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11
}, ye = {
  dd: (e) => e ? e.toString().padStart(2, "0") : "",
  Do: {
    1: "1st",
    2: "2nd",
    3: "3rd",
    4: "4th",
    5: "5th",
    6: "6th",
    7: "7th",
    8: "8th",
    9: "9th",
    10: "10th",
    11: "11th",
    12: "12th",
    13: "13th",
    14: "14th",
    15: "15th",
    16: "16th",
    17: "17th",
    18: "18th",
    19: "19th",
    20: "20th",
    21: "21st",
    22: "22nd",
    23: "23rd",
    24: "24th",
    25: "25th",
    26: "26th",
    27: "27th",
    28: "28th",
    29: "29th",
    30: "30th",
    31: "31st"
  },
  MMM: {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec"
  },
  hh: (e) => e <= 12 ? String(e).padStart(2, "0") : String(e - 12).padStart(2, "0"),
  // only do this when hours > 12
  mm: (e) => String(e).padStart(2, "0"),
  a: (e) => e - 12 >= 0 ? "pm" : "am",
  yy: (e) => e.toString().substr(-2)
}, $e = (e, n) => {
  try {
    return n.split("$").map((o) => {
      if (o && Object.keys(ye).includes(o))
        switch (o) {
          case "dd":
            return ye.dd(e.getDate());
          case "Do":
            return ye.Do[e.getDate()];
          case "MMM":
            return ye.MMM[e.getMonth() + 1];
          // getMonth is zero based
          case "hh":
            return ye.hh(e.getHours());
          case "mm":
            return ye.mm(e.getMinutes());
          case "a":
            return ye.a(e.getHours());
          case "yy":
            return ye.yy(e.getFullYear());
          case "MM":
            return ye.MM(e.getMonth() + 1);
          default:
            return o;
        }
      return o;
    }).join("");
  } catch {
    return "INVALID_DATE";
  }
}, Ho = (e, n) => {
  let r = null;
  switch (n) {
    case "dd/mm/yyyy":
      r = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      break;
    case "dd MMM yyyy":
      r = /^(\d{2})\s([j,J]an||[f,F]eb||[M,m]ar||[A,a]pr||[M,m]ay||[j,J]un||[j,J]ul||[A,a]ug||[s,S]ep||[O,o]ct||[N,n]ov||[d,D]ec)\s(\d{4})$/;
      break;
    default:
      r = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      break;
  }
  return r.test(e);
}, vn = {
  OUTSIDE_RANGE: "OUTSIDE_RANGE",
  INVALID_FORMAT: "INVALID_FORMAT"
};
function mr({
  defaultStart: e,
  defaultEnd: n,
  onDateChange: r,
  onInputError: o,
  recentSelections: t,
  selectorId: s,
  isOpen: a,
  selectReset: l,
  minDate: u,
  maxDate: m,
  setOpen: f,
  setSelectReset: E,
  secondaryCtaLabel: w,
  onClickSecondaryCta: y,
  isPrimaryCtaDisabled: D,
  onClickPrimaryCta: j,
  primaryCtaLabel: P,
  showResetOption: N,
  shouldShowFooter: M
}) {
  const [b, x] = Y(null), [C, h] = Y(null), [S, g] = Y(null), [O, v] = Y(null), [A, d] = Y(/* @__PURE__ */ new Date()), [c, k] = Y(null), [R, _] = Y(null), [B, I] = Y(null), [L, $] = Y(!1), U = Ce(null), F = Ce(null), T = (z) => z ? new Date(z) : null;
  Z(() => {
    if (gt(b)) {
      const z = `${$e(
        b,
        "dd$ $MMM"
      )} ${b.getFullYear()}`;
      k(z);
    } else
      k("");
    if (gt(C)) {
      const z = `${$e(C, "dd$ $MMM")} ${C.getFullYear()}`;
      _(z);
    } else
      _("");
  }, [b, C]), Z(() => {
    e && n && I(null);
  }, [e, n]), Z(() => {
    e !== void 0 && x(e);
  }, [e]), Z(() => {
    n !== void 0 && (h(n), g(n));
  }, [n]);
  const q = (z) => {
    const Q = b && gr.DateUtils.isDayBefore(z, b);
    return !b || Q || b && C;
  }, H = () => {
    if (x(null), h(null), g(null), M) {
      j([null, null]);
      return;
    }
    r && r([null, null]);
  };
  Z(() => {
    l && (H(), E(!1));
  }, [l]);
  const V = (z, Q) => {
    Q.disabled || q(z) || g(z);
  }, K = (z, Q) => {
    if (!Q.disabled) {
      if (b && C) {
        I(null), O === "start" ? (z > C && H(), F.current.focus(), x(z), r && r([z, C])) : z < b ? (x(z), h(null), g(null), r && r([z, null])) : (g(z), h(z), r && r([b, z]));
        return;
      }
      q(z) ? (x(z), h(null), g(null), r && r([z, null])) : (h(z), g(z), r && r([b, z]), M || f(!1));
    }
  }, ne = (z) => {
    const Q = document.querySelector(`#${s} .closeIcon`);
    if (z.target === Q) {
      f(!1);
      return;
    }
    f(!0);
    const oe = document.querySelector(
      `#${s} .datesInputWrapper`
    ), re = document.querySelector(`#${s} .inputDue`);
    if (!b && !C) {
      v("start"), U.current.focus();
      return;
    }
    (oe === z.target || oe.contains(z.target)) && (z.target === re ? v("due") : v("start"));
  }, ae = (z) => {
    const Q = z.split(" ");
    if (Q.length < 3) return;
    let oe = Q[1];
    return oe = oe[0].toUpperCase() + oe.slice(1).toLowerCase(), new Date(
      +Q[2],
      qo[oe],
      +Q[0]
    );
  }, ge = (z, Q) => {
    const oe = z ? z.trim() : "";
    if (!oe) return !1;
    if (!Ho(oe, "dd MMM yyyy"))
      return I({ ...B, [Q]: !0 }), !1;
    const re = ae(oe);
    return gt(re) ? (I({ ...B, [Q]: !1 }), !0) : (I({ ...B, [Q]: !0 }), !1);
  }, de = (z, Q) => {
    if (!z) {
      Q === "start" ? (x(null), r && r([null, C])) : (g(null), h(null), r && r([b, null]));
      return;
    }
    if (!ge(z, Q)) {
      Q === "start" ? r && r([null, C]) : r && r([b, null]), o && o({ error: !0, errorTypes: vn.INVALID_FORMAT });
      return;
    }
    const oe = z.trim(), re = ae(oe);
    if (re.setHours(12, 0, 0, 0), u && m) {
      const fn = new Date(u);
      fn.setHours(12, 0, 0, 0);
      const hn = new Date(m);
      if (hn.setHours(12, 0, 0, 0), re < fn || re > hn) {
        I({ ...B, [Q]: !0 }), o && o({ error: !0, errorType: vn.OUTSIDE_RANGE });
        return;
      }
    }
    if (o && o({ error: !1 }), I(null), Q === "start") {
      if (re >= C) {
        h(null), g(null), x(re), r && r([re, null]), d(re);
        return;
      }
      d(re), x(re), r && r([re, C]);
    } else {
      if (re < b) {
        x(null), r && r([null, C]);
        return;
      }
      d(re), h(re), g(re), r && r([b, re]);
    }
  }, ee = (z, Q) => {
    Q === "start" ? k(z.target.value) : _(z.target.value), de(z.target.value, Q);
  }, te = (z, Q) => {
    x(z), h(Q), g(Q), r && r([z, Q]);
  };
  Z(() => {
    if (a !== void 0) {
      if (a) {
        f(a);
        return;
      }
      f(!1);
    }
  }, [a]);
  const le = { start: b, end: S }, Ae = [b, { from: b, to: S }], pt = B && Object.values(B).some((z) => z), Br = () => {
    j([b, C]);
  };
  return /* @__PURE__ */ p.jsx(Bo, { dateActive: O, showDropDown: a, children: /* @__PURE__ */ p.jsxs(
    en,
    {
      distanceFromSelector: 4,
      id: `${s}`,
      isCloseOnClickSelector: !1,
      onToggle: (z) => {
        z && d(T(b)), f(z);
      },
      open: a,
      preferTop: !1,
      selector: /* @__PURE__ */ p.jsxs(
        "div",
        {
          className: `datesInputWrapper ${pt ? " errorDateInput" : ""}`,
          onClick: ne,
          onMouseEnter: () => $(!0),
          onMouseLeave: () => $(!1),
          children: [
            /* @__PURE__ */ p.jsx("div", { className: "inputStartBlock", children: /* @__PURE__ */ p.jsx(
              "input",
              {
                className: "datesInput inputStart",
                onChange: (z) => ee(z, "start"),
                onFocus: () => v("start"),
                placeholder: "Start date",
                ref: U,
                type: "text",
                value: c
              }
            ) }),
            /* @__PURE__ */ p.jsx("div", { className: "datesTo", children: "to" }),
            /* @__PURE__ */ p.jsx("div", { className: "inputDueBlock", children: /* @__PURE__ */ p.jsx(
              "input",
              {
                className: "datesInput inputDue",
                onChange: (z) => ee(z, "due"),
                onFocus: () => v("due"),
                placeholder: "Due date",
                ref: F,
                type: "text",
                value: R
              }
            ) }),
            L && N && (b || C) ? /* @__PURE__ */ p.jsx(
              fe,
              {
                className: "closeIcon",
                color: pt ? "#ffeeeb" : ce.grey[10],
                icon: er,
                onClick: H
              }
            ) : /* @__PURE__ */ p.jsx(
              fe,
              {
                color: pt ? "#ffeeeb" : ce.grey[0],
                icon: Hr
              }
            )
          ]
        }
      ),
      children: [
        t && /* @__PURE__ */ p.jsxs("div", { className: "dateRecentSelections", children: [
          /* @__PURE__ */ p.jsxs("div", { className: "selectionTitle", children: [
            /* @__PURE__ */ p.jsx(
              "img",
              {
                alt: "export",
                className: "icon recentSelectionImage",
                src: "/assets/images/dateSelector/recent-selection.svg"
              }
            ),
            /* @__PURE__ */ p.jsx("div", { children: "Recent Selections" })
          ] }),
          /* @__PURE__ */ p.jsx("div", { className: "selectionsContainer", children: t && t.map((z) => {
            const Q = new Date(z.startDate), oe = new Date(z.dueDate);
            return /* @__PURE__ */ p.jsxs(
              "div",
              {
                className: "singleSelection",
                onClick: () => te(
                  Q,
                  oe
                ),
                children: [
                  $e(Q, "dd$ $MMM"),
                  " ",
                  Q.getFullYear(),
                  " - ",
                  $e(oe, "dd$ $MMM"),
                  " ",
                  oe.getFullYear()
                ]
              }
            );
          }) })
        ] }),
        /* @__PURE__ */ p.jsx(
          Io,
          {
            className: "Range",
            disabledDays: {
              before: u && new Date(u),
              after: m && new Date(m)
            },
            modifiers: le,
            month: A,
            navbarElement: /* @__PURE__ */ p.jsx(_o, {}),
            numberOfMonths: 2,
            onDayClick: K,
            onDayMouseEnter: V,
            onMonthChange: d,
            selectedDays: Ae
          }
        ),
        M && /* @__PURE__ */ p.jsxs("div", { className: "dateRangePickerFooterContainer", children: [
          /* @__PURE__ */ p.jsx(
            "div",
            {
              className: "dateRangePickerSecondaryCta",
              onClick: y,
              children: w
            }
          ),
          /* @__PURE__ */ p.jsx(
            Pt,
            {
              className: "dateRangePickerPrimaryCta",
              color: "primary",
              isDisabled: D,
              onClick: Br,
              children: P
            }
          )
        ] })
      ]
    }
  ) });
}
mr.defaultProps = {
  defaultEnd: "",
  defaultStart: "",
  isOpen: !1,
  isPrimaryCtaDisabled: !1,
  maxDate: null,
  minDate: null,
  onClickPrimaryCta: null,
  onClickSecondaryCta: null,
  onDateChange: null,
  onInputError: null,
  primaryCtaLabel: "Apply",
  recentSelections: null,
  secondaryCtaLabel: "Cancel",
  selectorId: "dateRangePicker",
  selectReset: !1,
  setOpen: null,
  setSelectReset: null,
  shouldShowFooter: !1,
  showResetOption: !0
};
mr.propTypes = {
  defaultEnd: i.string,
  defaultStart: i.string,
  isOpen: i.bool,
  isPrimaryCtaDisabled: i.bool,
  maxDate: i.string,
  minDate: i.string,
  onClickPrimaryCta: i.func,
  onClickSecondaryCta: i.func,
  onDateChange: i.func,
  onInputError: i.func,
  primaryCtaLabel: i.string,
  recentSelections: i.arrayOf(Object),
  secondaryCtaLabel: i.string,
  selectorId(e, n) {
    if (n === "selectorId" && e[n] === "dateRangePicker")
      throw new Error(
        "Please add selectorId prop to DateRangePicker component."
      );
  },
  selectReset: i.bool,
  setOpen: i.func,
  setSelectReset: i.func,
  shouldShowFooter: i.bool,
  showResetOption: i.bool
};
const Uo = se(ie)`
  display: -webkit-box;
  -webkit-line-clamp: ${(e) => e.maxLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
`, Wo = (e) => e.scrollHeight > e.clientHeight, tn = Ee(({ children: e, maxLines: n, ...r }, o) => {
  const [t, s] = Y(!1), [a, l] = Y(!1), [u, m] = Y(n), f = o || Qr();
  Z(() => {
    Wo(f.current) && s(!0);
  }, [f]);
  const E = () => {
    m(a ? n : 999), l(!a);
  };
  return /* @__PURE__ */ p.jsxs(W, { children: [
    /* @__PURE__ */ p.jsx(W, { as: Uo, maxLines: u, ...r, ref: f, children: e }),
    t && /* @__PURE__ */ p.jsxs(nt, { color: "basic", mt: 4, onClick: () => E(), rightIcon: a ? zn : Wn, size: "small", children: [
      "Read ",
      a ? "less" : "more"
    ] })
  ] });
});
tn.propTypes = {
  /**
  * The textual content to be rendered on the screen
  */
  children: i.node.isRequired,
  /**
  * Max no. of lines allowed by the textbox component
  */
  maxLines: i.number
};
tn.defaultProps = {
  maxLines: 3
};
tn.displayName = "TextBox";
const zo = se.div`
  &.switch {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 14px;
  }

  &.switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: ${(e) => e.disabled ? "default" : "pointer"};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 8px;
    width: 8px;
    left: 4px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #2f53d7;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2f53d7;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(8px);
    -ms-transform: translateX(8px);
    transform: translateX(8px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  input[type='checkbox' i]:focus {
    outline: none;
  }
`, nn = ({ checked: e, onClick: n, disabled: r, id: o, ...t }) => {
  const [s, a] = Y(!1);
  Z(() => {
    s !== e && a(e);
  }, [e]);
  const l = () => {
    r || (a(!s), n && n());
  };
  return /* @__PURE__ */ p.jsxs(
    zo,
    {
      className: "switch",
      disabled: r,
      id: o || null,
      onClick: () => l(),
      ...t,
      children: [
        /* @__PURE__ */ p.jsx("input", { checked: s, onChange: () => {
        }, type: "checkbox" }),
        /* @__PURE__ */ p.jsx("span", { className: "slider round" })
      ]
    }
  );
};
nn.propTypes = {
  checked: i.bool,
  disabled: i.bool,
  onClick: i.func,
  id: i.string
};
nn.defaultProps = {
  disabled: !1,
  checked: !1,
  onClick: null,
  id: null
};
nn.displayName = "ToggleSwitch";
const xn = ({ content: e, action: n, isDisabled: r }) => /* @__PURE__ */ p.jsx(
  W,
  {
    cursor: "pointer",
    height: 24,
    lineHeight: "24px",
    onClick: () => {
      r || n();
    },
    opacity: r ? 0.5 : 1,
    children: e
  }
), rn = ({
  ctaLabel: e,
  unit: n,
  value: r,
  isDisabled: o,
  noUnitSuffix: t,
  onConfirm: s,
  placeholder: a,
  unitOptions: l,
  valueRange: u
}) => {
  const [m, f] = Y(!1), [E, w] = Y(r || u.min), [y, D] = Y(n), j = Ce(null);
  Z(() => {
    const h = (S) => {
      j.current && !j.current.contains(S.target) && f(!1);
    };
    return document.addEventListener("mousedown", h), () => {
      document.removeEventListener("mousedown", h);
    };
  }, [j]);
  const P = () => {
    w(E + 1);
  }, N = () => {
    w(E - 1);
  }, M = () => l?.length > 0 && !y || !E, b = (h, S) => {
    const g = S.toLowerCase();
    return g.substr(-1) === "s" && h === 1 ? `${h} ${g.slice(0, -1)}` : `${h} ${g}`;
  }, x = () => l?.length ? r && n ? b(r, n) : a : r ? b(r, t) : a, C = () => {
    f(!1);
    const h = {
      value: E
    };
    l?.length && (h.unit = y), s(h);
  };
  return /* @__PURE__ */ p.jsxs(W, { d: "inline-flex", position: "relative", ref: j, children: [
    /* @__PURE__ */ p.jsx(
      tt,
      {
        isDisabled: o,
        isOpen: m,
        onClick: () => f(!m),
        size: "large",
        children: x()
      }
    ),
    m && /* @__PURE__ */ p.jsxs(
      W,
      {
        bg: "white",
        borderRadius: 2,
        boxShadow: "0px 5px 10px 1px rgba(0,0,0,0.1)",
        mt: 6,
        p: "12px 16px 24px",
        position: "absolute",
        top: 40,
        w: 180,
        children: [
          /* @__PURE__ */ p.jsxs(W, { alignItems: "center", d: "flex", justifyContent: "center", mb: 6, children: [
            /* @__PURE__ */ p.jsxs(
              W,
              {
                color: "grey.20",
                flex: "0.5",
                fontSize: 12,
                px: 4,
                textAlign: "center",
                children: [
                  /* @__PURE__ */ p.jsx(
                    xn,
                    {
                      action: P,
                      content: "▲",
                      isDisabled: E >= u.max
                    }
                  ),
                  /* @__PURE__ */ p.jsx(
                    W,
                    {
                      border: "1px solid",
                      borderColor: "grey.70",
                      borderRadius: 2,
                      boxShadow: "0px 5px 10px 1px rgba(0,0,0,0.1)",
                      color: "grey.10",
                      d: "inline-block",
                      fontSize: 14,
                      height: 32,
                      lineHeight: 5,
                      minWidth: 50,
                      my: 3,
                      px: 2,
                      textAlign: "center",
                      children: E
                    }
                  ),
                  /* @__PURE__ */ p.jsx(
                    xn,
                    {
                      action: N,
                      content: "▼",
                      isDisabled: E <= u.min
                    }
                  )
                ]
              }
            ),
            l?.length > 0 && /* @__PURE__ */ p.jsx(
              W,
              {
                flex: "0.5",
                px: 4,
                textAlign: "center",
                textTransform: "lowercase",
                children: l.map((h) => /* @__PURE__ */ p.jsx(
                  ie,
                  {
                    color: y === h ? "grey.10" : "grey.50",
                    cursor: "pointer",
                    my: 6,
                    onClick: () => D(h),
                    type: "note",
                    children: h
                  },
                  h
                ))
              }
            )
          ] }),
          /* @__PURE__ */ p.jsx(
            W,
            {
              border: "1px solid",
              borderColor: "blue.50",
              borderRadius: 2,
              color: "blue.50",
              cursor: M() ? "auto" : "pointer",
              fontSize: 14,
              fontWeight: 600,
              height: 32,
              lineHeight: 4,
              onClick: C,
              opacity: M() ? 0.3 : 1,
              textAlign: "center",
              variant: "secondary",
              w: "100%",
              children: e
            }
          )
        ]
      }
    )
  ] });
};
rn.propTypes = {
  /**
   * Label for confirm cta
   */
  ctaLabel: i.string,
  /**
   * Disabled state
   */
  isDisabled: i.bool,
  /**
   * Suffix to use when unit options are not there
   */
  noUnitSuffix: i.string,
  /**
   * Get value and unit on confirm
   */
  onConfirm: i.func.isRequired,
  /**
   * Placeholder for dropdown
   */
  placeholder: i.string,
  /**
   * Initialized unit
   */
  unit: i.string,
  /**
   * Pass options for units
   */
  unitOptions: i.arrayOf(i.string),
  /**
   * Initialized value
   */
  value: i.number,
  /**
   * Pass the range for value
   */
  valueRange: i.shape({
    max: i.string,
    min: i.string
  })
};
rn.defaultProps = {
  ctaLabel: "Confirm",
  isDisabled: !1,
  noUnitSuffix: "times",
  placeholder: "Select",
  unit: "",
  unitOptions: [],
  value: 1,
  valueRange: {
    max: 10,
    min: 1
  }
};
rn.displayName = "UnitPicker";
const Vo = se(W)`
  background: #eaebf0;
  border-radius: 2px;
  display: flex;

  .block {
    display: flex;

    &:first-of-type {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }

    &:last-of-type {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }

  .tooltipWrapper {
    display: flex;
    flex: 1;
  }
`, Ko = se(W)`
  color: #fff;

  .sbDataContainer {
    margin-top: 8px;
  }
  .sbDataItem {
    display: flex;
    align-items: center;
  }
  .sbDataItemColorCode {
    border-radius: 50%;
    width: 8px;
    height: 8px;
  }

  .sbDataItemInfo {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-left: 8px;
  }
`, st = G.memo(function({ title: n, data: r }) {
  return /* @__PURE__ */ p.jsxs(Ko, { children: [
    /* @__PURE__ */ p.jsx(W, { className: "sbTitle", children: n }),
    /* @__PURE__ */ p.jsx(W, { className: "sbDataContainer", children: r ? r.map((o) => /* @__PURE__ */ p.jsxs(W, { className: "sbDataItem", children: [
      /* @__PURE__ */ p.jsx(
        W,
        {
          as: "span",
          bg: o ? o.background : null,
          className: "sbDataItemColorCode"
        }
      ),
      /* @__PURE__ */ p.jsxs(W, { as: "span", className: "sbDataItemInfo", children: [
        o ? o.label : null,
        " :",
        " ",
        o ? o.value : null
      ] })
    ] }, o.id)) : null })
  ] });
});
st.propTypes = {
  data: i.arrayOf(
    i.shape({
      id: i.number.isRequired,
      label: i.string,
      value: i.number
    })
  ),
  /**
   * Title of the tooltip, default to 'Distribution'
   */
  title: i.string
};
st.displayName = "TooltipContent";
st.defaultProps = {
  data: [],
  title: "Distribution"
};
const at = G.memo(function({
  data: n,
  isOpen: r,
  customTooltipContent: o,
  title: t,
  children: s
}) {
  return /* @__PURE__ */ p.jsx(
    tr,
    {
      background: "#000",
      className: "tooltipWrapper",
      color: "#FFF",
      content: o || /* @__PURE__ */ p.jsx(st, { data: n, title: t }),
      isOpen: r,
      children: s
    }
  );
});
at.propTypes = {
  children: i.node,
  customTooltipContent: i.node,
  data: i.arrayOf(
    i.shape({
      id: i.number.isRequired,
      label: i.string,
      value: i.number
    })
  ),
  isOpen: i.bool,
  /**
   * Title of the tooltip, default to 'Distribution'
   */
  title: i.string
};
at.defaultProps = {
  children: null,
  customTooltipContent: null,
  data: [],
  isOpen: void 0,
  title: null
};
at.displayName = "TooltipContainer";
const on = G.memo(function({
  height: n,
  data: r,
  enableTooltip: o,
  customTooltipContent: t,
  tooltipTitle: s,
  ...a
}) {
  const [l, u] = Y(0);
  return Z(() => {
    const m = r ? r.reduce(
      (f, E) => f + (E.value || 0),
      0
    ) : null;
    u(m);
  }, [r]), /* @__PURE__ */ p.jsx(Vo, { height: n, ...a, children: /* @__PURE__ */ p.jsx(
    at,
    {
      customTooltipContent: t,
      data: r,
      isOpen: o === !0 ? void 0 : !1,
      title: s,
      children: r && r.map((m) => /* @__PURE__ */ p.jsx(
        W,
        {
          as: "span",
          bg: m ? m.background : null,
          className: "block blockStyle",
          flex: (m ? m.value : 0) / l
        },
        m.id
      ))
    }
  ) });
});
on.propTypes = {
  /**
   * Custom component to render in tooltip
   */
  customTooltipContent: i.node,
  /**
   * Array of data to be rendered
   */
  data: i.arrayOf(
    i.shape({
      id: i.number.isRequired,
      label: i.string,
      value: i.number
    })
  ),
  /**
   * If true then it will show the data distribution in tooltip by default
   */
  enableTooltip: i.bool,
  /**
   * Height of the progress bar, default to 16px
   */
  height: i.oneOfType([i.number, i.string]),
  /**
   * Title of the tooltip, default to 'Distribution'
   */
  tooltipTitle: i.string
};
on.defaultProps = {
  customTooltipContent: null,
  data: [],
  enableTooltip: !1,
  height: "16px",
  tooltipTitle: "Distribution"
};
on.displayName = "StatusBar";
var mt = { exports: {} }, yt, En;
function Yo() {
  if (En) return yt;
  En = 1;
  var e = 1;
  function n() {
    return e = (e * 9301 + 49297) % 233280, e / 233280;
  }
  function r(o) {
    e = o;
  }
  return yt = {
    nextValue: n,
    seed: r
  }, yt;
}
var bt, wn;
function lt() {
  if (wn) return bt;
  wn = 1;
  var e = Yo(), n = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-", r, o, t;
  function s() {
    t = !1;
  }
  function a(y) {
    if (!y) {
      r !== n && (r = n, s());
      return;
    }
    if (y !== r) {
      if (y.length !== n.length)
        throw new Error("Custom alphabet for shortid must be " + n.length + " unique characters. You submitted " + y.length + " characters: " + y);
      var D = y.split("").filter(function(j, P, N) {
        return P !== N.lastIndexOf(j);
      });
      if (D.length)
        throw new Error("Custom alphabet for shortid must be " + n.length + " unique characters. These characters were not unique: " + D.join(", "));
      r = y, s();
    }
  }
  function l(y) {
    return a(y), r;
  }
  function u(y) {
    e.seed(y), o !== y && (s(), o = y);
  }
  function m() {
    r || a(n);
    for (var y = r.split(""), D = [], j = e.nextValue(), P; y.length > 0; )
      j = e.nextValue(), P = Math.floor(j * y.length), D.push(y.splice(P, 1)[0]);
    return D.join("");
  }
  function f() {
    return t || (t = m(), t);
  }
  function E(y) {
    var D = f();
    return D[y];
  }
  function w() {
    return r || n;
  }
  return bt = {
    get: w,
    characters: l,
    seed: u,
    lookup: E,
    shuffled: f
  }, bt;
}
var vt, Cn;
function Go() {
  if (Cn) return vt;
  Cn = 1;
  var e = typeof window == "object" && (window.crypto || window.msCrypto), n;
  return !e || !e.getRandomValues ? n = function(r) {
    for (var o = [], t = 0; t < r; t++)
      o.push(Math.floor(Math.random() * 256));
    return o;
  } : n = function(r) {
    return e.getRandomValues(new Uint8Array(r));
  }, vt = n, vt;
}
let Jo = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", yr = (e) => crypto.getRandomValues(new Uint8Array(e)), br = (e, n, r) => {
  let o = (2 << Math.log(e.length - 1) / Math.LN2) - 1, t = -~(1.6 * o * n / e.length);
  return (s = n) => {
    let a = "";
    for (; ; ) {
      let l = r(t), u = t | 0;
      for (; u--; )
        if (a += e[l[u] & o] || "", a.length === s) return a;
    }
  };
}, Xo = (e, n = 21) => br(e, n, yr), Qo = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((n, r) => (r &= 63, r < 36 ? n += r.toString(36) : r < 62 ? n += (r - 26).toString(36).toUpperCase() : r > 62 ? n += "-" : n += "_", n), "");
const Zo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  customAlphabet: Xo,
  customRandom: br,
  nanoid: Qo,
  random: yr,
  urlAlphabet: Jo
}, Symbol.toStringTag, { value: "Module" })), ei = /* @__PURE__ */ Gn(Zo);
var xt, Dn;
function ti() {
  if (Dn) return xt;
  Dn = 1;
  var e = lt(), n = Go(), r = ei.customRandom;
  function o(t) {
    for (var s = 0, a, l = ""; !a; )
      l = l + r(e.get(), 1, n)(), a = t < Math.pow(16, s + 1), s++;
    return l;
  }
  return xt = o, xt;
}
var Et, kn;
function ni() {
  if (kn) return Et;
  kn = 1;
  var e = ti();
  lt();
  var n = 1567752802062, r = 7, o, t;
  function s(a) {
    var l = "", u = Math.floor((Date.now() - n) * 1e-3);
    return u === t ? o++ : (o = 0, t = u), l = l + e(r), l = l + e(a), o > 0 && (l = l + e(o)), l = l + e(u), l;
  }
  return Et = s, Et;
}
var wt, Sn;
function ri() {
  if (Sn) return wt;
  Sn = 1;
  var e = lt();
  function n(r) {
    if (!r || typeof r != "string" || r.length < 6)
      return !1;
    var o = new RegExp("[^" + e.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]");
    return !o.test(r);
  }
  return wt = n, wt;
}
var Ct, On;
function oi() {
  return On || (On = 1, Ct = 0), Ct;
}
var Pn;
function ii() {
  return Pn || (Pn = 1, function(e) {
    var n = lt(), r = ni(), o = ri(), t = oi() || 0;
    function s(m) {
      return n.seed(m), e.exports;
    }
    function a(m) {
      return t = m, e.exports;
    }
    function l(m) {
      return m !== void 0 && n.characters(m), n.shuffled();
    }
    function u() {
      return r(t);
    }
    e.exports = u, e.exports.generate = u, e.exports.seed = s, e.exports.worker = a, e.exports.characters = l, e.exports.isValid = o;
  }(mt)), mt.exports;
}
var Dt, jn;
function si() {
  return jn || (jn = 1, Dt = ii()), Dt;
}
var ai = si();
const li = /* @__PURE__ */ Qe(ai), ui = se.div`
  position: ${(e) => e.selectorPosition};
  ${(e) => e.selectorTop ? `top: ${e.selectorTop}px` : ""};
  ${(e) => e.selectorRight ? `right: ${e.selectorRight}px` : ""};
  ${(e) => e.selectorBottom ? `bottom: ${e.selectorBottom}px` : ""};
  ${(e) => e.selectorLeft ? `left: ${e.selectorLeft}px` : ""};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(e) => e.selectorBackground};
  border-radius: 4px;
  cursor: pointer;
  height: ${(e) => e.selectorPadding + e.selectorHeight}px;
  width: ${(e) => e.selectorPadding + e.selectorWidth}px;
  .emojiIcon {
    height: ${(e) => e.selectorHeight}px;
    width: ${(e) => e.selectorWidth}px;
  }
  &:hover {
    background-color: ${(e) => e.selectorHoverBackground}
   
`, ci = se.div`
  display: ${(e) => e.open ? "flex" : "none"};
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: fixed;
  ${(e) => e.top ? `top: ${e.top}px;` : ""};
  ${(e) => e.right ? `right: ${e.right}px;` : ""};
  height: 40px;
  padding: ${(e) => e.renderSmallerVersion ? "4px 8px" : "8px"};
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15),
    2px 24px 24px 0 rgba(134, 139, 143, 0.2);
  background-color: #fff;
  & > div:not(:first-child) {
    margin-left: 8px;
  }
`, di = se.div.attrs({ className: "no-user-select" })`
  height: ${(e) => e.renderSmallerVersion ? "30px" : "40px"};
  width: ${(e) => e.renderSmallerVersion ? "30px" : "40px"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background-color: #fff;
  & > span {
    font-size: ${(e) => e.renderSmallerVersion ? "20px" : "24px"};
    line-height: 20px;
    color: #54555d;
  }
  &:hover {
    background-color: #e5f1ff;
  }
`, Mn = {
  emojis_data: {
    "👏": {
      enabled: !0,
      id: "2f26f82b-fbcb-11ea-bdd5-0215b6e3dd02"
    },
    "🙌": {
      enabled: !0,
      id: "9ae29f3b-fbcb-11ea-bdd5-0215b6e3dd02"
    },
    "🙏": {
      enabled: !0,
      id: "11587024-fbcc-11ea-bdd5-0215b6e3dd02"
    },
    "👍": {
      enabled: !0,
      id: "115d1b66-fbcc-11ea-bdd5-0215b6e3dd02"
    },
    "🚀": {
      enabled: !0,
      id: "11613a08-fbcc-11ea-bdd5-0215b6e3dd02"
    },
    "🔥": {
      enabled: !0,
      id: "1165560c-fbcc-11ea-bdd5-0215b6e3dd02"
    },
    "🎉": {
      enabled: !0,
      id: "1169bc22-fbcc-11ea-bdd5-0215b6e3dd02"
    }
  }
}, vr = (e) => {
  const {
    paletteHeight: n,
    paletteDistanceFromSelector: r,
    selectorImageUrlPaletteClosed: o,
    selectorImageUrlPaletteOpened: t,
    currentInputValue: s,
    inputContainerRef: a
  } = e, l = Ce(null), u = Ce(null), [m, f] = Y(
    s
  ), [E, w] = Y(!1), [y, D] = Y(null), [j, P] = Y(null), [N, M] = Y(!1);
  Z(() => {
    const { innerWidth: g } = window;
    g < 379 ? w(!0) : w(!1);
    const O = () => {
      g < 379 ? w(!0) : w(!1);
    };
    return window.addEventListener("resize", O, !0), () => window.removeEventListener("resize", O, !0);
  }, []), Z(() => {
    const g = (O) => {
      N && O.target !== u.current && M(!1);
    };
    return document.addEventListener("click", g), () => {
      document.removeEventListener("click", g);
    };
  });
  const b = () => {
    const { innerWidth: g } = window, O = l.current.getBoundingClientRect();
    D(
      g - (O.x + O.width)
    ), P(
      O.y - n - r
    );
  };
  Z(() => {
    s && !m && (b(), f(s)), !s && m && (b(), f(s));
  }, [s]);
  const x = () => {
    b(), M(!0);
  }, C = (g) => {
    if (a && a.current) {
      const O = a.current.selectionStart, v = a.current.selectionEnd;
      let A = O, d = v;
      const c = /\/\/~\[(\w|\d|\s|\$_-)*\]\((\w|\d|\s|-)*\)~\/\//g, k = /\[(\w|\d|\s|\$_-)*\]/;
      let R, _ = s;
      const B = [];
      for (R = _.match(c); R && R.length; ) {
        const T = _.indexOf(R[0]), q = R[0].match(k)[0], H = q.substring(
          1,
          q.length - 1
        ), V = "@".concat(H);
        _ = _.replace(R[0], V), B.push({
          start: T,
          end: T + V.length,
          lengthDiff: R[0].length - V.length
        }), R = _.match(c);
      }
      let I = !1;
      if (B.forEach((T) => {
        (O > T.start && O < T.end || v > T.start && v < T.end) && (I = !0), T.end <= O && (A += T.lengthDiff), T.end <= v && (d += T.lengthDiff);
      }), I) return;
      const L = s.substr(
        0,
        A
      ), $ = s.substr(
        d,
        s.length
      ), U = L && !L.endsWith(" ") ? " " : "", F = $ && !$.startsWith(" ") ? " " : "";
      e.onChange({
        target: {
          value: L.concat(U).concat(g).concat(F).concat($)
        }
      }), a.current.focus();
    } else
      e.onChange({
        target: {
          value: s.concat(s ? " " : "").concat(g)
        }
      });
  }, h = (g) => {
    e.onClick(g);
  }, S = Object.keys(Mn.emojis_data).filter((g) => Mn.emojis_data[g].enabled).map((g, O) => /* @__PURE__ */ p.jsx(
    di,
    {
      id: `emoji${O}`,
      onClick: () => {
        C(g), h(g);
      },
      children: /* @__PURE__ */ p.jsx("span", { children: g })
    },
    li.generate()
  ));
  return /* @__PURE__ */ p.jsxs("div", { children: [
    /* @__PURE__ */ p.jsx(
      ui,
      {
        id: "emojiContainer",
        ...e,
        onClick: x,
        ref: l,
        children: /* @__PURE__ */ p.jsx(
          Re,
          {
            alt: "reaction",
            className: "emojiIcon",
            src: N ? t : o
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      ci,
      {
        open: N,
        ref: u,
        renderSmallerVersion: E,
        right: y,
        top: j,
        children: S
      }
    )
  ] });
};
vr.propTypes = {
  selectorImageUrlPaletteClosed: i.string,
  selectorImageUrlPaletteOpened: i.string,
  selectorPosition: i.string,
  selectorBackground: i.string,
  selectorHoverBackground: i.string,
  selectorTop: i.oneOfType([i.object, i.number]),
  selectorRight: i.oneOfType([i.object, i.number]),
  selectorBottom: i.oneOfType([i.object, i.number]),
  selectorLeft: i.oneOfType([i.object, i.number]),
  selectorHeight: i.number,
  selectorWidth: i.number,
  selectorPadding: i.number,
  actionType: i.oneOf(["emoji", "reactions"]),
  paletteHeight: i.number,
  paletteDistanceFromSelector: i.number,
  currentInputValue: i.string,
  onChange: i.func,
  onClick: i.func,
  inputContainerRef: i.oneOfType([
    i.func,
    i.shape({ current: i.instanceOf(Element) })
  ])
};
vr.defaultProps = {
  selectorImageUrlPaletteClosed: "/assets/images/emoji-palette-close.svg",
  selectorImageUrlPaletteOpened: "/assets/images/emoji-palette-open.svg",
  selectorPosition: "absolute",
  selectorBackground: "base_100",
  selectorHoverBackground: "highlights_blue",
  selectorTop: null,
  selectorRight: 10,
  selectorBottom: 7,
  selectorLeft: null,
  selectorHeight: 30,
  selectorWidth: 30,
  selectorPadding: 7,
  actionType: "emoji",
  paletteHeight: 56,
  paletteDistanceFromSelector: 3,
  currentInputValue: "",
  onChange: () => {
  },
  onClick: () => {
  },
  inputContainerRef: null
};
const pi = se.div.attrs({
  className: "parentContainer"
})`
  height: auto;
  .repliesParentContainer {
    animation-duration: 1s;
    animation-name: slidein;
    border-left: 4px solid #f9b312;
    padding-left: 8px;
    border-radius: 2px;
  }
  .openCloseText {
    font-size: 14px;
    color: #2f53d7;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    margin-top: 8px;
  }
  .chevronIcon {
    padding-left: 4px;
  }
  @keyframes slidein {
    from {
      max-height: 0px;
      transform: translateY(0);
      opacity: 0;
    }

    to {
      max-height: 1000px;
      transform: translateY(1);
      opacity: 1;
    }
  }
`, sn = (e) => {
  const {
    replyRenderFunction: n,
    replies: r,
    closedText: o,
    hideText: t,
    onToggle: s,
    noAccordionReplyCount: a
  } = e, [l, u] = Y(!1), m = () => {
    u(!l), s();
  };
  return /* @__PURE__ */ p.jsxs(pi, { children: [
    l || a && r.length <= a ? /* @__PURE__ */ p.jsx("div", { className: "repliesParentContainer", children: r.map((f) => n(f)) }) : null,
    a && r.length <= a ? null : /* @__PURE__ */ p.jsxs("div", { className: "openCloseText", onClick: m, children: [
      l ? t : o,
      /* @__PURE__ */ p.jsx("div", { className: "chevronIcon", children: /* @__PURE__ */ p.jsx(
        fe,
        {
          color: "grey.100",
          icon: l ? Wr : Ur,
          size: "10px"
        }
      ) })
    ] })
  ] });
};
sn.propTypes = {
  /**
   *function to render each individual reply
   */
  replyRenderFunction: i.func,
  /**
   * Array of objects of each reply
   */
  replies: i.arrayOf(
    i.shape({
      id: i.string.isRequired,
      text: i.string
    })
  ),
  /**
   * String to show when the accordion is closed
   */
  closedText: i.string,
  /**
   * String to show when the accordion is open
   */
  hideText: i.string,
  /**
   *function to execute when the button is clicked
   */
  onToggle: i.func,
  noAccordionReplyCount: i.number
};
sn.defaultProps = {
  replyRenderFunction: () => {
  },
  replies: [{ id: "wdw" }],
  closedText: "show",
  hideText: "hide",
  onToggle: () => {
  },
  noAccordionReplyCount: 0
};
sn.displayName = "Replies Accordion";
function fi(e) {
  if (Array.isArray(e)) {
    for (var n = 0, r = new Array(e.length); n < e.length; n++)
      r[n] = e[n];
    return r;
  }
}
function hi(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]") return Array.from(e);
}
function gi() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function Ge(e) {
  return fi(e) || hi(e) || gi();
}
function pe() {
  return pe = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, pe.apply(this, arguments);
}
function mi(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function yi(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function bi(e, n, r) {
  return n && yi(e.prototype, n), e;
}
function X(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jt(e, n) {
  return jt = Object.setPrototypeOf || function(o, t) {
    return o.__proto__ = t, o;
  }, jt(e, n);
}
function vi(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && jt(e, n);
}
function Pe(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Pe = function(r) {
    return typeof r;
  } : Pe = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Pe(e);
}
function We(e) {
  return typeof Symbol == "function" && Pe(Symbol.iterator) === "symbol" ? We = function(r) {
    return Pe(r);
  } : We = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : Pe(r);
  }, We(e);
}
function xi(e, n) {
  return n && (We(n) === "object" || typeof n == "function") ? n : X(e);
}
function Je(e) {
  return Je = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Je(e);
}
function J(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
var kt, An;
function Ei() {
  if (An) return kt;
  An = 1;
  var e = function(n, r, o, t, s, a, l, u) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!n) {
      var m;
      if (r === void 0)
        m = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var f = [o, t, s, a, l, u], E = 0;
        m = new Error(
          r.replace(/%s/g, function() {
            return f[E++];
          })
        ), m.name = "Invariant Violation";
      }
      throw m.framesToPop = 1, m;
    }
  };
  return kt = e, kt;
}
var wi = Ei();
const je = /* @__PURE__ */ Qe(wi);
function Ci(e) {
  if (Array.isArray(e)) return e;
}
function Di(e, n) {
  var r = [], o = !0, t = !1, s = void 0;
  try {
    for (var a = e[Symbol.iterator](), l; !(o = (l = a.next()).done) && (r.push(l.value), !(n && r.length === n)); o = !0)
      ;
  } catch (u) {
    t = !0, s = u;
  } finally {
    try {
      !o && a.return != null && a.return();
    } finally {
      if (t) throw s;
    }
  }
  return r;
}
function ki() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function Xe(e, n) {
  return Ci(e) || Di(e, n) || ki();
}
function Si(e, n) {
  if (e == null) return {};
  var r = {}, o = Object.keys(e), t, s;
  for (s = 0; s < o.length; s++)
    t = o[s], !(n.indexOf(t) >= 0) && (r[t] = e[t]);
  return r;
}
function Oi(e, n) {
  if (e == null) return {};
  var r = Si(e, n), o, t;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (t = 0; t < s.length; t++)
      o = s[t], !(n.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (r[o] = e[o]);
  }
  return r;
}
function Ie(e) {
  "@babel/helpers - typeof";
  return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ie(e);
}
function Pi(e, n) {
  if (Ie(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var o = r.call(e, n);
    if (Ie(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function ji(e) {
  var n = Pi(e, "string");
  return Ie(n) == "symbol" ? n : n + "";
}
function Be(e, n, r) {
  return (n = ji(n)) in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Mt(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = Array(n); r < n; r++) o[r] = e[r];
  return o;
}
function Mi(e) {
  if (Array.isArray(e)) return Mt(e);
}
function Ai(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ti(e, n) {
  if (e) {
    if (typeof e == "string") return Mt(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Mt(e, n) : void 0;
  }
}
function Ni() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function be(e) {
  return Mi(e) || Ai(e) || Ti(e) || Ni();
}
var Me = function(n) {
  return n === Object(n) ? Object.keys(n) : [];
}, xr = function(n) {
  return n === Object(n) ? Object.values(n) : [];
};
function Er(e, n) {
  var r = Object.assign({}, e);
  return ze(e) && ze(n) && Me(n).forEach(function(o) {
    ze(n[o]) ? o in e ? r[o] = Er(e[o], n[o]) : Object.assign(r, Be({}, o, n[o])) : Object.assign(r, Be({}, o, n[o]));
  }), r;
}
var At = function(n) {
  for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), t = 1; t < r; t++)
    o[t - 1] = arguments[t];
  return o.reduce(function(s, a) {
    return Er(s, a);
  }, n);
}, Fi = function(n, r) {
  var o = Object.assign({}, n);
  if (r)
    for (var t = 0; t < r.length; t++)
      delete o[r[t]];
  return o;
}, ze = function(n) {
  return n === Object(n) && !(n instanceof Date) && !Array.isArray(n);
}, Ii = function(n) {
  return (n || []).filter(Boolean);
}, an = function(n) {
  return n[0] === "&";
}, Bi = function(n) {
  return !an(n);
}, Tn = function(n) {
  return n.replace(/-(\w)/g, function(r, o) {
    return o.toUpperCase();
  });
}, Ri = function(n) {
  for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], o = Me(n), t = {}, s = 0, a = o.length; s < a; s += 1) {
    var l = o[s], u = Object.prototype.toString.call(n[l]) !== "[object Object]" || // style defs
    l[0] === ":" || // pseudo selectors
    l[0] === "@" || // @media / @keyframes / @supports / @font-face
    r.indexOf(l) >= 0;
    u && (t[l] = n[l]);
  }
  return t;
}, wr = function(n, r) {
  for (var o = r.map(Tn), t = Me(n), s = {}, a = 0, l = t.length; a < l; a += 1) {
    var u = t[a];
    (r.indexOf(u) >= 0 || o.indexOf(Tn(u)) >= 0) && (s[u] = n[u]);
  }
  return s;
}, _i = function e(n, r) {
  for (var o = At.apply(void 0, [{}, Fi(n, r)].concat(be(xr(wr(n, r))))), t = Me(o).filter(an), s = 0, a = t.length; s < a; s += 1) {
    var l = t[s], u = e(o[l], r);
    r.indexOf(l) >= 0 ? (delete o[l], o = At({}, o, u)) : o[l] = u;
  }
  return o;
};
function Nn(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Fn(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Nn(Object(r), !0).forEach(function(o) {
      Be(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nn(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
var Li = ["animationName"], Cr = function(n) {
  var r = n.style, o = n.className;
  return Fn(Fn({}, r ? {
    style: Ri(r, Li)
  } : {}), o ? {
    className: o
  } : {});
}, Dr = /* @__PURE__ */ Zr(Cr);
Dr.Provider;
var kr = function(n) {
  if (n) {
    if (typeof n == "string")
      return [n];
    if (!Array.isArray(n)) {
      var r = n;
      return Me(n).reduce(function(o, t) {
        return o.concat(r[t] ? [t] : []);
      }, []);
    }
  } else return [];
  return n;
}, $i = {}, qi = function(n) {
  return function(r, o) {
    var t = o || $i;
    n.memoize = n.memoize || /* @__PURE__ */ new WeakMap();
    var s;
    n.memoize.has(t) ? s = n.memoize.get(t) : (s = {}, n.memoize.set(t, s));
    var a = kr(r).join(" ");
    return a in s ? s[a] : s[a] = n(r || [], o);
  };
};
function In(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Se(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? In(Object(r), !0).forEach(function(o) {
      Be(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : In(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
var Hi = function(n) {
  var r = n && Me(n)[0];
  return r && r.split("__")[0].split("--")[0];
}, Ui = function(n, r, o) {
  if (n) {
    var t = n.split(" ")[0], s = [].concat(be(r.length === 0 ? o.map(function(a) {
      return "".concat(t, "--").concat(a.substring(1));
    }) : []), be(r.map(function(a) {
      return "".concat(t, "__").concat(a);
    })));
    return r.length === 0 ? [n].concat(be(s)) : s;
  }
};
function Sr(e) {
  var n = e.style, r = e.className, o = e.classNames, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Cr, s = r || Hi(o) || n?.className, a = typeof n == "function" ? n : qi(function(E, w) {
    var y = kr(E);
    je(Array.isArray(y), "First parameter must be a string, an array of strings, a plain object with boolean values, or a falsy value."), je(!w || ze(w), "Optional second parameter must be a plain object.");
    var D = y.filter(an), j = y.filter(Bi), P = j.length > 0 ? function(b) {
      return xr(wr(b, j));
    } : function(b) {
      return [b];
    }, N = function() {
      var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return P(_i(x, D));
    }, M = Ui(s, j, D);
    return Sr(Se(Se(Se({}, (n || w) && {
      style: At.apply(void 0, [{}].concat(be(N(w)), be(N(n))))
    }), M && {
      className: M.join(" ")
    }), o && {
      classNames: o
    }), t);
  }), l = Se({}, typeof n == "function" ? n : {
    style: n
  }), u = be(new Set([].concat(be(l.className ? l.className.split(" ") : []), be(s ? s.split(" ") : [])))), m = o ? Ii(u.map(function(E) {
    return o[E];
  })) : u, f = t(Se(Se({}, l), m.length > 0 ? {
    className: m.join(" ")
  } : {}));
  return Object.assign(a, f), a;
}
function Bn(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Te(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Bn(Object(r), !0).forEach(function(o) {
      Be(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bn(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
var Wi = function() {
  for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  return r.reduce(function(t, s) {
    return Te(Te(Te({}, t), typeof s == "function" ? s : {}), {}, {
      style: Te(Te({}, t.style), typeof s == "function" ? s.style : s)
    });
  }, {});
}, ln = function(n, r, o) {
  var t = r.style, s = r.className, a = r.classNames, l = Ze(Dr), u = Ft(function() {
    return Sr({
      style: t,
      className: s,
      classNames: a
    }, l);
  }, [t, s, a, l]);
  return u(o, n);
}, Ve = function(n) {
  return n.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}, me = {
  id: "__id__",
  display: "__display__"
}, Rn = function(n, r) {
  je(r === "id" || r === "display", 'Second arg must be either "id" or "display", got: "'.concat(r, '"'));
  var o = n.indexOf(me.display), t = n.indexOf(me.id);
  return o < 0 && (o = null), t < 0 && (t = null), je(o !== null || t !== null, "The markup '".concat(n, "' does not contain either of the placeholders '__id__' or '__display__'")), o !== null && t !== null ? r === "id" && t <= o || r === "display" && o <= t ? 0 : 1 : 0;
}, zi = function(n) {
  var r = /^\/(.+)\/(\w+)?$/;
  return new RegExp(n.map(function(o) {
    var t = r.exec(o.toString()), s = Xe(t, 3), a = s[1], l = s[2];
    return je(!l, "RegExp flags are not supported. Change /".concat(a, "/").concat(l, " into /").concat(a, "/")), "(".concat(a, ")");
  }).join("|"), "g");
}, Or = function(n) {
  var r = 0;
  return n.indexOf("__id__") >= 0 && r++, n.indexOf("__display__") >= 0 && r++, r;
}, Vi = function() {
}, Le = function(n, r, o) {
  for (var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Vi, s = zi(r.map(function(C) {
    return C.regex;
  })), a = 2, l = r.map(function(C) {
    var h = C.markup, S = a;
    return a += Or(h) + 1, S;
  }), u, m = 0, f = 0; (u = s.exec(n)) !== null; ) {
    var E = l.find(function(C) {
      return !!u[C];
    }), w = l.indexOf(E), y = r[w], D = y.markup, j = y.displayTransform, P = E + Rn(D, "id"), N = E + Rn(D, "display"), M = u[P], b = j(M, u[N]), x = n.substring(m, u.index);
    t(x, m, f), f += x.length, o(u[0], u.index, f, M, b, w, m), f += b.length, m = s.lastIndex;
  }
  m < n.length && t(n.substring(m), m, f);
}, we = function(n, r) {
  var o = "";
  return Le(n, r, function(t, s, a, l, u) {
    o += u;
  }, function(t) {
    o += t;
  }), o;
}, ue = function(n, r, o) {
  var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "START";
  if (typeof o != "number")
    return o;
  var s, a = function(m, f, E) {
    s === void 0 && E + m.length >= o && (s = f + o - E);
  }, l = function(m, f, E, w, y, D, j) {
    s === void 0 && E + y.length > o && (t === "NULL" ? s = null : s = f + (t === "END" ? m.length : 0));
  };
  return Le(n, r, l, a), s === void 0 ? n.length : s;
}, Fe = function(n, r, o, t) {
  return n.substring(0, r) + t + n.substring(o);
}, Ki = function(n, r, o, t) {
  var s = o.selectionStartBefore, a = o.selectionEndBefore, l = o.selectionEndAfter, u = we(n, t), m = u.length - r.length;
  s === "undefined" && (s = l + m), a === "undefined" && (a = s), s === a && a === l && u.length === r.length && (s = s - 1);
  var f = r.slice(s, l), E = Math.min(s, l), w = a;
  s === l && (w = Math.max(a, s + m));
  var y = ue(n, t, E, "START"), D = ue(n, t, w, "END"), j = ue(n, t, E, "NULL"), P = ue(n, t, w, "NULL"), N = j === null || P === null, M = Fe(n, y, D, f);
  if (!N) {
    var b = we(M, t);
    if (b !== r) {
      for (E = 0; r[E] === b[E]; )
        E++;
      f = r.slice(E, l), w = u.lastIndexOf(r.substring(l)), y = ue(n, t, E, "START"), D = ue(n, t, w, "END"), M = Fe(n, y, D, f);
    }
  }
  return M;
}, _n = function(n, r, o) {
  var t = o, s = !1, a = function(u, m, f, E, w, y, D) {
    f <= o && f + w.length > o && (t = f, s = !0);
  };
  if (Le(n, r, a), s)
    return t;
}, Ne = function(n, r) {
  var o = [];
  return Le(n, r, function(t, s, a, l, u, m, f) {
    o.push({
      id: l,
      display: u,
      childIndex: m,
      index: s,
      plainTextIndex: a
    });
  }), o;
}, Pr = function(n, r) {
  return "".concat(n, "-").concat(r);
}, qe = function(n) {
  return Object.values(n).reduce(function(r, o) {
    var t = o.results;
    return r + t.length;
  }, 0);
}, Yi = function(n, r) {
  var o = Ne(n, r), t = o[o.length - 1];
  return t ? t.plainTextIndex + t.display.length : 0;
}, Gi = function(n) {
  var r = Ve(n), o = n[n.indexOf(me.display) + me.display.length], t = n[n.indexOf(me.id) + me.id.length];
  return new RegExp(r.replace(me.display, "([^".concat(Ve(o || ""), "]+?)")).replace(me.id, "([^".concat(Ve(t || ""), "]+?)")));
}, ve = function(n) {
  return xe.toArray(n).map(function(r) {
    var o = r.props, t = o.markup, s = o.regex, a = o.displayTransform;
    return {
      markup: t,
      regex: s ? Ji(s, t) : Gi(t),
      displayTransform: a || function(l, u) {
        return u || l;
      }
    };
  });
}, Ji = function(n, r) {
  var o = new RegExp(n.toString() + "|").exec("").length - 1, t = Or(r);
  return je(o === t, "Number of capturing groups in RegExp ".concat(n.toString(), " (").concat(o, ") does not match the number of placeholders in the markup '").concat(r, "' (").concat(t, ")")), n;
}, Xi = function(n, r, o) {
  return n.replace(me.id, r).replace(me.display, o);
}, Qi = [{
  base: "A",
  letters: /(&#65;|&#9398;|&#65313;|&#192;|&#193;|&#194;|&#7846;|&#7844;|&#7850;|&#7848;|&#195;|&#256;|&#258;|&#7856;|&#7854;|&#7860;|&#7858;|&#550;|&#480;|&#196;|&#478;|&#7842;|&#197;|&#506;|&#461;|&#512;|&#514;|&#7840;|&#7852;|&#7862;|&#7680;|&#260;|&#570;|&#11375;|[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F])/g
}, {
  base: "AA",
  letters: /(&#42802;|[\uA732])/g
}, {
  base: "AE",
  letters: /(&#198;|&#508;|&#482;|[\u00C6\u01FC\u01E2])/g
}, {
  base: "AO",
  letters: /(&#42804;|[\uA734])/g
}, {
  base: "AU",
  letters: /(&#42806;|[\uA736])/g
}, {
  base: "AV",
  letters: /(&#42808;|&#42810;|[\uA738\uA73A])/g
}, {
  base: "AY",
  letters: /(&#42812;|[\uA73C])/g
}, {
  base: "B",
  letters: /(&#66;|&#9399;|&#65314;|&#7682;|&#7684;|&#7686;|&#579;|&#386;|&#385;|[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181])/g
}, {
  base: "C",
  letters: /(&#67;|&#9400;|&#65315;|&#262;|&#264;|&#266;|&#268;|&#199;|&#7688;|&#391;|&#571;|&#42814;|[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E])/g
}, {
  base: "D",
  letters: /(&#68;|&#9401;|&#65316;|&#7690;|&#270;|&#7692;|&#7696;|&#7698;|&#7694;|&#272;|&#395;|&#394;|&#393;|&#42873;|&#208;|[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0])/g
}, {
  base: "DZ",
  letters: /(&#497;|&#452;|[\u01F1\u01C4])/g
}, {
  base: "Dz",
  letters: /(&#498;|&#453;|[\u01F2\u01C5])/g
}, {
  base: "E",
  letters: /(&#69;|&#9402;|&#65317;|&#200;|&#201;|&#202;|&#7872;|&#7870;|&#7876;|&#7874;|&#7868;|&#274;|&#7700;|&#7702;|&#276;|&#278;|&#203;|&#7866;|&#282;|&#516;|&#518;|&#7864;|&#7878;|&#552;|&#7708;|&#280;|&#7704;|&#7706;|&#400;|&#398;|[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E])/g
}, {
  base: "F",
  letters: /(&#70;|&#9403;|&#65318;|&#7710;|&#401;|&#42875;|[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B])/g
}, {
  base: "G",
  letters: /(&#71;|&#9404;|&#65319;|&#500;|&#284;|&#7712;|&#286;|&#288;|&#486;|&#290;|&#484;|&#403;|&#42912;|&#42877;|&#42878;|[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E])/g
}, {
  base: "H",
  letters: /(&#72;|&#9405;|&#65320;|&#292;|&#7714;|&#7718;|&#542;|&#7716;|&#7720;|&#7722;|&#294;|&#11367;|&#11381;|&#42893;|[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D])/g
}, {
  base: "I",
  letters: /(&#73;|&#9406;|&#65321;|&#204;|&#205;|&#206;|&#296;|&#298;|&#300;|&#304;|&#207;|&#7726;|&#7880;|&#463;|&#520;|&#522;|&#7882;|&#302;|&#7724;|&#407;|[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197])/g
}, {
  base: "J",
  letters: /(&#74;|&#9407;|&#65322;|&#308;|&#584;|[\u004A\u24BF\uFF2A\u0134\u0248])/g
}, {
  base: "K",
  letters: /(&#75;|&#9408;|&#65323;|&#7728;|&#488;|&#7730;|&#310;|&#7732;|&#408;|&#11369;|&#42816;|&#42818;|&#42820;|&#42914;|[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2])/g
}, {
  base: "L",
  letters: /(&#76;|&#9409;|&#65324;|&#319;|&#313;|&#317;|&#7734;|&#7736;|&#315;|&#7740;|&#7738;|&#321;|&#573;|&#11362;|&#11360;|&#42824;|&#42822;|&#42880;|[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780])/g
}, {
  base: "LJ",
  letters: /(&#455;|[\u01C7])/g
}, {
  base: "Lj",
  letters: /(&#456;|[\u01C8])/g
}, {
  base: "M",
  letters: /(&#77;|&#9410;|&#65325;|&#7742;|&#7744;|&#7746;|&#11374;|&#412;|[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C])/g
}, {
  base: "N",
  letters: /(&#78;|&#9411;|&#65326;|&#504;|&#323;|&#209;|&#7748;|&#327;|&#7750;|&#325;|&#7754;|&#7752;|&#544;|&#413;|&#42896;|&#42916;|&#330;|[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4\u014A])/g
}, {
  base: "NJ",
  letters: /(&#458;|[\u01CA])/g
}, {
  base: "Nj",
  letters: /(&#459;|[\u01CB])/g
}, {
  base: "O",
  letters: /(&#79;|&#9412;|&#65327;|&#210;|&#211;|&#212;|&#7890;|&#7888;|&#7894;|&#7892;|&#213;|&#7756;|&#556;|&#7758;|&#332;|&#7760;|&#7762;|&#334;|&#558;|&#560;|&#214;|&#554;|&#7886;|&#336;|&#465;|&#524;|&#526;|&#416;|&#7900;|&#7898;|&#7904;|&#7902;|&#7906;|&#7884;|&#7896;|&#490;|&#492;|&#216;|&#510;|&#390;|&#415;|&#42826;|&#42828;|[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C])/g
}, {
  base: "OE",
  letters: /(&#338;|[\u0152])/g
}, {
  base: "OI",
  letters: /(&#418;|[\u01A2])/g
}, {
  base: "OO",
  letters: /(&#42830;|[\uA74E])/g
}, {
  base: "OU",
  letters: /(&#546;|[\u0222])/g
}, {
  base: "P",
  letters: /(&#80;|&#9413;|&#65328;|&#7764;|&#7766;|&#420;|&#11363;|&#42832;|&#42834;|&#42836;|[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754])/g
}, {
  base: "Q",
  letters: /(&#81;|&#9414;|&#65329;|&#42838;|&#42840;|&#586;|[\u0051\u24C6\uFF31\uA756\uA758\u024A])/g
}, {
  base: "R",
  letters: /(&#82;|&#9415;|&#65330;|&#340;|&#7768;|&#344;|&#528;|&#530;|&#7770;|&#7772;|&#342;|&#7774;|&#588;|&#11364;|&#42842;|&#42918;|&#42882;|[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782])/g
}, {
  base: "S",
  letters: /(&#83;|&#9416;|&#65331;|&#7838;|&#346;|&#7780;|&#348;|&#7776;|&#352;|&#7782;|&#7778;|&#7784;|&#536;|&#350;|&#11390;|&#42920;|&#42884;|[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784])/g
}, {
  base: "T",
  letters: /(&#84;|&#9417;|&#65332;|&#7786;|&#356;|&#7788;|&#538;|&#354;|&#7792;|&#7790;|&#358;|&#428;|&#430;|&#574;|&#42886;|[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786])/g
}, {
  base: "TH",
  letters: /(&#222;|[\u00DE])/g
}, {
  base: "TZ",
  letters: /(&#42792;|[\uA728])/g
}, {
  base: "U",
  letters: /(&#85;|&#9418;|&#65333;|&#217;|&#218;|&#219;|&#360;|&#7800;|&#362;|&#7802;|&#364;|&#220;|&#475;|&#471;|&#469;|&#473;|&#7910;|&#366;|&#368;|&#467;|&#532;|&#534;|&#431;|&#7914;|&#7912;|&#7918;|&#7916;|&#7920;|&#7908;|&#7794;|&#370;|&#7798;|&#7796;|&#580;|[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244])/g
}, {
  base: "V",
  letters: /(&#86;|&#9419;|&#65334;|&#7804;|&#7806;|&#434;|&#42846;|&#581;|[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245])/g
}, {
  base: "VY",
  letters: /(&#42848;|[\uA760])/g
}, {
  base: "W",
  letters: /(&#87;|&#9420;|&#65335;|&#7808;|&#7810;|&#372;|&#7814;|&#7812;|&#7816;|&#11378;|[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72])/g
}, {
  base: "X",
  letters: /(&#88;|&#9421;|&#65336;|&#7818;|&#7820;|[\u0058\u24CD\uFF38\u1E8A\u1E8C])/g
}, {
  base: "Y",
  letters: /(&#89;|&#9422;|&#65337;|&#7922;|&#221;|&#374;|&#7928;|&#562;|&#7822;|&#376;|&#7926;|&#7924;|&#435;|&#590;|&#7934;|[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE])/g
}, {
  base: "Z",
  letters: /(&#90;|&#9423;|&#65338;|&#377;|&#7824;|&#379;|&#381;|&#7826;|&#7828;|&#437;|&#548;|&#11391;|&#11371;|&#42850;|[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762])/g
}, {
  base: "a",
  letters: /(&#97;|&#9424;|&#65345;|&#7834;|&#224;|&#225;|&#226;|&#7847;|&#7845;|&#7851;|&#7849;|&#227;|&#257;|&#259;|&#7857;|&#7855;|&#7861;|&#7859;|&#551;|&#481;|&#228;|&#479;|&#7843;|&#229;|&#507;|&#462;|&#513;|&#515;|&#7841;|&#7853;|&#7863;|&#7681;|&#261;|&#11365;|&#592;|[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250])/g
}, {
  base: "aa",
  letters: /(&#42803;|[\uA733])/g
}, {
  base: "ae",
  letters: /(&#230;|&#509;|&#483;|[\u00E6\u01FD\u01E3])/g
}, {
  base: "ao",
  letters: /(&#42805;|[\uA735])/g
}, {
  base: "au",
  letters: /(&#42807;|[\uA737])/g
}, {
  base: "av",
  letters: /(&#42809;|&#42811;|[\uA739\uA73B])/g
}, {
  base: "ay",
  letters: /(&#42813;|[\uA73D])/g
}, {
  base: "b",
  letters: /(&#98;|&#9425;|&#65346;|&#7683;|&#7685;|&#7687;|&#384;|&#387;|&#595;|[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253])/g
}, {
  base: "c",
  letters: /(&#99;|&#9426;|&#65347;|&#263;|&#265;|&#267;|&#269;|&#231;|&#7689;|&#392;|&#572;|&#42815;|&#8580;|[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184])/g
}, {
  base: "d",
  letters: /(&#100;|&#9427;|&#65348;|&#7691;|&#271;|&#7693;|&#7697;|&#7699;|&#7695;|&#273;|&#396;|&#598;|&#599;|&#42874;|&#240;|[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A\u00F0])/g
}, {
  base: "dz",
  letters: /(&#499;|&#454;|[\u01F3\u01C6])/g
}, {
  base: "e",
  letters: /(&#101;|&#9428;|&#65349;|&#232;|&#233;|&#234;|&#7873;|&#7871;|&#7877;|&#7875;|&#7869;|&#275;|&#7701;|&#7703;|&#277;|&#279;|&#235;|&#7867;|&#283;|&#517;|&#519;|&#7865;|&#7879;|&#553;|&#7709;|&#281;|&#7705;|&#7707;|&#583;|&#603;|&#477;|[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD])/g
}, {
  base: "f",
  letters: /(&#102;|&#9429;|&#65350;|&#7711;|&#402;|&#42876;|[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C])/g
}, {
  base: "g",
  letters: /(&#103;|&#9430;|&#65351;|&#501;|&#285;|&#7713;|&#287;|&#289;|&#487;|&#291;|&#485;|&#608;|&#42913;|&#7545;|&#42879;|[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F])/g
}, {
  base: "h",
  letters: /(&#104;|&#9431;|&#65352;|&#293;|&#7715;|&#7719;|&#543;|&#7717;|&#7721;|&#7723;|&#7830;|&#295;|&#11368;|&#11382;|&#613;|[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265])/g
}, {
  base: "hv",
  letters: /(&#405;|[\u0195])/g
}, {
  base: "i",
  letters: /(&#105;|&#9432;|&#65353;|&#236;|&#237;|&#238;|&#297;|&#299;|&#301;|&#239;|&#7727;|&#7881;|&#464;|&#521;|&#523;|&#7883;|&#303;|&#7725;|&#616;|&#305;|[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131])/g
}, {
  base: "ij",
  letters: /(&#307;|[\u0133])/g
}, {
  base: "j",
  letters: /(&#106;|&#9433;|&#65354;|&#309;|&#496;|&#585;|[\u006A\u24D9\uFF4A\u0135\u01F0\u0249])/g
}, {
  base: "k",
  letters: /(&#107;|&#9434;|&#65355;|&#7729;|&#489;|&#7731;|&#311;|&#7733;|&#409;|&#11370;|&#42817;|&#42819;|&#42821;|&#42915;|[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3])/g
}, {
  base: "l",
  letters: /(&#108;|&#9435;|&#65356;|&#320;|&#314;|&#318;|&#7735;|&#7737;|&#316;|&#7741;|&#7739;|&#322;|&#410;|&#619;|&#11361;|&#42825;|&#42881;|&#42823;|[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u0142\u019A\u026B\u2C61\uA749\uA781\uA747])/g
}, {
  base: "lj",
  letters: /(&#457;|[\u01C9])/g
}, {
  base: "m",
  letters: /(&#109;|&#9436;|&#65357;|&#7743;|&#7745;|&#7747;|&#625;|&#623;|[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F])/g
}, {
  base: "n",
  letters: /(&#110;|&#9437;|&#65358;|&#505;|&#324;|&#241;|&#7749;|&#328;|&#7751;|&#326;|&#7755;|&#7753;|&#414;|&#626;|&#329;|&#42897;|&#42917;|&#331;|[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u014B])/g
}, {
  base: "nj",
  letters: /(&#460;|[\u01CC])/g
}, {
  base: "o",
  letters: /(&#111;|&#9438;|&#65359;|&#242;|&#243;|&#244;|&#7891;|&#7889;|&#7895;|&#7893;|&#245;|&#7757;|&#557;|&#7759;|&#333;|&#7761;|&#7763;|&#335;|&#559;|&#561;|&#246;|&#555;|&#7887;|&#337;|&#466;|&#525;|&#527;|&#417;|&#7901;|&#7899;|&#7905;|&#7903;|&#7907;|&#7885;|&#7897;|&#491;|&#493;|&#248;|&#511;|&#596;|&#42827;|&#42829;|&#629;|[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275])/g
}, {
  base: "oe",
  letters: /(&#339;|[\u0153])/g
}, {
  base: "oi",
  letters: /(&#419;|[\u01A3])/g
}, {
  base: "ou",
  letters: /(&#547;|[\u0223])/g
}, {
  base: "oo",
  letters: /(&#42831;|[\uA74F])/g
}, {
  base: "p",
  letters: /(&#112;|&#9439;|&#65360;|&#7765;|&#7767;|&#421;|&#7549;|&#42833;|&#42835;|&#42837;|[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755])/g
}, {
  base: "q",
  letters: /(&#113;|&#9440;|&#65361;|&#587;|&#42839;|&#42841;|[\u0071\u24E0\uFF51\u024B\uA757\uA759])/g
}, {
  base: "r",
  letters: /(&#114;|&#9441;|&#65362;|&#341;|&#7769;|&#345;|&#529;|&#531;|&#7771;|&#7773;|&#343;|&#7775;|&#589;|&#637;|&#42843;|&#42919;|&#42883;|[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783])/g
}, {
  base: "s",
  letters: /(&#115;|&#9442;|&#65363;|&#347;|&#7781;|&#349;|&#7777;|&#353;|&#7783;|&#7779;|&#7785;|&#537;|&#351;|&#575;|&#42921;|&#42885;|&#7835;|&#383;|[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u017F])/g
}, {
  base: "ss",
  letters: /(&#223;|[\u00DF])/g
}, {
  base: "t",
  letters: /(&#116;|&#9443;|&#65364;|&#7787;|&#7831;|&#357;|&#7789;|&#539;|&#355;|&#7793;|&#7791;|&#359;|&#429;|&#648;|&#11366;|&#42887;|[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787])/g
}, {
  base: "th",
  letters: /(&#254;|[\u00FE])/g
}, {
  base: "tz",
  letters: /(&#42793;|[\uA729])/g
}, {
  base: "u",
  letters: /(&#117;|&#9444;|&#65365;|&#249;|&#250;|&#251;|&#361;|&#7801;|&#363;|&#7803;|&#365;|&#252;|&#476;|&#472;|&#470;|&#474;|&#7911;|&#367;|&#369;|&#468;|&#533;|&#535;|&#432;|&#7915;|&#7913;|&#7919;|&#7917;|&#7921;|&#7909;|&#7795;|&#371;|&#7799;|&#7797;|&#649;|[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289])/g
}, {
  base: "v",
  letters: /(&#118;|&#9445;|&#65366;|&#7805;|&#7807;|&#651;|&#42847;|&#652;|[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C])/g
}, {
  base: "vy",
  letters: /(&#42849;|[\uA761])/g
}, {
  base: "w",
  letters: /(&#119;|&#9446;|&#65367;|&#7809;|&#7811;|&#373;|&#7815;|&#7813;|&#7832;|&#7817;|&#11379;|[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73])/g
}, {
  base: "x",
  letters: /(&#120;|&#9447;|&#65368;|&#7819;|&#7821;|[\u0078\u24E7\uFF58\u1E8B\u1E8D])/g
}, {
  base: "y",
  letters: /(&#121;|&#9448;|&#65369;|&#7923;|&#253;|&#375;|&#7929;|&#563;|&#7823;|&#255;|&#7927;|&#7833;|&#7925;|&#436;|&#591;|&#7935;|[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF])/g
}, {
  base: "z",
  letters: /(&#122;|&#9449;|&#65370;|&#378;|&#7825;|&#380;|&#382;|&#7827;|&#7829;|&#438;|&#549;|&#576;|&#11372;|&#42851;|[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763])/g
}], Zi = function(n) {
  var r = n;
  return Qi.forEach(function(o) {
    r = r.replace(o.letters, o.base);
  }), r;
}, Ln = function(n) {
  return Zi(n).toLowerCase();
}, jr = function(n, r, o) {
  return o ? Ln(n).indexOf(Ln(r)) : n.toLowerCase().indexOf(r.toLowerCase());
}, es = function() {
  return !!document.documentMode;
}, Tt = function(n) {
  return typeof n == "number";
}, ts = function(n) {
  return n === Object(n) ? Object.keys(n) : [];
}, ns = function(n) {
  for (var r, o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
    t[s - 1] = arguments[s];
  var a = (r = []).concat.apply(r, t);
  return Object.keys(n).reduce(function(l, u) {
    return n.hasOwnProperty(u) && !a.includes(u) && n[u] !== void 0 && (l[u] = n[u]), l;
  }, {});
}, rs = ["style", "className", "classNames"];
function $n(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function qn(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? $n(Object(r), !0).forEach(function(o) {
      J(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $n(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function ut(e, n) {
  var r = function(t) {
    var s = function(u) {
      var m = u.style, f = u.className, E = u.classNames, w = Oi(u, rs), y = n ? n(w) : void 0, D = ln(e, {
        style: m,
        className: f,
        classNames: E
      }, y);
      return /* @__PURE__ */ G.createElement(t, pe({}, w, {
        style: D
      }));
    }, a = t.displayName || t.name || "Component";
    return s.displayName = "defaultStyle(".concat(a, ")"), /* @__PURE__ */ G.forwardRef(function(l, u) {
      return s(qn(qn({}, l), {}, {
        ref: u
      }));
    });
  };
  return r;
}
var os = function(n, r) {
  return n.hasOwnProperty(r) ? n[r]++ : n[r] = 0, r + "_" + n[r];
};
function Mr(e) {
  var n = e.selectionStart, r = e.selectionEnd, o = e.value, t = o === void 0 ? "" : o, s = e.onCaretPositionChange, a = e.containerRef, l = e.children;
  e.singleLine;
  var u = e.style, m = Y({
    left: void 0,
    top: void 0
  }), f = Xe(m, 2), E = f[0], w = f[1], y = Y(), D = Xe(y, 2), j = D[0], P = D[1];
  Z(function() {
    N();
  });
  var N = function() {
    if (j) {
      var k = j.offsetLeft, R = j.offsetTop;
      if (!(E.left === k && E.top === R)) {
        var _ = {
          left: k,
          top: R
        };
        w(_), s(_);
      }
    }
  }, M = ve(l), b;
  r === n && (b = ue(t, M, n, "START"));
  var x = [], C = {}, h = x, S = 0, g = function(k, R, _) {
    if (Tt(b) && b >= R && b <= R + k.length) {
      var B = b - R;
      h.push(v(k.substring(0, B), S)), h = [v(k.substring(B), S)];
    } else
      h.push(v(k, S));
    S++;
  }, O = function(k, R, _, B, I, L, $) {
    var U = os(C, B);
    h.push(A(B, I, L, U));
  }, v = function(k, R) {
    return /* @__PURE__ */ G.createElement("span", pe({}, u("substring"), {
      key: R
    }), k);
  }, A = function(k, R, _, B) {
    var I = {
      id: k,
      display: R,
      key: B
    }, L = xe.toArray(l)[_];
    return /* @__PURE__ */ G.cloneElement(L, I);
  }, d = function(k) {
    return /* @__PURE__ */ G.createElement("span", pe({}, u("caret"), {
      ref: P,
      key: "caret"
    }), k);
  };
  return Le(t, M, O, g), h.push(" "), h !== x && x.push(d(h)), /* @__PURE__ */ G.createElement("div", pe({}, u, {
    ref: a
  }), x);
}
Mr.propTypes = {
  selectionStart: i.number,
  selectionEnd: i.number,
  value: i.string.isRequired,
  onCaretPositionChange: i.func.isRequired,
  containerRef: i.oneOfType([i.func, i.shape({
    current: typeof Element > "u" ? i.any : i.instanceOf(Element)
  })]),
  children: i.oneOfType([i.element, i.arrayOf(i.element)]).isRequired
};
var is = ut({
  position: "relative",
  boxSizing: "border-box",
  width: "100%",
  color: "transparent",
  overflow: "hidden",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  border: "1px solid transparent",
  textAlign: "start",
  "&singleLine": {
    whiteSpace: "pre",
    wordWrap: null
  },
  substring: {
    visibility: "hidden"
  }
}, function(e) {
  return {
    "&singleLine": e.singleLine
  };
}), ss = is(Mr);
function Ar(e) {
  var n = e.id, r = e.focused, o = e.ignoreAccents, t = e.index, s = e.onClick, a = e.onMouseEnter, l = e.query, u = e.renderSuggestion, m = e.suggestion, f = e.style;
  e.className, e.classNames;
  var E = {
    onClick: s,
    onMouseEnter: a
  }, w = function() {
    var P = y(), N = D(P);
    return u ? u(m, l, N, t, r) : N;
  }, y = function() {
    if (typeof m == "string")
      return m;
    var P = m.id, N = m.display;
    return P === void 0 || !N ? P : N;
  }, D = function(P) {
    var N = jr(P, l, o);
    return N === -1 ? /* @__PURE__ */ G.createElement("span", f("display"), P) : /* @__PURE__ */ G.createElement("span", f("display"), P.substring(0, N), /* @__PURE__ */ G.createElement("b", f("highlight"), P.substring(N, N + l.length)), P.substring(N + l.length));
  };
  return /* @__PURE__ */ G.createElement("li", pe({
    id: n,
    role: "option",
    "aria-selected": r
  }, E, f), w());
}
Ar.propTypes = {
  id: i.string.isRequired,
  query: i.string.isRequired,
  index: i.number.isRequired,
  ignoreAccents: i.bool,
  suggestion: i.oneOfType([i.string, i.shape({
    id: i.oneOfType([i.string, i.number]).isRequired,
    display: i.string
  })]).isRequired,
  renderSuggestion: i.func,
  focused: i.bool
};
var as = ut({
  cursor: "pointer"
}, function(e) {
  return {
    "&focused": e.focused
  };
}), ls = as(Ar);
function us(e) {
  var n = e.style, r = e.className, o = e.classNames, t = ln(cs, {
    style: n,
    className: r,
    classNames: o
  }), s = t("spinner");
  return /* @__PURE__ */ G.createElement("div", t, /* @__PURE__ */ G.createElement("div", s, /* @__PURE__ */ G.createElement("div", s(["element", "element1"])), /* @__PURE__ */ G.createElement("div", s(["element", "element2"])), /* @__PURE__ */ G.createElement("div", s(["element", "element3"])), /* @__PURE__ */ G.createElement("div", s(["element", "element4"])), /* @__PURE__ */ G.createElement("div", s(["element", "element5"]))));
}
var cs = {};
function Tr(e) {
  var n = e.id, r = e.suggestions, o = r === void 0 ? {} : r, t = e.a11ySuggestionsListLabel, s = e.focusIndex, a = e.position, l = e.left, u = e.right, m = e.top, f = e.scrollFocusedIntoView, E = e.isLoading, w = e.isOpened, y = e.onSelect, D = y === void 0 ? function() {
    return null;
  } : y, j = e.ignoreAccents, P = e.containerRef, N = e.children, M = e.style, b = e.customSuggestionsContainer, x = e.onMouseDown, C = e.onMouseEnter, h = Y(void 0), S = Xe(h, 2), g = S[0], O = S[1];
  Z(function() {
    if (!(!g || g.offsetHeight >= g.scrollHeight || !f)) {
      var _ = g.scrollTop, B = g.children[s].getBoundingClientRect(), I = B.top, L = B.bottom, $ = g.getBoundingClientRect(), U = $.top;
      I = I - U + _, L = L - U + _, I < _ ? g.scrollTop = I : L > g.offsetHeight && (g.scrollTop = L - g.offsetHeight);
    }
  }, [s, f, g]);
  var v = function() {
    var B = /* @__PURE__ */ G.createElement("ul", pe({
      ref: O,
      id: n,
      role: "listbox",
      "aria-label": t
    }, M("list")), Object.values(o).reduce(function(I, L) {
      var $ = L.results, U = L.queryInfo;
      return [].concat(Ge(I), Ge($.map(function(F, T) {
        return A(F, U, I.length + T);
      })));
    }, []));
    return b ? b(B) : B;
  }, A = function(B, I, L) {
    var $ = L === s, U = I.childIndex, F = I.query, T = xe.toArray(N)[U].props.renderSuggestion;
    return /* @__PURE__ */ G.createElement(ls, {
      style: M("item"),
      key: "".concat(U, "-").concat(R(B)),
      id: Pr(n, L),
      query: F,
      index: L,
      ignoreAccents: j,
      renderSuggestion: T,
      suggestion: B,
      focused: $,
      onClick: function() {
        return k(B, I);
      },
      onMouseEnter: function() {
        return c(L);
      }
    });
  }, d = function() {
    if (E)
      return /* @__PURE__ */ G.createElement(us, {
        style: M("loadingIndicator")
      });
  }, c = function(B, I) {
    C && C(B);
  }, k = function(B, I) {
    D(B, I);
  }, R = function(B) {
    return typeof B == "string" ? B : B.id;
  };
  return w ? /* @__PURE__ */ G.createElement("div", pe({}, Wi({
    position: a || "absolute",
    left: l,
    right: u,
    top: m
  }, M), {
    onMouseDown: x,
    ref: P
  }), v(), d()) : null;
}
Tr.propTypes = {
  id: i.string.isRequired,
  suggestions: i.object.isRequired,
  a11ySuggestionsListLabel: i.string,
  focusIndex: i.number,
  position: i.string,
  left: i.number,
  right: i.number,
  top: i.number,
  scrollFocusedIntoView: i.bool,
  isLoading: i.bool,
  isOpened: i.bool.isRequired,
  onSelect: i.func,
  ignoreAccents: i.bool,
  customSuggestionsContainer: i.func,
  containerRef: i.oneOfType([i.func, i.shape({
    current: typeof Element > "u" ? i.any : i.instanceOf(Element)
  })])
};
var ds = ut({
  zIndex: 1,
  backgroundColor: "white",
  marginTop: 14,
  minWidth: 100,
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  }
}), ps = ds(Tr);
function Hn(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function he(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Hn(Object(r), !0).forEach(function(o) {
      J(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hn(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function fs(e) {
  var n = hs();
  return function() {
    var o = Je(e), t;
    if (n) {
      var s = Je(this).constructor;
      t = Reflect.construct(o, arguments, s);
    } else
      t = o.apply(this, arguments);
    return xi(this, t);
  };
}
function hs() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var gs = function(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (n instanceof RegExp)
    return n;
  var o = r.allowSpaceInQuery, t = Ve(n);
  return new RegExp("(?:^|\\s)(".concat(t, "([^").concat(o ? "" : "\\s").concat(t, "]*))$"));
}, ms = function(n, r) {
  return n instanceof Array ? function(o, t) {
    for (var s = [], a = 0, l = n.length; a < l; ++a) {
      var u = n[a].display || n[a].id;
      jr(u, o, r) >= 0 && s.push(n[a]);
    }
    return s;
  } : n;
}, Oe = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40
}, He = !1, Nr = {
  /**
   * If set to `true` a regular text input element will be rendered
   * instead of a textarea
   */
  singleLine: i.bool,
  allowSpaceInQuery: i.bool,
  allowSuggestionsAboveCursor: i.bool,
  forceSuggestionsAboveCursor: i.bool,
  ignoreAccents: i.bool,
  a11ySuggestionsListLabel: i.string,
  value: i.string,
  onKeyDown: i.func,
  customSuggestionsContainer: i.func,
  onSelect: i.func,
  onBlur: i.func,
  onChange: i.func,
  suggestionsPortalHost: typeof Element > "u" ? i.any : i.PropTypes.instanceOf(Element),
  inputRef: i.oneOfType([i.func, i.shape({
    current: typeof Element > "u" ? i.any : i.instanceOf(Element)
  })]),
  children: i.oneOfType([i.element, i.arrayOf(i.element)]).isRequired
}, un = /* @__PURE__ */ function(e) {
  vi(r, e);
  var n = fs(r);
  function r(o) {
    var t;
    return mi(this, r), t = n.call(this, o), J(X(t), "setContainerElement", function(s) {
      t.containerElement = s;
    }), J(X(t), "getInputProps", function() {
      var s = t.props, a = s.readOnly, l = s.disabled, u = s.style, m = ns(
        t.props,
        ["style", "classNames", "className"],
        // substyle props
        ts(Nr)
      );
      return he(he(he(he({}, m), u("input")), {}, {
        value: t.getPlainText(),
        onScroll: t.updateHighlighterScroll
      }, !a && !l && {
        onChange: t.handleChange,
        onSelect: t.handleSelect,
        onKeyDown: t.handleKeyDown,
        onBlur: t.handleBlur,
        onCompositionStart: t.handleCompositionStart,
        onCompositionEnd: t.handleCompositionEnd
      }), t.isOpened() && {
        role: "combobox",
        "aria-controls": t.uuidSuggestionsOverlay,
        "aria-expanded": !0,
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-activedescendant": Pr(t.uuidSuggestionsOverlay, t.state.focusIndex)
      });
    }), J(X(t), "renderControl", function() {
      var s = t.props, a = s.singleLine, l = s.style, u = t.getInputProps();
      return /* @__PURE__ */ G.createElement("div", l("control"), t.renderHighlighter(), a ? t.renderInput(u) : t.renderTextarea(u));
    }), J(X(t), "renderInput", function(s) {
      return /* @__PURE__ */ G.createElement("input", pe({
        type: "text",
        ref: t.setInputRef
      }, s));
    }), J(X(t), "renderTextarea", function(s) {
      return /* @__PURE__ */ G.createElement("textarea", pe({
        ref: t.setInputRef
      }, s));
    }), J(X(t), "setInputRef", function(s) {
      t.inputElement = s;
      var a = t.props.inputRef;
      typeof a == "function" ? a(s) : a && (a.current = s);
    }), J(X(t), "setSuggestionsElement", function(s) {
      t.suggestionsElement = s;
    }), J(X(t), "renderSuggestionsOverlay", function() {
      if (!Tt(t.state.selectionStart))
        return null;
      var s = t.state.suggestionsPosition, a = s.position, l = s.left, u = s.top, m = s.right, f = /* @__PURE__ */ G.createElement(ps, {
        id: t.uuidSuggestionsOverlay,
        style: t.props.style("suggestions"),
        position: a,
        left: l,
        top: u,
        right: m,
        focusIndex: t.state.focusIndex,
        scrollFocusedIntoView: t.state.scrollFocusedIntoView,
        containerRef: t.setSuggestionsElement,
        suggestions: t.state.suggestions,
        customSuggestionsContainer: t.props.customSuggestionsContainer,
        onSelect: t.addMention,
        onMouseDown: t.handleSuggestionsMouseDown,
        onMouseEnter: t.handleSuggestionsMouseEnter,
        isLoading: t.isLoading(),
        isOpened: t.isOpened(),
        ignoreAccents: t.props.ignoreAccents,
        a11ySuggestionsListLabel: t.props.a11ySuggestionsListLabel
      }, t.props.children);
      return t.props.suggestionsPortalHost ? /* @__PURE__ */ Xn.createPortal(f, t.props.suggestionsPortalHost) : f;
    }), J(X(t), "renderHighlighter", function() {
      var s = t.state, a = s.selectionStart, l = s.selectionEnd, u = t.props, m = u.singleLine, f = u.children, E = u.value, w = u.style;
      return /* @__PURE__ */ G.createElement(ss, {
        containerRef: t.setHighlighterElement,
        style: w("highlighter"),
        value: E,
        singleLine: m,
        selectionStart: a,
        selectionEnd: l,
        onCaretPositionChange: t.handleCaretPositionChange
      }, f);
    }), J(X(t), "setHighlighterElement", function(s) {
      t.highlighterElement = s;
    }), J(X(t), "handleCaretPositionChange", function(s) {
      t.setState({
        caretPosition: s
      });
    }), J(X(t), "getPlainText", function() {
      return we(t.props.value || "", ve(t.props.children));
    }), J(X(t), "executeOnChange", function(s) {
      for (var a = arguments.length, l = new Array(a > 1 ? a - 1 : 0), u = 1; u < a; u++)
        l[u - 1] = arguments[u];
      if (t.props.onChange) {
        var m;
        return (m = t.props).onChange.apply(m, [s].concat(l));
      }
      if (t.props.valueLink) {
        var f;
        return (f = t.props.valueLink).requestChange.apply(f, [s.target.value].concat(l));
      }
    }), J(X(t), "handleChange", function(s) {
      if (He = !1, es()) {
        var a = document.activeElement && document.activeElement.contentDocument || document;
        if (a.activeElement !== s.target)
          return;
      }
      var l = t.props.value || "", u = ve(t.props.children), m = s.target.value, f = t.state.selectionStart;
      f == null && (f = s.target.selectionStart);
      var E = t.state.selectionEnd;
      E == null && (E = s.target.selectionEnd);
      var w = Ki(l, m, {
        selectionStartBefore: f,
        selectionEndBefore: E,
        selectionEndAfter: s.target.selectionEnd
      }, u);
      m = we(w, u);
      var y = s.target.selectionStart, D = s.target.selectionEnd, j = !1, P = _n(l, u, y);
      P !== void 0 && t.state.selectionEnd > P && (y = P + (s.nativeEvent.data ? s.nativeEvent.data.length : 0), D = y, j = !0), t.setState({
        selectionStart: y,
        selectionEnd: D,
        setSelectionAfterMentionChange: j
      });
      var N = Ne(w, u);
      s.nativeEvent.isComposing && y === D && t.updateMentionsQueries(t.inputElement.value, y);
      var M = {
        target: {
          value: w
        }
      };
      t.executeOnChange(M, w, m, N);
    }), J(X(t), "handleSelect", function(s) {
      if (t.setState({
        selectionStart: s.target.selectionStart,
        selectionEnd: s.target.selectionEnd
      }), !He) {
        var a = t.inputElement;
        s.target.selectionStart === s.target.selectionEnd ? t.updateMentionsQueries(a.value, s.target.selectionStart) : t.clearSuggestions(), t.updateHighlighterScroll(), t.props.onSelect(s);
      }
    }), J(X(t), "handleKeyDown", function(s) {
      var a = qe(t.state.suggestions);
      if (a === 0 || !t.suggestionsElement) {
        t.props.onKeyDown(s);
        return;
      }
      switch (Object.values(Oe).indexOf(s.keyCode) >= 0 && (s.preventDefault(), s.stopPropagation()), s.keyCode) {
        case Oe.ESC: {
          t.clearSuggestions();
          return;
        }
        case Oe.DOWN: {
          t.shiftFocus(1);
          return;
        }
        case Oe.UP: {
          t.shiftFocus(-1);
          return;
        }
        case Oe.RETURN: {
          t.selectFocused();
          return;
        }
        case Oe.TAB: {
          t.selectFocused();
          return;
        }
        default:
          return;
      }
    }), J(X(t), "shiftFocus", function(s) {
      var a = qe(t.state.suggestions);
      t.setState({
        focusIndex: (a + t.state.focusIndex + s) % a,
        scrollFocusedIntoView: !0
      });
    }), J(X(t), "selectFocused", function() {
      var s = t.state, a = s.suggestions, l = s.focusIndex, u = Object.values(a).reduce(function(E, w) {
        var y = w.results, D = w.queryInfo;
        return [].concat(Ge(E), Ge(y.map(function(j) {
          return {
            result: j,
            queryInfo: D
          };
        })));
      }, [])[l], m = u.result, f = u.queryInfo;
      t.addMention(m, f), t.setState({
        focusIndex: 0
      });
    }), J(X(t), "handleBlur", function(s) {
      var a = t._suggestionsMouseDown;
      t._suggestionsMouseDown = !1, a || t.setState({
        selectionStart: null,
        selectionEnd: null
      }), window.setTimeout(function() {
        t.updateHighlighterScroll();
      }, 1), t.props.onBlur(s, a);
    }), J(X(t), "handleSuggestionsMouseDown", function(s) {
      t._suggestionsMouseDown = !0;
    }), J(X(t), "handleSuggestionsMouseEnter", function(s) {
      t.setState({
        focusIndex: s,
        scrollFocusedIntoView: !1
      });
    }), J(X(t), "updateSuggestionsPosition", function() {
      var s = t.state.caretPosition, a = t.props, l = a.suggestionsPortalHost, u = a.allowSuggestionsAboveCursor, m = a.forceSuggestionsAboveCursor;
      if (!(!s || !t.suggestionsElement)) {
        var f = t.suggestionsElement, E = t.highlighterElement, w = E.getBoundingClientRect(), y = St(E, "font-size"), D = {
          left: w.left + s.left,
          top: w.top + s.top + y
        }, j = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (f) {
          var P = {};
          if (l) {
            P.position = "fixed";
            var N = D.left, M = D.top;
            N -= St(f, "margin-left"), M -= St(f, "margin-top"), N -= E.scrollLeft, M -= E.scrollTop;
            var b = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            N + f.offsetWidth > b ? P.left = Math.max(0, b - f.offsetWidth) : P.left = N, u && M + f.offsetHeight > j && f.offsetHeight < M - y || m ? P.top = Math.max(0, M - f.offsetHeight - y) : P.top = M;
          } else {
            var x = s.left - E.scrollLeft, C = s.top - E.scrollTop;
            x + f.offsetWidth > t.containerElement.offsetWidth ? P.right = 0 : P.left = x, u && D.top - E.scrollTop + f.offsetHeight > j && f.offsetHeight < w.top - y - E.scrollTop || m ? P.top = C - f.offsetHeight - y : P.top = C;
          }
          P.left === t.state.suggestionsPosition.left && P.top === t.state.suggestionsPosition.top && P.position === t.state.suggestionsPosition.position || t.setState({
            suggestionsPosition: P
          });
        }
      }
    }), J(X(t), "updateHighlighterScroll", function() {
      var s = t.inputElement, a = t.highlighterElement;
      !s || !a || (a.scrollLeft = s.scrollLeft, a.scrollTop = s.scrollTop, a.height = s.height);
    }), J(X(t), "handleCompositionStart", function() {
      He = !0;
    }), J(X(t), "handleCompositionEnd", function() {
      He = !1;
    }), J(X(t), "setSelection", function(s, a) {
      if (!(s === null || a === null)) {
        var l = t.inputElement;
        if (l.setSelectionRange)
          l.setSelectionRange(s, a);
        else if (l.createTextRange) {
          var u = l.createTextRange();
          u.collapse(!0), u.moveEnd("character", a), u.moveStart("character", s), u.select();
        }
      }
    }), J(X(t), "updateMentionsQueries", function(s, a) {
      t._queryId++, t.suggestions = {}, t.setState({
        suggestions: {}
      });
      var l = t.props.value || "", u = t.props.children, m = ve(u), f = ue(l, m, a, "NULL");
      if (f !== null) {
        var E = Yi(l.substring(0, f), m), w = s.substring(E, a);
        G.Children.forEach(u, function(y, D) {
          if (y) {
            var j = gs(y.props.trigger, t.props), P = w.match(j);
            if (P) {
              var N = E + w.indexOf(P[1], P.index);
              t.queryData(P[2], D, N, N + P[1].length, s);
            }
          }
        });
      }
    }), J(X(t), "clearSuggestions", function() {
      t._queryId++, t.suggestions = {}, t.setState({
        suggestions: {},
        focusIndex: 0
      });
    }), J(X(t), "queryData", function(s, a, l, u, m) {
      var f = t.props, E = f.children, w = f.ignoreAccents, y = xe.toArray(E)[a], D = ms(y.props.data, w), j = D(s, t.updateSuggestions.bind(null, t._queryId, a, s, l, u, m));
      j instanceof Array && t.updateSuggestions(t._queryId, a, s, l, u, m, j);
    }), J(X(t), "updateSuggestions", function(s, a, l, u, m, f, E) {
      if (s === t._queryId) {
        t.suggestions = he(he({}, t.suggestions), {}, J({}, a, {
          queryInfo: {
            childIndex: a,
            query: l,
            querySequenceStart: u,
            querySequenceEnd: m,
            plainTextValue: f
          },
          results: E
        }));
        var w = t.state.focusIndex, y = qe(t.suggestions);
        t.setState({
          suggestions: t.suggestions,
          focusIndex: w >= y ? Math.max(y - 1, 0) : w
        });
      }
    }), J(X(t), "addMention", function(s, a) {
      var l = s.id, u = s.display, m = a.childIndex, f = a.querySequenceStart, E = a.querySequenceEnd, w = a.plainTextValue, y = t.props.value || "", D = ve(t.props.children), j = xe.toArray(t.props.children)[m], P = j.props, N = P.markup, M = P.displayTransform, b = P.appendSpaceOnAdd, x = P.onAdd, C = ue(y, D, f, "START"), h = C + E - f, S = Xi(N, l, u);
      b && (S += " ");
      var g = Fe(y, C, h, S);
      t.inputElement.focus();
      var O = M(l, u);
      b && (O += " ");
      var v = f + O.length;
      t.setState({
        selectionStart: v,
        selectionEnd: v,
        setSelectionAfterMentionChange: !0
      });
      var A = {
        target: {
          value: g
        }
      }, d = Ne(g, D), c = Fe(w, f, E, O);
      t.executeOnChange(A, g, c, d), x && x(l, u, C, h), t.clearSuggestions();
    }), J(X(t), "isLoading", function() {
      var s = !1;
      return G.Children.forEach(t.props.children, function(a) {
        s = s || a && a.props.isLoading;
      }), s;
    }), J(X(t), "isOpened", function() {
      return Tt(t.state.selectionStart) && (qe(t.state.suggestions) !== 0 || t.isLoading());
    }), J(X(t), "_queryId", 0), t.suggestions = {}, t.uuidSuggestionsOverlay = Math.random().toString(16).substring(2), t.handleCopy = t.handleCopy.bind(X(t)), t.handleCut = t.handleCut.bind(X(t)), t.handlePaste = t.handlePaste.bind(X(t)), t.state = {
      focusIndex: 0,
      selectionStart: null,
      selectionEnd: null,
      suggestions: {},
      caretPosition: null,
      suggestionsPosition: {},
      setSelectionAfterHandlePaste: !1
    }, t;
  }
  return bi(r, [{
    key: "componentDidMount",
    value: function() {
      document.addEventListener("copy", this.handleCopy), document.addEventListener("cut", this.handleCut), document.addEventListener("paste", this.handlePaste), this.updateSuggestionsPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function(t, s) {
      s.suggestionsPosition === this.state.suggestionsPosition && this.updateSuggestionsPosition(), this.state.setSelectionAfterMentionChange && (this.setState({
        setSelectionAfterMentionChange: !1
      }), this.setSelection(this.state.selectionStart, this.state.selectionEnd)), this.state.setSelectionAfterHandlePaste && (this.setState({
        setSelectionAfterHandlePaste: !1
      }), this.setSelection(this.state.selectionStart, this.state.selectionEnd));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("copy", this.handleCopy), document.removeEventListener("cut", this.handleCut), document.removeEventListener("paste", this.handlePaste);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ G.createElement("div", pe({
        ref: this.setContainerElement
      }, this.props.style), this.renderControl(), this.renderSuggestionsOverlay());
    }
  }, {
    key: "handlePaste",
    value: function(t) {
      if (t.target === this.inputElement && this.supportsClipboardActions(t)) {
        t.preventDefault();
        var s = this.state, a = s.selectionStart, l = s.selectionEnd, u = this.props, m = u.value, f = u.children, E = ve(f), w = ue(m, E, a, "START"), y = ue(m, E, l, "END"), D = t.clipboardData.getData("text/react-mentions"), j = t.clipboardData.getData("text/plain"), P = Fe(m, w, y, D || j).replace(/\r/g, ""), N = we(P, E), M = {
          target: he(he({}, t.target), {}, {
            value: P
          })
        };
        this.executeOnChange(M, P, N, Ne(P, E));
        var b = _n(m, E, a), x = (b || a) + we(D || j, E).length;
        this.setState({
          selectionStart: x,
          selectionEnd: x,
          setSelectionAfterHandlePaste: !0
        });
      }
    }
  }, {
    key: "saveSelectionToClipboard",
    value: function(t) {
      var s = this.inputElement.selectionStart, a = this.inputElement.selectionEnd, l = this.props, u = l.children, m = l.value, f = ve(u), E = ue(m, f, s, "START"), w = ue(m, f, a, "END");
      t.clipboardData.setData("text/plain", t.target.value.slice(s, a)), t.clipboardData.setData("text/react-mentions", m.slice(E, w));
    }
  }, {
    key: "supportsClipboardActions",
    value: function(t) {
      return !!t.clipboardData;
    }
  }, {
    key: "handleCopy",
    value: function(t) {
      t.target === this.inputElement && this.supportsClipboardActions(t) && (t.preventDefault(), this.saveSelectionToClipboard(t));
    }
  }, {
    key: "handleCut",
    value: function(t) {
      if (t.target === this.inputElement && this.supportsClipboardActions(t)) {
        t.preventDefault(), this.saveSelectionToClipboard(t);
        var s = this.state, a = s.selectionStart, l = s.selectionEnd, u = this.props, m = u.children, f = u.value, E = ve(m), w = ue(f, E, a, "START"), y = ue(f, E, l, "END"), D = [f.slice(0, w), f.slice(y)].join(""), j = we(D, E), P = {
          target: he(he({}, t.target), {}, {
            value: j
          })
        };
        this.executeOnChange(P, D, j, Ne(f, E));
      }
    }
    // Handle input element's change event
  }]), r;
}(G.Component);
J(un, "propTypes", Nr);
J(un, "defaultProps", {
  ignoreAccents: !1,
  singleLine: !1,
  allowSuggestionsAboveCursor: !1,
  onKeyDown: function() {
    return null;
  },
  onSelect: function() {
    return null;
  },
  onBlur: function() {
    return null;
  }
});
var St = function(n, r) {
  var o = parseFloat(window.getComputedStyle(n, null).getPropertyValue(r));
  return isFinite(o) ? o : 0;
}, ys = typeof navigator < "u" && /iPhone|iPad|iPod/i.test(navigator.userAgent), bs = ut({
  position: "relative",
  overflowY: "visible",
  input: {
    display: "block",
    width: "100%",
    position: "absolute",
    margin: 0,
    top: 0,
    left: 0,
    boxSizing: "border-box",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    letterSpacing: "inherit"
  },
  "&multiLine": {
    input: he({
      height: "100%",
      bottom: 0,
      overflow: "hidden",
      resize: "none"
    }, ys ? {
      marginTop: 1,
      marginLeft: -3
    } : null)
  }
}, function(e) {
  var n = e.singleLine;
  return {
    "&singleLine": n,
    "&multiLine": !n
  };
}), vs = bs(un), xs = {
  fontWeight: "inherit"
}, cn = function(n) {
  var r = n.display, o = n.style, t = n.className, s = n.classNames, a = ln(xs, {
    style: o,
    className: t,
    classNames: s
  });
  return /* @__PURE__ */ G.createElement("strong", a, r);
};
cn.propTypes = {
  /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */
  onAdd: i.func,
  onRemove: i.func,
  renderSuggestion: i.func,
  trigger: i.oneOfType([i.string, i.instanceOf(RegExp)]),
  markup: i.string,
  displayTransform: i.func,
  /**
   * If set to `true` spaces will not interrupt matching suggestions
   */
  allowSpaceInQuery: i.bool,
  isLoading: i.bool
};
cn.defaultProps = {
  trigger: "@",
  markup: "@[__display__](__id__)",
  displayTransform: function(n, r) {
    return r || n;
  },
  onAdd: function() {
    return null;
  },
  onRemove: function() {
    return null;
  },
  renderSuggestion: null,
  isLoading: !1,
  appendSpaceOnAdd: !1
};
const Es = (e, n, r, o = "") => e.filter(
  (t) => t[n] && t[n].toLowerCase().includes(o.toLowerCase()) || t[r] && t[r].toLowerCase().includes(o.toLowerCase())
), ws = (e) => {
  const n = [];
  if (e.match(/(\/\/\~\[)/g)) {
    let r = 0, o = "", t = "", s = "", a = "";
    const l = e.match(/(\/\/\~\[)/g).length;
    if (l > 0)
      for (let u = 0; u < l; u += 1)
        o = e.indexOf("//~[", r) + 4, t = e.indexOf("](", o), s = e.indexOf("](", t) + 2, a = e.indexOf(")~//", s), n.push(e.slice(s, a)), r = a;
  }
  return n;
}, Un = (e, n, r) => {
  const o = document.getElementById(e);
  if (o) {
    if (n) {
      o.setAttribute("style", `height: ${r || "50px"}`);
      return;
    }
    o.setAttribute("style", `height: ${r || "50px"}`), o.setAttribute("style", `height: ${o.scrollHeight}px`);
  }
}, Cs = se.div.attrs({
  className: "mentionTaskAssignmentInput"
})`
  ${(e) => e.isBottomAligned ? `
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
        ` : ""};
  .textBoxContainer {
    display: flex;
    padding: 16px 24px;
    ${(e) => e.isEditEnabled ? "" : "box-shadow: 0 2px 8px 0 rgba(134, 139, 143, 0.3)"};
    flex-direction: column;
    flex-shrink: 0;
    ${(e) => e.isMobile && "background-color: #fff"}
  }

  .mentionInputContainer {
    position: relative;
    box-shadow: 0 1px 2px 0 rgba(9, 30, 66, 0.15), 0 0 1px 0 rgba(9, 30, 66, 0);
    border-radius: 4px;
    border: solid 1px #c8c9d1;

    &:hover {
      border-color: #adaeb5;
      box-shadow: 0 1px 3px 0 rgba(9, 30, 66, 0.25),
        0 0 1px 0 rgba(9, 30, 66, 0);
    }

    :focus-within {
      border-color: #2f53d7;
      box-shadow: 0 1px 3px 0 rgba(47, 83, 215, 0.25),
        0 0 1px 0 rgba(47, 83, 215, 0);
    }

    .commentTextArea__input {
      ${(e) => e.mentionInputFontSize ? `font-size: ${e.mentionInputFontSize}px` : "font-size: 14px"};
    }
  }
  .taskAssignmentOption {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 18px;
    img {
      cursor: pointer;
    }
    .userSelectionDropdown {
      cursor: pointer;
      padding-left: 4px;
    }
  }

  .helpText {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.43;
  }

  .actionButtonContainer {
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    float: right;

    .confirm {
      margin-left: 8px;
    }
  }

  .userDetail {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .userSelectionContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #c8c9d1;
    height: 24px;
    padding: 4px;
    border-radius: 2px;
  }

  .userSuggestions {
    ${(e) => e.isMobile ? "" : `
          min-width: 232px;
          width: max-content;
          z-index: 9;
          position: absolute;
          border-radius: 2px;
          width: max-content;
          background-color: #fff;
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1),
            0 32px 32px 0 rgba(134, 139, 143, 0.2);
          `};

    .dropdownHeader {
      padding: 10px 24px;
      font-size: 12px;
      font-weight: 500;
      color: #a2a5b1;
    }

    .singleUser {
      display: flex;
      flex-direction: row;
      align-items: center;
      ${(e) => e.isMobile ? "padding: 8px 0;" : "padding:8px 24px;"};
      cursor: pointer;
      .singleUserImage {
        margin-right: 8px;
      }

      &:hover {
        ${(e) => e.isMobile ? "" : "background-color: #eaebf0;"};
      }
    }
  }

  .mentions_list_item_container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .replySection {
    position: relative;
  }

  .closeIcon {
    position: absolute;
    right: 0;
    height: 20px;
    width: 20px;
    cursor: pointer;
  }

  .commentTextArea__highlighter {
    display: none !important;
  }
  .commentTextArea__input {
    display: flex !important;
    position: relative !important;
    box-sizing: border-box !important;
    width: 100% !important;
    ${(e) => e.isMobile ? "padding: 14px 16px;" : "padding: 16px !important"};
    resize: none !important;
    ${(e) => e.isMobile ? "" : "min-height: 100px !important"};
    max-height: 140px !important;
    border-radius: 4px !important;
    // border: solid 1px #a2a5b1;
    border: none;
    background-color: #fff !important;
    // box-shadow: 0 1px 2px 0 rgba(9, 30, 66, 0.15), 0 0 1px 0 rgba(9, 30, 66, 0);
    transition: border-color 0.2s ease-in;
    overflow-y: auto !important;
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .commentTextArea__suggestions__list {
    max-height: 320px !important;
    overflow: auto !important;
    padding: 12px 0px !important;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  }
  .commentTextArea__suggestions {
    margin-bottom: 100px !important;
    width: 100% !important;
    bottom: 0px !important;
    top: unset !important;
    ${(e) => e.isMobile ? "max-width: 100%;" : ""}
  }
  .commentTextArea__suggestions__item {
    display: flex;
    align-items: center;
    padding: 0px 12px !important;
    height: 12px !important;
  }
  .commentTextArea__suggestions__item--focused {
    background-color: #e5f1ff;
  }
`, Fr = (e) => {
  const {
    mentionContainerRef: n,
    functionToAddViewInsideTextBoxBottom: r,
    functionForViewAboveTextBox: o,
    functionForViewAboveButton: t,
    onMentionedUsersChange: s,
    initialValue: a,
    onValueChange: l,
    inputReference: u,
    allUsers: m,
    onCancelClick: f,
    onConfirmClick: E,
    inputPlaceholder: w,
    isButtonAlwaysVisible: y,
    value: D,
    additionalConditionToEnableConfirmButton: j
  } = e, [P, N] = Y(!1), [M, b] = Y(a || ""), x = Ce(null), C = (d) => {
    s(d);
  };
  Z(() => {
    b(D || "");
  }, [D]);
  const h = (d) => {
    const c = ws(D);
    if (c.length > 0) {
      const k = m.filter((R) => c.includes(R.id));
      C(k);
    }
    l(d), D.length > 0 && N(!0);
  };
  Z(() => {
    M.length > 0 && h(M);
  }, []);
  const S = (d) => {
    const c = d.target.value;
    h(c), l && l(c), Un("mentionInput", !1, "100px");
  }, g = () => {
    N(!1), l(""), f && f(), Un("mentionInput", !0);
  }, O = () => {
    N(!1), l("");
  }, v = (d) => {
    if (d.toString().trim().length === 0) {
      l("");
      return;
    }
    E(d, O);
  }, A = () => e.isEditEnabled ? (M.trim() === e.initialValue || M.trim().length === 0) && !(j && j()) : (!M || M.trim().length === 0) && !(j && j());
  return Z(() => {
    e.onHeightChange && e.onHeightChange();
  }, [x.current && x.current.clientHeight]), /* @__PURE__ */ p.jsx(
    Cs,
    {
      isEditEnabled: e.isEditEnabled,
      ref: n || null,
      children: /* @__PURE__ */ p.jsxs("div", { className: "textBoxContainer", ref: x, children: [
        o && o(),
        /* @__PURE__ */ p.jsxs("div", { className: "mentionInputContainer", children: [
          /* @__PURE__ */ p.jsx(
            vs,
            {
              className: "commentTextArea",
              id: "mentionInput",
              inputRef: u,
              onChange: (d) => S(d),
              placeholder: w,
              value: M,
              children: /* @__PURE__ */ p.jsx(
                cn,
                {
                  appendSpaceOnAdd: !0,
                  data: (d, c) => {
                    const k = Es(
                      m,
                      "display",
                      "email",
                      d
                    );
                    c(k);
                  },
                  displayTransform: (d, c) => `@${c}`,
                  markup: "//~[__display__](__id__)~//",
                  renderSuggestion: (d, c, k) => /* @__PURE__ */ p.jsxs("div", { className: "mentions_list_item_container", children: [
                    /* @__PURE__ */ p.jsx(
                      ke,
                      {
                        name: d.name,
                        size: "M",
                        src: d.image
                      }
                    ),
                    /* @__PURE__ */ p.jsxs("div", { className: "mentions_list_item", children: [
                      k,
                      /* @__PURE__ */ p.jsx("div", { className: "mentions_list_item_email", children: d.email })
                    ] })
                  ] }),
                  trigger: "@"
                }
              )
            }
          ),
          r && r()
        ] }),
        (P || y) && /* @__PURE__ */ p.jsxs("div", { children: [
          t && t(),
          /* @__PURE__ */ p.jsxs("div", { className: "actionButtonContainer", children: [
            /* @__PURE__ */ p.jsx("div", { className: "Cancel", children: /* @__PURE__ */ p.jsx(Pt, { color: "basic", onClick: () => g(), children: "Cancel" }) }),
            /* @__PURE__ */ p.jsx("div", { className: "confirm", children: /* @__PURE__ */ p.jsx(
              Pt,
              {
                color: "primary",
                disabled: A(),
                onClick: () => v(M),
                children: e.confirmButtonText ? e.confirmButtonText : "Save"
              }
            ) })
          ] })
        ] })
      ] })
    }
  );
};
Fr.defaultProps = {
  functionToAddViewInsideTextBoxBottom: () => {
  },
  functionForViewAboveTextBox: () => {
  },
  functionForViewAboveButton: () => {
  },
  onMentionedUsersChange: () => {
  },
  initialValue: "string",
  onValueChange: () => {
  },
  // mentionContainerRef: { current: '12' },
  // inputReference: { current: '12' },
  confirmButtonText: "consfirm",
  onHeightChange: () => {
  },
  isEditEnabled: !1,
  onConfirmClick: () => {
  },
  onCancelClick: () => {
  },
  inputPlaceholder: "Enter a value",
  isButtonAlwaysVisible: !1,
  additionalConditionToEnableConfirmButton: null
};
Fr.propTypes = {
  /**
   *function returns a view which will be rendered at the bottom inside of the textbox
   */
  functionToAddViewInsideTextBoxBottom: i.func,
  /**
   *function returns a view which will be rendered on the outside of the textbox
   */
  functionForViewAboveTextBox: i.func,
  /**
   *function returns a view which will be rendered just above the buttons
   */
  functionForViewAboveButton: i.func,
  /**
   *function to execute when the mentions users changes
   */
  onMentionedUsersChange: i.func,
  /**
   * initial text value of the textbox
   */
  initialValue: i.string,
  /**
   *function to execute when the value changes
   */
  onValueChange: i.func,
  /**
   * container ref for the mentions input
   */
  mentionContainerRef: i.shape({
    current: i.any
  }).isRequired,
  /**
   * ref for the mentions input
   */
  inputReference: i.shape({
    current: i.any
  }).isRequired,
  /**
   * all users array
   */
  allUsers: i.arrayOf(
    i.shape({
      id: i.string.isRequired,
      name: i.string.isRequired,
      display: i.string.isRequired,
      email: i.string.isRequired,
      image: i.string
    })
  ).isRequired,
  /**
   * function to execute on cancel click
   */
  onCancelClick: i.func,
  /**
   * function to execute on cancel click
   */
  onConfirmClick: i.func,
  /**
   * Is the view in Edit mode and has an initial value
   */
  isEditEnabled: i.bool,
  /**
   * function to execute on text box height change
   */
  onHeightChange: i.func,
  /**
   * confirm button alternate text
   */
  confirmButtonText: i.string,
  /**
   * confirm button alternate text
   */
  inputPlaceholder: i.string,
  /**
   * should button be visible always
   */
  isButtonAlwaysVisible: i.bool,
  /**
   * new value for component
   */
  value: i.string.isRequired,
  /**
   * any additional condition that needs to be checked to enable submit button (OR condition)
   */
  additionalConditionToEnableConfirmButton: i.func
};
const ct = G.createContext({}), dn = De(({ children: e, maxHeight: n, ...r }) => {
  const { isExpandable: o, isOpen: t, borderColor: s } = Ze(ct);
  return o ? /* @__PURE__ */ p.jsx(
    W,
    {
      borderTop: "1px solid",
      borderTopColor: t ? s || "#202124" : "transparent",
      fontSize: 14,
      lineHeight: "1.6",
      maxHeight: t ? n : "0px",
      overflow: "hidden",
      px: 10,
      py: t ? 8 : 0,
      transition: "max-height 0.3s ease, border 0.4s ease, padding 0.4s ease",
      ...r,
      children: e
    }
  ) : null;
});
dn.displayName = "AccordionBody";
dn.propTypes = {
  /**
   * children can be text or React element
   */
  children: i.oneOfType([i.string, i.node]).isRequired,
  /**
   * maxHeight of Accordion body
   */
  maxHeight: i.string
};
dn.defaultProps = {
  maxHeight: "100vh"
};
const Ir = De(({ children: e }) => {
  const {
    isExpandable: n,
    isOpen: r,
    toggleIconColor: o,
    collapseIcon: t,
    expandIcon: s,
    toggle: a
  } = Ze(ct);
  return /* @__PURE__ */ p.jsxs(
    W,
    {
      alignItems: "center",
      boxSizing: "border-box",
      cursor: n ? "pointer" : "default",
      d: "flex",
      fontSize: 14,
      fontWeight: 500,
      justifyContent: "space-between",
      minHeight: 40,
      onClick: n ? a : null,
      px: 10,
      py: 4,
      children: [
        /* @__PURE__ */ p.jsx(W, { flex: "1", children: e }),
        n && /* @__PURE__ */ p.jsx(
          fe,
          {
            color: o,
            focusable: "false",
            icon: r ? t : s,
            ml: "10px",
            size: "24px"
          }
        )
      ]
    }
  );
});
Ir.displayName = "AccordionTitle";
Ir.propTypes = {
  /**
   * children can be text or React element
   */
  children: i.oneOfType([i.string, i.node]).isRequired
};
const pn = De(({ color: e, children: n, ...r }) => {
  const { isOpen: o } = Ze(ct);
  return o ? /* @__PURE__ */ p.jsx(ie, { color: e, my: 4, type: "label", ...r, children: n }) : null;
});
pn.displayName = "AccordionNote";
pn.propTypes = {
  /**
   * Text for note. Required.
   */
  children: i.string.isRequired,
  /**
   * Set color of the note. Default `grey.10`
   */
  color: i.bool
};
pn.defaultProps = {
  color: "grey.10"
};
const dt = ({
  isOpen: e,
  toggle: n,
  toggleIconColor: r,
  collapseIcon: o,
  expandIcon: t,
  isExpandable: s,
  borderColor: a,
  children: l,
  ...u
}) => {
  const [m, f, E] = G.Children.toArray(l), w = Ft(
    () => ({
      isOpen: e,
      isExpandable: s,
      toggleIconColor: r,
      collapseIcon: o,
      expandIcon: t,
      borderColor: a,
      toggle: n
    }),
    [
      e,
      s,
      r,
      o,
      t,
      a,
      n
    ]
  );
  return /* @__PURE__ */ p.jsxs(ct.Provider, { value: w, children: [
    /* @__PURE__ */ p.jsxs(
      W,
      {
        border: "1px solid",
        borderColor: a || "#202124",
        borderRadius: "4px",
        mt: 10,
        w: "100%",
        ...u,
        children: [
          m,
          f
        ]
      }
    ),
    E
  ] });
};
dt.displayName = "Accordion";
dt.propTypes = {
  /**
   * Color code for borders. Default `#202124`
   */
  borderColor: i.string,
  /**
   * Children of accordion would be Accordion Title and Accordion Body
   */
  children: i.node.isRequired,
  /**
   * Icon from `IconLib` to collapse the accordion. Default `caretUp`
   */
  collapseIcon: i.shape({ render: i.func }),
  /**
   * Icon from `IconLib` to expand the accordion. Default `caretDown`
   */
  expandIcon: i.shape({ render: i.func }),
  /**
   * Set `false` if accordion can't be expanded. Default `true`
   */
  isExpandable: i.bool,
  /**
   * Set `true` is accordion is in expanded state. Default `false`
   */
  isOpen: i.bool,
  /**
   * onClick handler for toggling accordion.
   */
  toggle: i.func,
  /**
   * Color code for toggle icon. Default `#202124`
   */
  toggleIconColor: i.string
};
dt.defaultProps = {
  borderColor: "#202124",
  collapseIcon: Qn,
  expandIcon: Zn,
  isExpandable: !0,
  isOpen: !1,
  toggle: () => {
  },
  toggleIconColor: "#202124"
};
const Ns = De(dt), Fs = nr.ModalProvider;
export {
  Ns as Accordion,
  dn as AccordionBody,
  pn as AccordionNote,
  Ir as AccordionTitle,
  ke as Avatar,
  Bt as AvatarGroup,
  W as Box,
  _t as Breadcrumb,
  Rt as BreadcrumbItem,
  Ks as BulkSelector,
  no as Checkbox,
  Ys as CloseButton,
  qt as ContentSelection,
  $t as ContentSelectionItem,
  Ts as Core,
  mr as DateRangePicker,
  Ls as DateTimePicker,
  fr as DiscreteProgress,
  en as DropDown,
  tt as DropdownButton,
  vr as EmojiPalette,
  $s as FormControl,
  Vt as FormErrorMessage,
  qs as FormLabel,
  it as Hierarchy,
  fe as Icon,
  Hs as IconButton,
  Rs as IconLib,
  Re as Image,
  Us as Input,
  et as Link,
  Fr as MentionsInputField,
  Gs as Modal,
  Js as ModalBody,
  Xs as ModalFooter,
  Fs as ModalProvider,
  hr as PageSpinner,
  _e as Portal,
  zt as Progress,
  Vn as PseudoBox,
  sn as RepliesAccordion,
  Pt as SimpleButton,
  Yt as SimpleMenuView,
  Gt as SimpleMenuViewRow,
  Ot as Spinner,
  on as StatusBar,
  Xt as Stepper,
  As as StyledReactModal,
  Qt as Tag,
  ie as Text,
  Ws as TextArea,
  tn as TextBox,
  nt as TextButton,
  zs as ThemeProvider,
  nn as ToggleSwitch,
  Kt as TrendLine,
  rn as UnitPicker,
  Lt as UserChipInput,
  Kr as createGlobalStyle,
  gn as defaultTheme,
  Yn as keyframes,
  se as styled,
  Vr as useTheme
};
